var external_file_cities = [
  "Andorra La Vella, Andorra (ALV)",
  "Al Ain, Emiratos Arabes (AAN)",
  "Abu Dhabi, Emiratos Arabes (AUH)",
  "Dubai, Emiratos Arabes (DXB)",
  "Al Fujairah, Emiratos Arabes (FJR)",
  "Ras Al Khaimah, Emiratos Arabes (RKT)",
  "Sharjah, Emiratos Arabes (SHJ)",
  "Antigua, Antigua y Barbuda (ANU)",
  "Anguilla, Anguilla (AXA)",
  "Tirana, Albania (TIA)",
  "Erevan, Armenia (EVN)",
  "St Eustatius, Antillas Holandesas (EUX)",
  "Curaçao, Antillas Holandesas (CUR)",
  "Bonaire, Antillas Holandesas (BON)",
  "St. Maarten, Antillas Holandesas (SXM)",
  "Saba Island, Antillas Holandesas (SAB)",
  "Luanda, Angola (LAD)",
  "Pago Pago, Samoa Americana (PPG)",
  "Linz, Austria (LNZ)",
  "Innsbruck, Austria (INN)",
  "Klagenfurt, Austria (KLU)",
  "Graz, Austria (GRZ)",
  "Salzburgo, Austria (SZG)",
  "Viena, Austria (VIE)",
  "Warwick, Australia (WAZ)",
  "Weipa, Australia (WEI)",
  "Wee Waa, Australia (WEW)",
  "Wagga Wagga, Australia (WGA)",
  "Walgett, Australia (WGE)",
  "Wangaratta, Australia (WGT)",
  "Welshpool, Australia (WHL)",
  "Warrnambool, Australia (WMB)",
  "Windorah, Australia (WNR)",
  "Wollongong, Australia (WOL)",
  "Airlie Beach, Australia (WSY)",
  "Whyalla, Australia (WYA)",
  "Wyndham, Australia (WYN)",
  "Colac, Australia (XCO)",
  "Yandicoogina, Australia (YNN)",
  "Biloela, Australia (ZBL)",
  "Newman, Australia (ZNE)",
  "Sydney, Australia (SYD)",
  "Swan Hill, Australia (SWH)",
  "Sale, Australia (SXE)",
  "Tennant Creek, Australia (TCA)",
  "Tocumwal, Australia (TCW)",
  "Traralgon, Australia (TGN)",
  "Thursday Island, Australia (TIS)",
  "Thangool, Australia (THG)",
  "Tamworth, Australia (TMW)",
  "Tom Price, Australia (TPR)",
  "Taree, Australia (TRO)",
  "Townsville, Australia (TSV)",
  "Toowoomba, Australia (TWB)",
  "Queenstown, Australia (UEE)",
  "Quirindi, Australia (UIR)",
  "Quilpie, Australia (ULP)",
  "Useless Loop, Australia (USL)",
  "Rottnest, Australia (RTS)",
  "Roma, Australia (RMA)",
  "Renmark, Australia (RMK)",
  "Rockhampton, Australia (ROK)",
  "St George, Australia (SGO)",
  "Shepparton, Australia (SHT)",
  "Singleton, Australia (SIX)",
  "Stanthorpe, Australia (SNH)",
  "South Molle, Australia (SOI)",
  "Strahan, Australia (SRN)",
  "Lock, Australia (LOC)",
  "Gove, Australia (GOV)",
  "Goondiwindi, Australia (GOO)",
  "Geelong, Australia (GEX)",
  "Griffith, Australia (GFF)",
  "Grafton, Australia (GFN)",
  "Glen Innes, Australia (GLI)",
  "Gladstone, Australia (GLT)",
  "Forster, Australia (FOT)",
  "Geraldton, Australia (GET)",
  "Gunnedah, Australia (GUH)",
  "Gympie, Australia (GYP)",
  "Long Island, Australia (HAP)",
  "Hobart, Australia (HBA)",
  "Horn Island, Australia (HID)",
  "Hayman Island, Australia (HIS)",
  "St Helens, Australia (HLS)",
  "Hamilton Island, Australia (HTI)",
  "Cudal, Australia (CUG)",
  "Charleville, Australia (CTL)",
  "Casino, Australia (CSI)",
  "Carnarvon, Australia (CVQ)",
  "Cowra, Australia (CWT)",
  "Dubbo, Australia (DBO)",
  "Dalby, Australia (DBY)",
  "Daydream Island, Australia (DDI)",
  "Mudgee, Australia (DGE)",
  "Dunk Island, Australia (DKI)",
  "Deniliquin, Australia (DNQ)",
  "Dongara, Australia (DOX)",
  "Devonport, Australia (DPO)",
  "Derby, Australia (DRB)",
  "Darwin, Australia (DRW)",
  "Exmouth Gulf, Australia (EXM)",
  "Esperance, Australia (EPR)",
  "Echuca, Australia (ECH)",
  "Emerald, Australia (EMD)",
  "Borroloola, Australia (BOX)",
  "Busselton, Australia (BQB)",
  "Bourke, Australia (BRK)",
  "Bathurst Isl, Australia (BRT)",
  "Blackwater, Australia (BLT)",
  "Broome, Australia (BME)",
  "Brisbane, Australia (BNE)",
  "Ballina, Australia (BNK)",
  "Bairnsdale, Australia (BSJ)",
  "Bunbury, Australia (BUY)",
  "Brewarrina, Australia (BWQ)",
  "Burnie, Australia (BWT)",
  "Bankstown, Australia (BWU)",
  "Cobar, Australia (CAZ)",
  "Camberra, Australia (CBR)",
  "Cooinda, Australia (CDA)",
  "Ceduna, Australia (CED)",
  "Cessnock, Australia (CES)",
  "Coffs Harbour, Australia (CFS)",
  "Clermont, Australia (CMQ)",
  "Coonamble, Australia (CNB)",
  "Cloncurry, Australia (CNJ)",
  "Cairns, Australia (CNS)",
  "Coonabarabrn, Australia (COJ)",
  "Coober Pedy, Australia (CPD)",
  "Avalon, Australia (AVV)",
  "Ayers Rock, Australia (AYQ)",
  "Ayr Au, Australia (AYR)",
  "Armidale, Australia (ARM)",
  "Alice Springs, Australia (ASP)",
  "Bundaberg, Australia (BDB)",
  "Broken Hill, Australia (BHQ)",
  "Bathurst, Australia (BHS)",
  "Albany, Australia (ALH)",
  "Bamaga, Australia (ABM)",
  "Albury, Australia (ABX)",
  "Adelaida, Australia (ADL)",
  "Kings Canyon, Australia (KBJ)",
  "Collinsville, Australia (KCE)",
  "Kingscote, Australia (KGC)",
  "Kalgoorlie, Australia (KGI)",
  "King Island, Australia (KNS)",
  "Kununurra, Australia (KNX)",
  "Kempsey, Australia (KPS)",
  "Karratha, Australia (KTA)",
  "Katherine, Australia (KTR)",
  "Hervey Bay, Australia (HVB)",
  "Mount Isa, Australia (ISA)",
  "Inverell, Australia (IVR)",
  "Jabiru, Australia (JAB)",
  "Fremantle, Australia (JFM)",
  "Shute Hrb, Australia (JHQ)",
  "Leonora, Australia (LNO)",
  "Longreach, Australia (LRE)",
  "Launceston, Australia (LST)",
  "Lismore, Australia (LSY)",
  "Lord Howe Island, Australia (LDH)",
  "Learmonth, Australia (LEA)",
  "Leinster, Australia (LER)",
  "Lightning Ridge, Australia (LHG)",
  "Laverton, Australia (LVO)",
  "Maryborough, Australia (MBH)",
  "Moorabbin, Australia (MBW)",
  "Maroochydore, Australia (MCY)",
  "Melbourne, Australia (MEL)",
  "Mt Gambier, Australia (MGB)",
  "Margaret River Station, Australia (MGV)",
  "Mount Hotham, Australia (MHU)",
  "Merimbula, Australia (MIM)",
  "Meekathara, Australia (MKR)",
  "Mackay, Australia (MKY)",
  "Port Pirie, Australia (PPI)",
  "Proserpine, Australia (PPP)",
  "Parkes, Australia (PKE)",
  "Port Lincoln, Australia (PLO)",
  "Paraburdoo, Australia (PBO)",
  "Perth, Australia (PER)",
  "Port Hedland, Australia (PHE)",
  "Pt Macquarie, Australia (PQQ)",
  "Port Douglas, Australia (PTI)",
  "Portland, Australia (PTJ)",
  "Port Augusta, Australia (PUG)",
  "Leeton, Australia (QLE)",
  "Mount Magnet, Australia (MMG)",
  "Middlemount, Australia (MMM)",
  "Monto, Australia (MNQ)",
  "Mildura, Australia (MQL)",
  "Margaret River, Australia (MQZ)",
  "Moree, Australia (MRZ)",
  "Maitland, Australia (MTL)",
  "Moruya, Australia (MYA)",
  "Narrabri, Australia (NAA)",
  "Young, Australia (NGA)",
  "Norfolk Island, Australia (NLK)",
  "Nowra, Australia (NOA)",
  "Narrandera, Australia (NRA)",
  "Noosa, Australia (NSA)",
  "Norseman, Australia (NSM)",
  "Scone, Australia (NSO)",
  "Newcastle, Australia (NTL)",
  "Nullarbor, Australia (NUR)",
  "Nyngan, Australia (NYN)",
  "Orange, Australia (OAG)",
  "Olympic Dam, Australia (OLP)",
  "Gold Coast, Australia (OOL)",
  "Cooma, Australia (OOM)",
  "Orpheus Island, Australia (ORS)",
  "Baku, Azerbaijan (BAK)",
  "Banja Luka, Bosnia Herzegovina (BNX)",
  "Mostar, Bosnia Herzegovina (OMO)",
  "Sarajevo, Bosnia Herzegovina (SJJ)",
  "Tuzla, Bosnia Herzegovina (TZL)",
  "Barbados, Barbados (BGI)",
  "Chittagong, Bangladesh (CGP)",
  "Dhaka, Bangladesh (DAC)",
  "Sylhet, Bangladesh (ZYL)",
  "Leuven, Belgium (ZGK)",
  "Bruselas, Belgium (BRU)",
  "Antwerp, Belgium (ANR)",
  "Brujas, Belgium (OST)",
  "Liege, Belgium (LGG)",
  "Kortrijk, Belgium (KJK)",
  "Ouagadougou, Burkina Faso (OUA)",
  "Bourgas, Bulgaria (BOJ)",
  "Varna, Bulgaria (VAR)",
  "Sofia, Bulgaria (SOF)",
  "Bahrain, Bahrain (BAH)",
  "Bujumbura, Burundi (BJM)",
  "Cotonou, Benin (COO)",
  "Bermuda, Bermuda (BDA)",
  "Bandar Seri, Brunei (BWN)",
  "Kuala Belait, Brunei (KUB)",
  "La Paz, Bolivia (LPB)",
  "San Matias, Bolivia (MQK)",
  "Puerto Suarez, Bolivia (PSZ)",
  "Camiri, Bolivia (CAM)",
  "Cochabamba, Bolivia (CBB)",
  "Sucre, Bolivia (SRE)",
  "Santa Cruz De La Sierra, Bolivia (SRZ)",
  "Tarija, Bolivia (TJA)",
  "Trinidad, Bolivia (TDD)",
  "Monteagudo, Bolivia (MHW)",
  "Oruro, Bolivia (ORU)",
  "Chimore, Bolivia (CCA)",
  "Cobija, Bolivia (CIJ)",
  "Guayaramerin, Bolivia (GYA)",
  "Potosí, Bolivia (POI)",
  "Uyuni, Bolivia (UYU)",
  "Rurrenabaque, Bolivia (RBQ)",
  "San Ignacio de Velasco, Bolivia (SNG)",
  "Yacuiba, Bolivia (BYC)",
  "Riberalta, Bolivia (RIB)",
  "CALDAS NOVAS, Brasil (CLV)",
  "Praia de Cumbuco, Brasil (BR1)",
  "Arraial d'Ajuda, Brasil (BR2)",
  "Trancoso, Brasil (BR3)",
  "Barra da Tijuca, Brasil (BR4)",
  "Copacabana, Brasil (BR5)",
  "Ipanema, Brasil (BR6)",
  "Praia do Forte, Brasil (BR7)",
  "Imbassaí, Brasil (BR8)",
  "Guarujá, Brasil (BR9)",
  "Puerto Iguazú, Brasil (IUF)",
  "Gramado, Brasil (GM1)",
  "Canela, Brasil (BR_7530)",
  "Aparecida, Brasil (BR_4857)",
  "Aparecida, Brasil (BR_8896)",
  "Aquiraz, Brasil (BR_1156)",
  "CMNET, Brasil (FSG)",
  "Santo Antônio de Jesus, Brasil (BR_1006)",
  "Jequiá da Praia, Brasil (BR_10089)",
  "Teixeira de Freitas, Brasil (BR_1078)",
  "Vereda, Brasil (BR_1114)",
  "Marechal Deodoro, Brasil (BR_114)",
  "Amontada, Brasil (BR_1145)",
  "Aracati, Brasil (BR_1158)",
  "Barbalha, Brasil (BR_1190)",
  "Beberibe, Brasil (BR_1208)",
  "Boa Viagem, Brasil (BR_1218)",
  "Camocim, Brasil (BR_1247)",
  "Caucaia, Brasil (BR_1284)",
  "Cruz, Brasil (BR_1308)",
  "Barra de São Miguel, Brasil (BR_37)",
  "Fortim, Brasil (BR_1348)",
  "Barra de São Miguel, Brasil (BR_4874)",
  "Paripueira, Brasil (BR_138)",
  "Jijoca de Jericoacoara, Brasil (BR_1443)",
  "Barueri, Brasil (BR_8956)",
  "Maracanaú, Brasil (BR_1486)",
  "Belém, Brasil (BR_42)",
  "Belém, Brasil (BR_4877)",
  "Paracuru, Brasil (BR_1577)",
  "São Miguel dos Milagres, Brasil (BR_171)",
  "Sobral, Brasil (BR_1722)",
  "Trairi, Brasil (BR_1746)",
  "Aracruz, Brasil (BR_1816)",
  "Boa Vista, Brasil (BR_4881)",
  "Cariacica, Brasil (BR_1844)",
  "Colatina, Brasil (BR_1847)",
  "Conceição da Barra, Brasil (BR_1848)",
  "Domingos Martins, Brasil (BR_1861)",
  "Guarapari, Brasil (BR_1879)",
  "Linhares, Brasil (BR_1925)",
  "Autazes, Brasil (BR_200)",
  "Serra, Brasil (BR_2028)",
  "Venda Nova do Imigrante, Brasil (BR_2037)",
  "Alto Paraíso de Goiás, Brasil (BR_2060)",
  "Aparecida de Goiânia, Brasil (BR_2069)",
  "Buriti Alegre, Brasil (BR_2096)",
  "Catalão, Brasil (BR_2125)",
  "Itumbiara, Brasil (BR_2204)",
  "Jataí, Brasil (BR_2209)",
  "Mineiros, Brasil (BR_2234)",
  "Pirenópolis, Brasil (BR_2282)",
  "Rio Verde, Brasil (BR_2298)",
  "Bonito, Brasil (BR_4132)",
  "Bonito, Brasil (BR_432)",
  "Iranduba, Brasil (BR_232)",
  "Bonito, Brasil (BR_4577)",
  "Itacoatiara, Brasil (BR_233)",
  "Bonito, Brasil (BR_5182)",
  "Balsas, Brasil (BR_2395)",
  "Barreirinhas, Brasil (BR_2399)",
  "São José de Ribamar, Brasil (BR_2585)",
  "Rio Preto da Eva, Brasil (BR_261)",
  "Campo Grande, Brasil (BR_58)",
  "Alfenas, Brasil (BR_2651)",
  "Campo Grande, Brasil (BR_7149)",
  "Araguari, Brasil (BR_2695)",
  "Araxá, Brasil (BR_2704)",
  "Barão de Cocais, Brasil (BR_2733)",
  "Betim, Brasil (BR_2762)",
  "Campos do Jordão, Brasil (B05)",
  "Caeté, Brasil (BR_2834)",
  "Camanducaia, Brasil (BR_2842)",
  "Caxambu, Brasil (BR_2918)",
  "Confins, Brasil (BR_2971)",
  "Conselheiro Lafaiete, Brasil (BR_2976)",
  "Contagem, Brasil (BR_2980)",
  "Coronel Fabriciano, Brasil (BR_2990)",
  "Arapiraca, Brasil (BR_30)",
  "Diamantina, Brasil (BR_3036)",
  "Divinópolis, Brasil (BR_3047)",
  "Extrema, Brasil (BR_3104)",
  "Formiga, Brasil (BR_3128)",
  "Gonçalves, Brasil (BR_3164)",
  "Itabira, Brasil (BR_3234)",
  "Itabirito, Brasil (BR_3236)",
  "Itajubá, Brasil (BR_3245)",
  "Ituiutaba, Brasil (BR_3275)",
  "Iturama, Brasil (BR_3277)",
  "Jaboticatubas, Brasil (BR_3279)",
  "Lagoa da Prata, Brasil (BR_3327)",
  "Lambari, Brasil (BR_3334)",
  "Luz, Brasil (BR_3360)",
  "Cascavel, Brasil (BR_1278)",
  "Alagoinhas, Brasil (BR_342)",
  "Muriaé, Brasil (BR_3460)",
  "Nova Lima, Brasil (BR_3480)",
  "Nova Serrana, Brasil (BR_3486)",
  "Cedral, Brasil (BR_2431)",
  "Pará de Minas, Brasil (BR_3531)",
  "Paracatu, Brasil (BR_3532)",
  "Passos, Brasil (BR_3547)",
  "Patos de Minas, Brasil (BR_3549)",
  "Pouso Alegre, Brasil (BR_3654)",
  "Sabará, Brasil (BR_3724)",
  "Sacramento, Brasil (BR_3726)",
  "São João Del Rei, Brasil (BR_3857)",
  "São José da Lapa, Brasil (BR_3872)",
  "Conde, Brasil (BR_4921)",
  "São Lourenço, Brasil (BR_3892)",
  "Sete Lagoas, Brasil (BR_3986)",
  "Conde, Brasil (BR_537)",
  "Teófilo Otoni, Brasil (BR_4017)",
  "Timóteo, Brasil (BR_4019)",
  "Tiradentes, Brasil (BR_4020)",
  "Três Pontas, Brasil (BR_4035)",
  "Ubá, Brasil (BR_4043)",
  "Barro Preto, Brasil (BR_405)",
  "Vespasiano, Brasil (BR_4081)",
  "Virgínia, Brasil (BR_4091)",
  "Entre Rios, Brasil (BR_575)",
  "Dourados, Brasil (BR_4163)",
  "Maracaju, Brasil (BR_4197)",
  "Três Lagoas, Brasil (BR_4263)",
  "Barra do Garças, Brasil (BR_4300)",
  "Chapada dos Guimarães, Brasil (BR_4331)",
  "Lucas do Rio Verde, Brasil (BR_4389)",
  "Nova Mutum, Brasil (BR_4416)",
  "Poconé, Brasil (BR_4437)",
  "Primavera do Leste, Brasil (BR_4451)",
  "Franca, Brasil (BR_9144)",
  "Santo Antônio do Leverger, Brasil (BR_4473)",
  "Sinop, Brasil (BR_4493)",
  "Sorriso, Brasil (BR_4495)",
  "Tangará da Serra, Brasil (BR_4498)",
  "Ananindeua, Brasil (BR_4539)",
  "Guaíra, Brasil (BR_6115)",
  "Cairu, Brasil (BR_465)",
  "Guaíra, Brasil (BR_9162)",
  "Camacan, Brasil (BR_472)",
  "Paragominas, Brasil (BR_4728)",
  "Camaçari, Brasil (BR_473)",
  "Parauapebas, Brasil (BR_4730)",
  "Camamu, Brasil (BR_474)",
  "Salinópolis, Brasil (BR_4762)",
  "Guarujá, Brasil (BR_9182)",
  "Bananeiras, Brasil (BR_4870)",
  "Ilhabela, Brasil (BR_9214)",
  "Patos, Brasil (BR_5017)",
  "Itacaré, Brasil (BR_684)",
  "Itajaí, Brasil (BR_8507)",
  "Jandaíra, Brasil (BR_745)",
  "Cabo de Santo Agostinho, Brasil (BR_5189)",
  "Jaraguá do Sul, Brasil (B11)|E",
  "Garanhuns, Brasil (BR_5259)",
  "Gravatá, Brasil (BR_5264)",
  "Ipojuca, Brasil (BR_5285)",
  "Ilha de Itamaracá, Brasil (BR_5293)",
  "Jaboatão dos Guararapes, Brasil (BR_5302)",
  "Lagoa Santa, Brasil (BR_2347)",
  "Lagoa Santa, Brasil (BR_3332)",
  "Lajeado, Brasil (BR_7823)",
  "Lajeado, Brasil (BR_9874)",
  "Tamandaré, Brasil (BR_5467)",
  "Mogi das Cruzes, Brasil (BR_9369)",
  "Antonina, Brasil (BR_5774)",
  "Apucarana, Brasil (BR_5780)",
  "Arapongas, Brasil (BR_5783)",
  "Araucária, Brasil (BR_5789)",
  "Eunápolis, Brasil (BR_579)",
  "Ariranha do Ivaí, Brasil (BR_5793)",
  "Feira de Santana, Brasil (BR_582)",
  "Cambará, Brasil (BR_5894)",
  "Campina Grande do Sul, Brasil (BR_5906)",
  "Campo Largo, Brasil (BR_5911)",
  "Campo Mourão, Brasil (BR_5914)",
  "Cianorte, Brasil (BR_5959)",
  "Colombo, Brasil (BR_5964)",
  "Francisco Beltrão, Brasil (BR_6094)",
  "Guarapuava, Brasil (BR_6131)",
  "Guaratuba, Brasil (BR_6135)",
  "Jaguariaíva, Brasil (BR_6212)",
  "Matinhos, Brasil (BR_6321)",
  "Olinda, Brasil (B03)|E",
  "Osasco, Brasil (BR_9432)",
  "Paranavaí, Brasil (BR_6420)",
  "Pinhais, Brasil (BR_6445)",
  "Ouro Preto, Brasil (BR_3507)",
  "Santa Terezinha de Itaipu, Brasil (BR_6598)",
  "Palmas, Brasil (BR_6401)",
  "São José dos Pinhais, Brasil (BR_6656)",
  "União da Vitória, Brasil (BR_6796)",
  "Itabuna, Brasil (BR_683)",
  "Vitorino, Brasil (BR_6832)",
  "Parati, Brasil (BR_7004)",
  "Parnamirim, Brasil (BR_5379)",
  "Barra do Piraí, Brasil (BR_6862)",
  "Cachoeiras de Macacu, Brasil (BR_6875)",
  "Campos dos Goytacazes, Brasil (BR_6881)",
  "Duque de Caxias, Brasil (BR_6912)",
  "Itaboraí, Brasil (BR_6941)",
  "Itaguaí, Brasil (BR_6943)",
  "Itatiaia, Brasil (BR_6951)",
  "Japeri, Brasil (BR_6955)",
  "Mangaratiba, Brasil (BR_6966)",
  "Paulista, Brasil (BR_5018)",
  "Nova Friburgo, Brasil (BR_6993)",
  "Nova Iguaçu, Brasil (BR_6994)",
  "Paulista, Brasil (BR_5384)",
  "Porto Real, Brasil (BR_7023)",
  "Queimados, Brasil (BR_7031)",
  "Resende, Brasil (BR_7035)",
  "Rio Bonito, Brasil (BR_7039)",
  "Rio das Flores, Brasil (BR_7041)",
  "Rio das Ostras, Brasil (BR_7042)",
  "São João da Barra, Brasil (BR_7068)",
  "São João de Meriti, Brasil (BR_7069)",
  "São Pedro da Aldeia, Brasil (BR_7078)",
  "Saquarema, Brasil (BR_7085)",
  "Teresópolis, Brasil (BR_7102)",
  "Três Rios, Brasil (BR_7107)",
  "Itaparica, Brasil (BR_711)",
  "Vassouras, Brasil (BR_7113)",
  "Volta Redonda, Brasil (BR_7121)",
  "Petrópolis, Brasil (B23)",
  "Extremoz, Brasil (BR_7167)",
  "Galinhos, Brasil (BR_7174)",
  "Nísia Floresta, Brasil (BR_7222)",
  "Poços de Caldas, Brasil (BR_3632)",
  "São José de Mipibu, Brasil (BR_7271)",
  "São Miguel de Touros, Brasil (BR_7275)",
  "Ponta Grossa, Brasil (BR_6471)",
  "Praia Grande, Brasil (BR_8625)",
  "Touros, Brasil (BR_7300)",
  "Praia Grande, Brasil (BR_9527)",
  "Ituberá, Brasil (BR_731)",
  "Rolim de Moura, Brasil (BR_7358)",
  "Alegrete, Brasil (BR_7396)",
  "Jequié, Brasil (BR_749)",
  "Quatro Barras, Brasil (BR_6501)",
  "Campo Bom, Brasil (BR_7517)",
  "Canoas, Brasil (BR_7533)",
  "Capão da Canoa, Brasil (BR_7539)",
  "Dois Irmãos, Brasil (BR_7650)",
  "Erechim, Brasil (BR_7675)",
  "Esteio, Brasil (BR_7697)",
  "Farroupilha, Brasil (BR_7710)",
  "Flores da Cunha, Brasil (BR_7719)",
  "Frederico Westphalen, Brasil (BR_7730)",
  "Garibaldi, Brasil (BR_7733)",
  "Guaíba, Brasil (BR_7750)",
  "Igrejinha, Brasil (BR_7768)",
  "Ijuí, Brasil (BR_7771)",
  "Marau, Brasil (BR_7850)",
  "Lauro de Freitas, Brasil (BR_789)",
  "Nova Petrópolis, Brasil (BR_7910)",
  "Salvador do Sul, Brasil (BR_8066)",
  "Santa Cruz do Sul, Brasil (BR_8079)",
  "Santa Rosa, Brasil (BR_8090)",
  "Santana do Livramento, Brasil (BR_8101)",
  "São Leopoldo, Brasil (BR_8146)",
  "Rio Branco, Brasil (BR_4459)",
  "Rio Claro, Brasil (BR_7040)",
  "Rio Claro, Brasil (BR_9566)",
  "Torres, Brasil (BR_8242)",
  "Tramandaí, Brasil (BR_8245)",
  "Mata de São João, Brasil (BR_827)",
  "Venâncio Aires, Brasil (BR_8288)",
  "Balneário Camboriú, Brasil (BR_8357)",
  "Bom Jardim da Serra, Brasil (BR_8380)",
  "Brusque, Brasil (BR_8390)",
  "Caçador, Brasil (BR_8391)",
  "Campos Novos, Brasil (BR_8403)",
  "Fraiburgo, Brasil (BR_8456)",
  "Garopaba, Brasil (BR_8461)",
  "Gaspar, Brasil (BR_8463)",
  "Governador Celso Ramos, Brasil (BR_8465)",
  "Gravatal, Brasil (BR_8468)",
  "Imbituba, Brasil (BR_8486)",
  "Indaial, Brasil (BR_8488)",
  "Itapoá, Brasil (BR_8511)",
  "Joaçaba, Brasil (BR_8520)",
  "Lages, Brasil (BR_8525)",
  "Laguna, Brasil (BR_8528)",
  "Mafra, Brasil (BR_8543)",
  "Santa Inês, Brasil (BR_2562)",
  "Santa Inês, Brasil (BR_5062)",
  "Santa Inês, Brasil (BR_6578)",
  "Santa Inês, Brasil (BR_994)",
  "Palhoça, Brasil (BR_8589)",
  "Penha, Brasil (BR_8602)",
  "Santa Luzia, Brasil (BR_2563)",
  "Balneário Piçarras, Brasil (BR_8607)",
  "Santa Luzia, Brasil (BR_3749)",
  "Piratuba, Brasil (BR_8614)",
  "Porto Belo, Brasil (BR_8622)",
  "Santa Luzia, Brasil (BR_5063)",
  "Santa Luzia, Brasil (BR_995)",
  "Rio do Sul, Brasil (BR_8650)",
  "Santa Maria, Brasil (BR_7256)",
  "São Bento do Sul, Brasil (BR_8684)",
  "São Francisco do Sul, Brasil (BR_8692)",
  "São José, Brasil (BR_8700)",
  "Timbó, Brasil (BR_8735)",
  "Tubarão, Brasil (BR_8742)",
  "Xanxerê, Brasil (BR_8763)",
  "Santo André, Brasil (BR_5073)",
  "Barra dos Coqueiros, Brasil (BR_8774)",
  "Canindé de São Francisco, Brasil (BR_8780)",
  "Santo André, Brasil (B16)|E",
  "Laranjeiras, Brasil (BR_8804)",
  "São Carlos, Brasil (BR_8687)",
  "São Carlos, Brasil (BR_9643)",
  "Águas de Lindóia, Brasil (BR_8859)",
  "Águas de São Pedro, Brasil (BR_8861)",
  "Americana, Brasil (BR_8883)",
  "Araraquara, Brasil (BR_8912)",
  "Assis, Brasil (BR_8926)",
  "Avaré, Brasil (BR_8933)",
  "Barretos, Brasil (BR_8954)",
  "São Francisco de Paula, Brasil (BR_3827)",
  "Bebedouro, Brasil (BR_8962)",
  "Bertioga, Brasil (BR_8967)",
  "Boituva, Brasil (BR_8977)",
  "Botucatu, Brasil (BR_8989)",
  "Bragança Paulista, Brasil (BR_8992)",
  "Brotas, Brasil (BR_8998)",
  "Cabreúva, Brasil (BR_9004)",
  "Caçapava, Brasil (BR_9005)",
  "Cachoeira Paulista, Brasil (BR_9007)",
  "São Gonçalo do Amarante, Brasil (BR_1682)",
  "Caraguatatuba, Brasil (BR_9043)",
  "Cardoso, Brasil (BR_9046)",
  "Cruzeiro, Brasil (BR_9087)",
  "Paulo Afonso, Brasil (BR_909)",
  "Japaratinga, Brasil (BR_91)",
  "Fernandópolis, Brasil (BR_9136)",
  "Franco da Rocha, Brasil (BR_9146)",
  "Guaratinguetá, Brasil (BR_9177)",
  "Guarulhos, Brasil (BR_9183)",
  "Hortolândia, Brasil (BR_9189)",
  "Ibiúna, Brasil (BR_9201)",
  "Indaiatuba, Brasil (BR_9216)",
  "Itanhaém, Brasil (BR_9237)",
  "Itapecerica da Serra, Brasil (BR_9239)",
  "Itapira, Brasil (BR_9244)",
  "Itatiba, Brasil (BR_9254)",
  "Itu, Brasil (BR_9260)",
  "Itupeva, Brasil (BR_9261)",
  "Jaboticabal, Brasil (BR_9265)",
  "Jacareí, Brasil (BR_9267)",
  "Jaguariúna, Brasil (BR_9273)",
  "Jarinu, Brasil (BR_9283)",
  "Jaú, Brasil (BR_9285)",
  "Jundiaí, Brasil (BR_9295)",
  "Limeira, Brasil (BR_9317)",
  "Lins, Brasil (BR_9319)",
  "Lorena, Brasil (BR_9321)",
  "Mairiporã, Brasil (BR_9338)",
  "Matão, Brasil (BR_9354)",
  "Mauá, Brasil (BR_9355)",
  "Mirassol, Brasil (BR_9366)",
  "São Sebastião, Brasil (BR_172)",
  "Mogi Guaçu, Brasil (BR_9370)",
  "Mogi Mirim, Brasil (BR_9371)",
  "Mongaguá, Brasil (BR_9374)",
  "Monte Alegre do Sul, Brasil (BR_9376)",
  "São Sebastião, Brasil (BR_9673)",
  "Nazaré Paulista, Brasil (BR_9396)",
  "Nova Odessa, Brasil (BR_9415)",
  "Olímpia, Brasil (BR_9425)",
  "Osvaldo Cruz, Brasil (BR_9434)",
  "Ourinhos, Brasil (BR_9435)",
  "São Vicente, Brasil (BR_7280)",
  "Paraguaçu Paulista, Brasil (BR_9447)",
  "São Vicente, Brasil (BR_9678)",
  "Paulínia, Brasil (BR_9464)",
  "Penápolis, Brasil (BR_9477)",
  "Prado, Brasil (BR_948)",
  "Peruíbe, Brasil (BR_9480)",
  "Piedade, Brasil (BR_9483)",
  "Pindamonhangaba, Brasil (BR_9485)",
  "Piracicaba, Brasil (BR_9493)",
  "Pirapozinho, Brasil (BR_9500)",
  "Pirassununga, Brasil (BR_9501)",
  "Sarandi, Brasil (BR_6709)",
  "Porto Feliz, Brasil (BR_9518)",
  "Presidente Epitácio, Brasil (BR_9531)",
  "Presidente Venceslau, Brasil (BR_9533)",
  "Registro, Brasil (BR_9549)",
  "Sertãozinho, Brasil (BR_5109)",
  "Sertãozinho, Brasil (BR_9686)",
  "Salto, Brasil (BR_9587)",
  "Santana de Parnaíba, Brasil (BR_9622)",
  "Santo Antônio do Pinhal, Brasil (BR_9632)",
  "Santos, Brasil (BR_9636)",
  "São Bernardo do Campo, Brasil (BR_9640)",
  "São Caetano do Sul, Brasil (BR_9642)",
  "São Roque, Brasil (BR_9671)",
  "Serra Negra, Brasil (BR_9684)",
  "Socorro, Brasil (BR_9693)",
  "Taboão da Serra, Brasil (BR_9707)",
  "Taubaté, Brasil (BR_9726)",
  "Tupã, Brasil (BR_9748)",
  "Ubatuba, Brasil (BR_9756)",
  "Valinhos, Brasil (BR_9768)",
  "Vinhedo, Brasil (BR_9783)",
  "Votuporanga, Brasil (BR_9789)",
  "Tibau do Sul, Brasil (BR_7298)",
  "Toledo, Brasil (BR_4026)",
  "Santa Cruz Cabrália, Brasil (BR_992)",
  "Taguatinga, Brasil (BR_9948)",
  "Valença, Brasil (BR_1102)",
  "Balneário de Camboriú, Brasil (B06)",
  "Várzea Grande, Brasil (BR_4511)",
  "Várzea Grande, Brasil (BR_5726)",
  "Ilhéus, Brasil (B12)",
  "Viçosa, Brasil (BR_188)",
  "Viçosa, Brasil (BR_4082)",
  "Canoa Quebrada, Brasil (B21)",
  "Viçosa, Brasil (BR_7308)",
  "Vila Velha, Brasil (BR_2044)",
  "Porto de Galinhas, Brasil (PG8)",
  "Rio Quente, Brasil (RQR)",
  "São Sebastião, Brasil (BR_10146)",
  "São Carlos, Brasil (BR_10147)",
  "Barão do Melgaço, Brasil (BR_10148)",
  "Acailândia, Brasil (BR_10149)",
  "São Miguel do Gostoso, Brasil (BR_10150)",
  "Guaíra, Brasil (BR_10151)",
  "Praia Grande, Brasil (BR_10152)",
  "Santa Luzia, Brasil (BR_10153)",
  "Rio Claro, Brasil (BR_10154)",
  "São João del-Rei, Brasil (BR_10155)",
  "Belmonte, Brasil (BR_10156)",
  "Una, Brasil (BR_10157)",
  "Água Branca, Brasil (BR_10159)",
  "Sertãozinho, Brasil (BR_10161)",
  "Amparo, Brasil (BR_10164)",
  "Praia da Pipa, Brasil (PP2)",
  "Tibau do Sul, Brasil (B20)",
  "Vila Velha, Brasil (B15)",
  "Itacaré, Brasil (B18)",
  "Telemaco Borba, Brasil (TEC)",
  "Tefe, Brasil (TFF)",
  "Tabatinga, Brasil (TBT)",
  "Teresina, Brasil (THE)",
  "Trombetas, Brasil (TMT)",
  "Toledo, Brasil (TOW)",
  "Varginha, Brasil (VAG)",
  "Vitoria Da Conquista, Brasil (VDC)",
  "Umuarama, Brasil (UMU)",
  "Una BR, Brasil (UNA)",
  "Uruguaina, Brasil (URG)",
  "Uberaba, Brasil (UBA)",
  "Uberlandia, Brasil (UDI)",
  "Tucurui, Brasil (TUR)",
  "Salvador, Brasil (SSA)",
  "Sorocaba, Brasil (SOD)",
  "Santarem, Brasil (STM)",
  "San Luis, Brasil (SLZ)",
  "Sao Jose Dos Campos, Brasil (SJK)",
  "Sao Jose Do Rio Preto, Brasil (SJP)",
  "Cabo de Santo Agostino, Brasil (SA1)",
  "Rondonopolis, Brasil (ROO)",
  "Rio Grande, Brasil (RIG)",
  "Rio De Janeiro, Brasil (RIO)",
  "Sao Paulo, Brasil (SAO)",
  "Sumare, Brasil (RWS)",
  "Atibaia, Brasil (ZBW)",
  "Chapeco, Brasil (XAP)",
  "Vitoria, Brasil (VIX)",
  "Camboriu, Brasil (CB1)",
  "Caucedo, Brasil (CAU)",
  "Campos, Brasil (CAW)",
  "Cachoeiro De Itapemirim, Brasil (CDI)",
  "Criciuma, Brasil (CCM)",
  "Campo Grande, Brasil (CGR)",
  "Cuiaba, Brasil (CGB)",
  "Cabo Frio, Brasil (CFB)",
  "Corumba, Brasil (CMG)",
  "Carajas, Brasil (CKS)",
  "Cascavel, Brasil (CAC)",
  "Buzios, Brasil (BZC)",
  "Boa Vista, Brasil (BVB)",
  "Vilhena, Brasil (BVH)",
  "Brasilia, Brasil (BSB)",
  "Blumenau, Brasil (BNU)",
  "Porto Seguro, Brasil (BPS)",
  "Barreiras, Brasil (BRA)",
  "Belem, Brasil (BEL)",
  "Bento Goncalves, Brasil (BGV)",
  "Belo Horizonte, Brasil (BHZ)",
  "Bauru, Brasil (JTC)",
  "Bombinhas, Brasil (BB1)",
  "Araguaina, Brasil (AUX)",
  "Aracatuba, Brasil (ARU)",
  "Altamira, Brasil (ATM)",
  "Anapolis, Brasil (APS)",
  "Angra dos Reis, Brasil (AR1)",
  "Aracaju, Brasil (AJU)",
  "Alta Floresta, Brasil (AFL)",
  "Santo Amaro da Imperatriz, Brasil (AI1)",
  "Arraial Do Cabo, Brasil (AC1)",
  "Arapoti, Brasil (AAG)",
  "Cruzeiro Do Sul, Brasil (CZS)",
  "Caxias Do Sul, Brasil (CXJ)",
  "Curitiba, Brasil (CWB)",
  "Campinas, Brasil (CPQ)",
  "Campina Grande, Brasil (CPV)",
  "Costa Do Sauipe, Brasil (CS1)",
  "Fernando De Noronha, Brasil (FEN)",
  "Floriano, Brasil (FLB)",
  "Florianopolis, Brasil (FLN)",
  "Horizontina, Brasil (HRZ)",
  "Goiania, Brasil (GYN)",
  "Governador Valadares, Brasil (GVR)",
  "Gravatai, Brasil (GCV)",
  "Fortaleza, Brasil (FOR)",
  "Guarajuba, Brasil (GJ1)",
  "Parati, Brasil (PT1)",
  "Pato Branco, Brasil (PTO)",
  "Praia do Santinho, Brasil (PS1)",
  "Porto Velho, Brasil (PVH)",
  "Novo Hamburgo, Brasil (QHV)",
  "Iguatu, Brasil (QIG)",
  "Niteroi, Brasil (QNT)",
  "Ribeirao Preto, Brasil (RAO)",
  "Rio Branco, Brasil (RBR)",
  "Recife, Brasil (REC)",
  "Santa Maria, Brasil (RIA)",
  "Parnaiba, Brasil (PHB)",
  "Pelotas, Brasil (PET)",
  "Passo Fundo, Brasil (PFB)",
  "Ponta Pora, Brasil (PMG)",
  "Palmas, Brasil (PMW)",
  "Paranagua, Brasil (PNG)",
  "Praia da Pipa, Brasil (PP1)",
  "Presidente Prudente, Brasil (PPB)",
  "Petrolina, Brasil (PNZ)",
  "Porto Alegre, Brasil (POA)",
  "Morro de São Paulo, Brasil, Brasil (MO1)",
  "Montes Claros, Brasil (MOC)",
  "Natal, Brasil (NAT)",
  "Mossoro, Brasil (MVF)",
  "Ourilandia, Brasil (OIA)",
  "Cacoal, Brasil (OAL)",
  "Navegantes, Brasil (NVT)",
  "Lencois, Brasil (LEC)",
  "Londrina, Brasil (LDB)",
  "Marilia, Brasil (MII)",
  "Maringa, Brasil (MGF)",
  "Monte Dourado, Brasil (MEU)",
  "Maragogi, Brasil (MG1)",
  "Maceio, Brasil (MCZ)",
  "Macae, Brasil (MEA)",
  "Macapa, Brasil (MCP)",
  "Maraba, Brasil (MAB)",
  "Praia de Muro Alto, Brasil (MA1)",
  "Manaos, Brasil (MAO)",
  "Lajes, Brasil (LAJ)",
  "Juazeiro Do Norte, Brasil (JDO)",
  "Joinville, Brasil (JOI)",
  "Joao Pessoa, Brasil (JPA)",
  "Ji Parana, Brasil (JPR)",
  "Jericoacoara, Brasil (JC1)",
  "Juiz De Fora, Brasil (JDF)",
  "Itapema, Brasil (IT1)",
  "Itaperuna, Brasil (ITP)",
  "Ilha Grande, Brasil (IG1)",
  "Foz Do Iguaçu, Brasil (IGU)",
  "Imperatriz, Brasil (IMP)",
  "Ilheus, Brasil (IOS)",
  "Ipatinga, Brasil (IPN)",
  "Marsh Harbour, Bahamas (MHH)",
  "Nassau, Bahamas (NAS)",
  "Governor S Harbour, Bahamas (GHB)",
  "George Town, Bahamas (GGT)",
  "Freeport, Bahamas (FPO)",
  "Harbour Island, Bahamas (HBI)",
  "North Eleuthera, Bahamas (ELH)",
  "Arthurs Town, Bahamas (ATC)",
  "Andros Town, Bahamas (ASD)",
  "Bimini, Bahamas (BIM)",
  "San Salvador, Bahamas (ZSA)",
  "Rock Sound, Bahamas (RSD)",
  "South Andros, Bahamas (TZN)",
  "Treasure Cay, Bahamas (TCB)",
  "Kasane, Botswana (BBK)",
  "Francistown, Botswana (FRW)",
  "Gaborone, Botswana (GBE)",
  "Maun, Botswana (MUB)",
  "Selebi Phikwe, Botswana (PKW)",
  "Mogilev, Bielorusia (MVQ)",
  "Minsk, Bielorusia (MSQ)",
  "Gomel, Bielorusia (GME)",
  "Grodna, Bielorusia (GNA)",
  "Brest, Bielorusia (BQT)",
  "Vitebsk, Bielorusia (VTB)",
  "San Pedro, Belize (SPR)",
  "Belice, Belize (BZE)",
  "Placencia, Belize (PLJ)",
  "Pikwitonei, Canada (PIW)",
  "Bella Coola, Canada (QBC)",
  "Lake Louise, Canada (LL1)",
  "Ilford, Canada (ILF)",
  "Creston, Canada (CFQ)",
  "St Pierre, Canada (FSP)",
  "Duncan, Canada (DUQ)",
  "La Sarre, Canada (SSQ)",
  "Capreol, Canada (XAW)",
  "Campbellton, Canada (XAZ)",
  "Brockville, Canada (XBR)",
  "Killineq, Canada (XBW)",
  "Chambord, Canada (XCI)",
  "Chatham, Canada (XCM)",
  "Cobourg, Canada (XGJ)",
  "Coteau, Canada (XGK)",
  "Gananoque, Canada (XGW)",
  "Grimsby, Canada (XGY)",
  "Georgetown, Canada (XHM)",
  "Chemainus, Canada (XHS)",
  "Chandler, Canada (XDL)",
  "Drummondville, Canada (XDM)",
  "Grande Riviere, Canada (XDO)",
  "Hervey, Canada (XDU)",
  "Lac Edouard, Canada (XEE)",
  "Ladysmith, Canada (XEH)",
  "Langford, Canada (XEJ)",
  "Melville, Canada (XEK)",
  "New Carlisle, Canada (XEL)",
  "New Richmond, Canada (XEM)",
  "Stratford, Canada (XFD)",
  "Parent, Canada (XFE)",
  "Perce, Canada (XFG)",
  "Port Daniel, Canada (XFI)",
  "Senneterre, Canada (XFK)",
  "Shawinigan, Canada (XFL)",
  "Shawnigan, Canada (XFM)",
  "Taschereau, Canada (XFO)",
  "Weymont, Canada (XFQ)",
  "Alexandria, Canada (XFS)",
  "Brantford, Canada (XFV)",
  "Joliette, Canada (XJL)",
  "Jonquiere, Canada (XJQ)",
  "Sackville, Canada (XKV)",
  "Matapedia, Canada (XLP)",
  "Niagara Falls, Canada (XLV)",
  "Aldershot, Canada (XLY)",
  "Truro, Canada (XLZ)",
  "Guelph, Canada (XIA)",
  "Ingersoll, Canada (XIB)",
  "Maxville, Canada (XID)",
  "Napanee, Canada (XIF)",
  "Prescott, Canada (XII)",
  "Saint Hyacinthe, Canada (XIM)",
  "St Marys, Canada (XIO)",
  "Woodstock, Canada (XIP)",
  "Oakville, Canada (XOK)",
  "Carleton, Canada (XON)",
  "Parksville, Canada (XPB)",
  "Port Hope, Canada (XPH)",
  "Pukatawagan, Canada (XPK)",
  "Brampton, Canada (XPN)",
  "Pointe Aux Trembles, Canada (XPX)",
  "Qualicum, Canada (XQU)",
  "Riviere A Pierre, Canada (XRP)",
  "St Anthony, Canada (YAY)",
  "Tofino, Canada (YAZ)",
  "Banff, Canada (YBA)",
  "Pelly Bay, Canada (YBB)",
  "Baie Comeau, Canada (YBC)",
  "New Westminster, Canada (YBD)",
  "Bagotville, Canada (YBG)",
  "Campbell River, Canada (YBL)",
  "Brandon, Canada (YBR)",
  "Blanc Sablon, Canada (YBX)",
  "Courtenay, Canada (YCA)",
  "Cambridge Bay, Canada (YCB)",
  "Cornwall, Canada (YCC)",
  "Nanaimo, Canada (YCD)",
  "Castlegar, Canada (YCG)",
  "Miramichi, Canada (YCH)",
  "Colville, Canada (YCK)",
  "Charlo, Canada (YCL)",
  "St Catherines, Canada (YCM)",
  "Cochrane, Canada (YCN)",
  "Chilliwack, Canada (YCW)",
  "Clyde River, Canada (YCY)",
  "Fairmont Springs, Canada (YCZ)",
  "Dawson City, Canada (YDA)",
  "Deer Lake, Canada (YDF)",
  "Dease Lake, Canada (YDL)",
  "Dauphin, Canada (YDN)",
  "Dawson Creek, Canada (YDQ)",
  "Edmonton, Canada (YEA)",
  "Arviat, Canada (YEK)",
  "Elliot Lake, Canada (YEL)",
  "Estevan, Canada (YEN)",
  "Edson, Canada (YET)",
  "Inuvik, Canada (YEV)",
  "Amos, Canada (YEY)",
  "Iqaluit, Canada (YFB)",
  "Fredericton, Canada (YFC)",
  "Flin Flon, Canada (YFO)",
  "Strathroy, Canada (XTY)",
  "Belleville, Canada (XVV)",
  "Watford, Canada (XWA)",
  "Wyoming, Canada (XWY)",
  "Casselman, Canada (XZB)",
  "Glencoe, Canada (XZC)",
  "Amherst, Canada (XZK)",
  "Fort Frances, Canada (YAG)",
  "Kingston, Canada (YGK)",
  "La Grande, Canada (YGL)",
  "Gaspe, Canada (YGP)",
  "Iles De Madeleine, Canada (YGR)",
  "Havre St Pierre, Canada (YGV)",
  "Gillam, Canada (YGX)",
  "Hudson Bay, Canada (YHB)",
  "Dryden, Canada (YHD)",
  "Hope, Canada (YHE)",
  "Hearst, Canada (YHF)",
  "Charlottetown, Canada (YHG)",
  "Hamilton, Canada (YHM)",
  "Hornepayne, Canada (YHN)",
  "Chevery, Canada (YHR)",
  "Sechelt, Canada (YHS)",
  "Hay River, Canada (YHY)",
  "Halifax, Canada (YHZ)",
  "Atikokan, Canada (YIB)",
  "Pakuashipi, Canada (YIF)",
  "Jasper, Canada (YJA)",
  "Stephenville, Canada (YJT)",
  "Kamloops, Canada (YKA)",
  "Kitchener, Canada (YKF)",
  "Schefferville, Canada (YKL)",
  "Ottawa, Canada (YOW)",
  "Prince Albert, Canada (YPA)",
  "Port Alberni, Canada (YPB)",
  "Parry Sound, Canada (YPD)",
  "Peace River, Canada (YPE)",
  "Esquimalt, Canada (YPF)",
  "Portage La Prairie, Canada (YPG)",
  "Pickle Lake, Canada (YPL)",
  "St Pierre, Canada (YPM)",
  "Port Menier, Canada (YPN)",
  "Peterborough, Canada (YPQ)",
  "Prince Rupert, Canada (YPR)",
  "Port Hawkesbury, Canada (YPS)",
  "Powell River, Canada (YPW)",
  "Burns Lake, Canada (YPZ)",
  "Muskoka, Canada (YQA)",
  "Quebec, Canada (YQB)",
  "The Pas, Canada (YQD)",
  "Windsor, Canada (YQG)",
  "Watson Lake, Canada (YQH)",
  "Yarmouth, Canada (YQI)",
  "Kenora, Canada (YQK)",
  "Lethbridge, Canada (YQL)",
  "Moncton, Canada (YQM)",
  "Nakina, Canada (YQN)",
  "Comox, Canada (YQQ)",
  "Regina, Canada (YQR)",
  "St Thomas, Canada (YQS)",
  "Thunder Bay, Canada (YQT)",
  "Grande Prairie, Canada (YQU)",
  "Yorkton, Canada (YQV)",
  "North Battleford, Canada (YQW)",
  "Gander, Canada (YQX)",
  "Sydney, Canada (YQY)",
  "Quesnel, Canada (YQZ)",
  "Riviere Du Loup, Canada (YRI)",
  "Roberval, Canada (YRJ)",
  "Red Lake, Canada (YRL)",
  "Trois Rivieres, Canada (YRQ)",
  "Rankin Inlet, Canada (YRT)",
  "Sudbury, Canada (YSB)",
  "Sherbrooke, Canada (YSC)",
  "Smith Falls, Canada (YSH)",
  "St John, Canada (YSJ)",
  "St Leonard, Canada (YSL)",
  "Ft Smith, Canada (YSM)",
  "Salmon Arm, Canada (YSN)",
  "Marathon, Canada (YSP)",
  "St Theris Point, Canada (YST)",
  "Pembroke, Canada (YTA)",
  "Thicket Portage, Canada (YTD)",
  "Cape Dorset, Canada (YTE)",
  "Alma, Canada (YTF)",
  "Thompson, Canada (YTH)",
  "Terrace Bay, Canada (YTJ)",
  "Toronto, Canada (YTO)",
  "Trenton, Canada (YTR)",
  "Timmins, Canada (YTS)",
  "Sandy Lake, Canada (ZSJ)",
  "Tete A La Baleine, Canada (ZTB)",
  "Bromont, Canada (ZBM)",
  "Bathurst, Canada (ZBF)",
  "Gethsemanie, Canada (ZGS)",
  "Houston, Canada (ZHO)",
  "La Tabatiere, Canada (ZLT)",
  "Swan River, Canada (ZJN)",
  "Kegaska, Canada (ZKG)",
  "Queen Charlotte Island, Canada (ZQS)",
  "Cold Lake, Canada (YOD)",
  "High Level, Canada (YOJ)",
  "Oshawa, Canada (YOO)",
  "Rainbow Lake, Canada (YOP)",
  "Owen Sound, Canada (YOS)",
  "Rouyn Noranda, Canada (YUY)",
  "Meadow Lake, Canada (YLJ)",
  "Lloydminster, Canada (YLL)",
  "La Tuque, Canada (YLQ)",
  "Kelowna, Canada (YLW)",
  "Merritt, Canada (YMB)",
  "Matane, Canada (YME)",
  "Manitouwadge, Canada (YMG)",
  "Minaki, Canada (YMI)",
  "Ft McMurray, Canada (YMM)",
  "Moosonee, Canada (YMO)",
  "Montreal, Canada (YMQ)",
  "Chibougamau, Canada (YMT)",
  "Natashquan, Canada (YNA)",
  "Waskaganish, Canada (YKQ)",
  "Chisasibi, Canada (YKU)",
  "Kirkland, Canada (YKX)",
  "Chapleau, Canada (YLD)",
  "Sault Ste Marie, Canada (YAM)",
  "Gatineau Hull, Canada (YND)",
  "Bonaventure, Canada (YVB)",
  "Vernon, Canada (YVE)",
  "Vermilion, Canada (YVG)",
  "Val D Or, Canada (YVO)",
  "Kuujjuaq, Canada (YVP)",
  "Norman Wells, Canada (YVQ)",
  "Vancouver, Canada (YVR)",
  "Deer Lake, Canada (YVZ)",
  "Winnipeg, Canada (YWG)",
  "Wabush, Canada (YWK)",
  "Williams Lake, Canada (YWL)",
  "White River, Canada (YWR)",
  "Whistler, Canada (YWS)",
  "Cranbrook, Canada (YXC)",
  "Saskatoon, Canada (YXE)",
  "Medicine Hat, Canada (YXH)",
  "Ft St John, Canada (YXJ)",
  "Rimouski, Canada (YXK)",
  "Sioux Lookout, Canada (YXL)",
  "Pangnirtung, Canada (YXP)",
  "Prince George, Canada (YXS)",
  "Terrace, Canada (YXT)",
  "London, Canada (YXU)",
  "Abbotsford, Canada (YXX)",
  "Whitehorse, Canada (YXY)",
  "Wawa, Canada (YXZ)",
  "North Bay, Canada (YYB)",
  "Calgary, Canada (YYC)",
  "Smithers, Canada (YYD)",
  "Fort Nelson, Canada (YYE)",
  "Penticton, Canada (YYF)",
  "Charlottetown, Canada (YYG)",
  "Rivers, Canada (YYI)",
  "Victoria, Canada (YYJ)",
  "Lynn Lake, Canada (YYL)",
  "Swift Current, Canada (YYN)",
  "Churchill, Canada (YYQ)",
  "Goose Bay, Canada (YYR)",
  "St Johns, Canada (YYT)",
  "Kapuskasing, Canada (YYU)",
  "Armstromg, Canada (YYW)",
  "Mont Joli, Canada (YYY)",
  "Ashcroft, Canada (YZA)",
  "Yellowknife, Canada (YZF)",
  "Sandspit, Canada (YZP)",
  "Sarnia, Canada (YZR)",
  "Port Hardy, Canada (YZT)",
  "Sept Iles, Canada (YZV)",
  "Kinshasa, Congo RD (FIH)",
  "Lubumbashi, Congo RD (FBM)",
  "Bangui, Rep. Centroafricana (BGF)",
  "Brazzaville, Congo Rep (BZV)",
  "Pointe Noire, Congo Rep (PNR)",
  "Lucerne, Suiza (QLJ)",
  "Lausanne, Suiza (QLS)",
  "Lugano, Suiza (LUG)",
  "Basilea, Suiza (BSL)",
  "Berna, Suiza (BRN)",
  "Altenrhein, Suiza (ACH)",
  "Ginebra, Suiza (GVA)",
  "Montreux, Suiza (ZJP)",
  "Engelberg, Suiza (ZHB)",
  "Interlaken, Suiza (ZIN)",
  "Davos, Suiza (ZDV)",
  "Zurich, Suiza (ZRH)",
  "Sion, Suiza (SIR)",
  "St Moritz, Suiza (SMV)",
  "Gstaad, Suiza (ZHK)",
  "Andermatt, Suiza (S01)",
  "M Bahiakro, Costa de Marfil (XMB)",
  "Abidjan, Costa de Marfil (ABJ)",
  "Yamoussouro, Costa de Marfil (ASK)",
  "Aitutaki, Cook Islands (AIT)",
  "Rarotonga, Cook Islands (RAR)",
  "Punta Arenas, Chile (PUQ)",
  "Puerto Varas, Chile (PTV)",
  "Puerto Natales, Chile (PNT)",
  "Puerto Montt, Chile (PMC)",
  "Los Angeles, Chile (LSQ)",
  "La Serena, Chile (LSC)",
  "Iquique, Chile (IQQ)",
  "Isla De Pascua, Chile (IPC)",
  "Vina Del Mar, Chile (KNA)",
  "Arica, Chile (ARI)",
  "Antofagasta, Chile (ANF)",
  "Balmaceda, Chile (BBA)",
  "Concepcion, Chile (CCP)",
  "Calama, Chile (CJC)",
  "Coyhaique, Chile (GXQ)",
  "El Salvador, Chile (ESR)",
  "Copiapo, Chile (CPO)",
  "Temuco, Chile (ZCO)",
  "Osorno, Chile (ZOS)",
  "Pucon, Chile (ZPC)",
  "Valdivia, Chile (ZAL)",
  "Puerto Aisen, Chile (WPA)",
  "Valparaiso, Chile (VAP)",
  "San Pedro de Atacama, Chile (SP1)",
  "Santiago De Chile, Chile (SCL)",
  "Castro, Chile (WCA)",
  "Porvenir, Chile (WPR)",
  "Puerto Williams, Chile (WPU)",
  "Yaounde, Camerún (YAO)",
  "Douala, Camerún (DLA)",
  "Koutaba, Camerún (KOB)",
  "Maroua, Camerún (MVR)",
  "N Gaoundere, Camerún (NGE)",
  "Ningbo, China (NGB)",
  "Nanjing, China (NKG)",
  "Nanning, China (NNG)",
  "Meixian, China (MXZ)",
  "Qiqihar, China (NDG)",
  "Guiyang, China (KWE)",
  "Guilin, China (KWL)",
  "Kunming, China (KMG)",
  "Kashgar, China (KHG)",
  "Nanchang, China (KHN)",
  "Huangyan, China (HYN)",
  "Jinzhou, China (JNZ)",
  "Jiujiang, China (JIU)",
  "Jinghong, China (JHG)",
  "Ling Ling, China (LLF)",
  "Lijiang City, China (LJG)",
  "Lianping, China (LIA)",
  "Mian Yang, China (MIG)",
  "Liuzhou, China (LZH)",
  "Luoyang, China (LYA)",
  "Mudanjiang, China (MDG)",
  "Dalian, China (DLC)",
  "Dongguan, China (DGM)",
  "Diqing, China (DIG)",
  "Changsha, China (CSX)",
  "Chengdu, China (CTU)",
  "Dayong, China (DYG)",
  "Guang Yuan, China (GYS)",
  "Haikou, China (HAK)",
  "Hohhot, China (HET)",
  "Huanghua, China (HHA)",
  "Hefei, China (HFE)",
  "Hangzhou, China (HGH)",
  "Harbin, China (HRB)",
  "Hengyang, China (HNY)",
  "Fuzhou, China (FOC)",
  "Chongqing, China (CKG)",
  "Zhengzhou, China (CGO)",
  "Changchun, China (CGQ)",
  "Beijing, China (BJS)",
  "Guangzhou, China (CAN)",
  "Beihai, China (BHY)",
  "Yanji, China (YNJ)",
  "Yantai, China (YNT)",
  "Zhangjiang, China (ZHA)",
  "Zhuhai, China (ZUH)",
  "Changzhou, China (CZX)",
  "Wenzhou, China (WNZ)",
  "Wuhan, China (WUH)",
  "Weihai, China (WEH)",
  "Yangzhou, China (YTY)",
  "Xining, China (XNN)",
  "Xian, China (XIY)",
  "Xiamen, China (XMN)",
  "Shanghai, China (SHA)",
  "Shenyang, China (SHE)",
  "Qinhuangdao, China (SHP)",
  "Xiguan, China (SIA)",
  "Shantou, China (SWA)",
  "Sanya, China (SYX)",
  "Shanzhou, China (SZO)",
  "Suzhou , China (SZV)",
  "Shenzhen, China (SZX)",
  "Qingdao, China (TAO)",
  "Jinan, China (TNA)",
  "Tianjin, China (TSN)",
  "Urumqi, China (URC)",
  "Qionghai, China (BAR)",
  "Rio Claro, Antioquia, Colombia (C151)",
  "Rionegro, Colombia (C114)",
  "Sabanalarga, Colombia (C115)",
  "Sabaneta, Colombia (C116)",
  "Salgar, Colombia (C117)",
  "San Andres De Cuerquia, Colombia (C118)",
  "Pueblorrico, Colombia (C111)",
  "Puerto Nare, Colombia (C112)",
  "Puerto Triunfo, Colombia (C113)",
  "San Carlos, Colombia (C119)",
  "San Francisco, Colombia (C120)",
  "San Jeronimo, Colombia (C121)",
  "San Jose De La Montaña, Colombia (C122)",
  "San Luis, Colombia (C123)",
  "San Rafael, Colombia (C125)",
  "San Roque, Colombia (C126)",
  "San Pedro de los Milagros, Colombia (C124)",
  "San Vicente Ferrer, Colombia (C127)",
  "Santa Rosa De Osos, Colombia (C129)",
  "Santa Rosalía, Colombia (CO_912)",
  "Santa Barbara, Colombia (C128)",
  "Santo Domingo, Colombia (C130)",
  "Valparaiso, Colombia (C142)",
  "Vegachi, Colombia (C143)",
  "Venecia, Colombia (C144)",
  "Villa Vieja, Colombia (CO_1122)",
  "Yali, Colombia (C146)",
  "Yarumal, Colombia (C147)",
  "Yolombo, Colombia (C148)",
  "Yondo, Colombia (C149)",
  "Zaragosa, Colombia (C150)",
  "Vigia Del Fuerte, Colombia (C145)",
  "Titiribi, Colombia (C137)",
  "Tobia, Colombia (CO3)",
  "Toledo, Colombia (C138)",
  "Uramita, Colombia (C139)",
  "Valdivia, Colombia (C141)",
  "Segovia, Colombia (C131)",
  "Sonson, Colombia (C132)",
  "Sopetran, Colombia (C133)",
  "Tamesis, Colombia (C134)",
  "Taraza, Colombia (C135)",
  "Tarso, Colombia (C136)",
  "Guadalupe, Colombia (C90)",
  "Granada, Colombia (CO_99)",
  "Granada, Colombia (C89)",
  "Heliconia, Colombia (C92)",
  "Hispania, Colombia (C93)",
  "Guarne, Colombia (C91)",
  "Isla Tintipan, Colombia (CO4)",
  "Fredonia, Colombia (C84)",
  "Frontino, Colombia (C85)",
  "Giraldo, Colombia (C86)",
  "Girardota, Colombia (C87)",
  "Gomez Plata, Colombia (C88)",
  "Cocorna, Colombia (C71)",
  "Concepcion, Colombia (C72)",
  "Concordia, Colombia (C73)",
  "Copacabana, Colombia (C74)",
  "Cisneros, Colombia (C69)",
  "Ciudad Bolivar, Colombia (C70)",
  "Dabeiba, Colombia (C75)",
  "Don Matias, Colombia (C76)",
  "Ebejico, Colombia (C77)",
  "El Carmen De Viboral, Colombia (C67)",
  "El Retiro, Colombia (C80)",
  "El Santuario, Colombia (C81)",
  "El Peñol, Colombia (C79)",
  "Entrerrios, Colombia (C82)",
  "Envigado, Colombia (C83)",
  "Itagui, Colombia (C94)",
  "Ituango, Colombia (C95)",
  "Jardin, Colombia (C78)",
  "Jerico, Colombia (C96)",
  "La Ceja, Colombia (C97)",
  "La Estrella, Colombia (C98)",
  "La Pintada, Colombia (C99)",
  "Liborina, Colombia (C101)",
  "Maceo, Colombia (C102)",
  "La Union, Colombia (C100)",
  "Olaya, Colombia (C109)",
  "Peque, Colombia (C110)",
  "Montebello, Colombia (C104)",
  "Marinilla, Colombia (C103)",
  "Murindo, Colombia (C105)",
  "Mutata, Colombia (C106)",
  "Nariño, Colombia (C107)",
  "Mesetas, Colombia (CO_877)",
  "Mompox, Colombia (CO5)",
  "Nechi, Colombia (C108)",
  "Abejorral, Colombia (C40)",
  "Abriaqui, Colombia (C41)",
  "andes, Colombia (C48)",
  "Angelopolis, Colombia (C45)",
  "Angostura, Colombia (C46)",
  "Anori, Colombia (C47)",
  "Anza, Colombia (C49)",
  "Alejandria, Colombia (C42)",
  "Amaga, Colombia (C43)",
  "Argelia, Colombia (C50)",
  "Bahia Malaga, Colombia (CB3)",
  "Amalfi, Colombia (C44)",
  "Bello, Colombia (C53)",
  "Belmira, Colombia (C52)",
  "Betania, Colombia (C54)",
  "Betulia, Colombia (C55)",
  "Barbosa, Colombia (C51)",
  "Briceño, Colombia (C56)",
  "Buritica, Colombia (C57)",
  "Caceres, Colombia (C58)",
  "Caicedo, Colombia (C59)",
  "Caldas, Colombia (C60)",
  "Campamento, Colombia (C61)",
  "Cañasgordas, Colombia (C62)",
  "Caracoli, Colombia (C63)",
  "Caramanta, Colombia (C65)",
  "Carepa, Colombia (C66)",
  "Carolina del Principe , Colombia (C68)",
  "CASA DEL AGUA, Colombia (C64)",
  "Cerrito, Colombia (CO29)",
  "Zapatoca, Colombia (AZP)",
  "Santa Veronica, Juan de acosta, Colombia (CO_0991)",
  "Isla Palma, Colombia (A10)",
  "Pamplona, Colombia (CO_9003)",
  "Doradal, Colombia (CO_9004)",
  "Mucura, Colombia (MCR)",
  "Mompox, Colombia (MMX)",
  "Gorgona, Colombia (GOG)",
  "Aguachica, Colombia (HAY)",
  "Quibdó, Colombia (UIB)",
  "Tunja, Colombia (GUS)",
  "Tumaco, Colombia (TCO)",
  "Santa Marta, Colombia (SMR)",
  "Villa Garzón, Colombia (VGZ)",
  "Villa de Leyva, Colombia (VI1)",
  "Valledupar, Colombia (VUP)",
  "Villavicencio, Colombia (VVC)",
  "Tame Arauca, Colombia (TME)",
  "Tolu, Colombia (TLU)",
  "Coveñas, Colombia (CVE)",
  "San Gil, Colombia (SGL)",
  "La Macarena, Colombia (LMC)",
  "Arauca, Colombia (AUC)",
  "Pitalito, Colombia (PTX)",
  "Palomino, Colombia (PAL)",
  "Espinal, Colombia (EPN)",
  "Santa Fe de Antioquia, Colombia (SAQ)",
  "Sogamoso, Colombia (SOX)",
  "Acandí, Colombia (ACD)",
  "Araracuara, Colombia (ACR)",
  "Caucasia, Colombia (CAQ)",
  "Condoto, Colombia (COG)",
  "Cumaribo, Colombia (PCE)",
  "El Bagre, Colombia (EBG)",
  "Girardot, Colombia (GIR)",
  "Guapi, Colombia (GPI)",
  "La Chorrera, Colombia (LCR)",
  "Maicao, Colombia (MCJ)",
  "Mitú, Colombia (MVP)",
  "Nuquí, Colombia (NQU)",
  "Ocaña, Colombia (OCV)",
  "Puerto Inírida, Colombia (PDA)",
  "Puerto Carreño, Colombia (PCR)",
  "Puerto Leguízamo, Colombia (LQM)",
  "Remedios, Colombia (OTU)",
  "San José del Guaviare, Colombia (SJE)",
  "San Vicente del Caguán, Colombia (SVI)",
  "Saravena, Colombia (RVE)",
  "Montelíbano, Colombia (MTB)",
  "Tuluá, Colombia (ULQ)",
  "Santander de quilichao, Colombia (CTO)",
  "Cartago, Colombia (CRC)",
  "Chigorodó, Colombia (IGO)",
  "Cravo Norte, Colombia (RAV)",
  "Magangué, Colombia (MGN)",
  "Mariquita, Colombia (MQU)",
  "Necoclí, Colombia (NCI)",
  "Puerto Gaitán, Colombia (PGT)",
  "Puerto Rico, Colombia (PCC)",
  "San Pedro de Urabá, Colombia (NPD)",
  "Turbo, Colombia (TRB)",
  "Solano, Colombia (TQS)",
  "Arboletes, Colombia (CO_0012)",
  "Guatape, Colombia (CO_0050)",
  "La Ceja, Colombia (CO_0057)",
  "Sabanalarga, Colombia (CO_0080)",
  "Chiquinquira, Colombia (CO_0185)",
  "Duitama, Colombia (CO_0199)",
  "San Antero, Colombia (CO_0401)",
  "San Bernardo Del Viento, Colombia (CO_0402)",
  "Fusagasuga, Colombia (CO_0436)",
  "Nilo, Colombia (CO_0463)",
  "Puerto Salgar, Colombia (CO_0471)",
  "Apulo, Colombia (CO_0476)",
  "Villeta, Colombia (CO_0511)",
  "San Agustin, Colombia (CO_0567)",
  "Filandia, Colombia (CO_0739)",
  "Montenegro, Colombia (CO_0742)",
  "Quimbaya, Colombia (CO_0744)",
  "Salento, Colombia (CO_0745)",
  "Santa Rosa De Cabal, Colombia (CO_0756)",
  "Barichara, Colombia (CO_0762)",
  "San Onofre, Colombia (CO_0853)",
  "Melgar, Colombia (CO_0881)",
  "Mocoa, Colombia (CO_0958)",
  "Lorica, Colombia (LRI)",
  "Isla Barú, Colombia (IBU)",
  "Bucaramanga, Colombia (BGA)",
  "Barranquilla, Colombia (BAQ)",
  "Armenia, Colombia (AXM)",
  "Apartadó, Colombia (APO)",
  "San Andres Isla, Colombia (ADZ)",
  "Bahia Solano, Colombia (BSC)",
  "Buga, Colombia (CO_0904)",
  "Buenaventura, Colombia (BUN)",
  "Bogotá, Colombia (BOG)",
  "Cali, Colombia (CLO)",
  "Capurgana, Colombia (CPB)",
  "Florencia, Colombia (FLA)",
  "Barrancabermeja, Colombia (EJA)",
  "Yopal, Colombia (EYP)",
  "Cartagena, Colombia (CTG)",
  "Cúcuta, Colombia (CUC)",
  "Cabo de la Vela, Colombia (CO_9001)",
  "Medellín, Colombia (MDE)",
  "Leticia, Colombia (LET)",
  "Ibagué, Colombia (IBE)",
  "Ipiales, Colombia (IPI)",
  "Jurado, Colombia (JUO)",
  "Manizales, Colombia (MZL)",
  "Montería, Colombia (MTR)",
  "Neiva, Colombia (NVA)",
  "Popayán, Colombia (PPN)",
  "Paipa, Colombia (PAI)",
  "Pereira, Colombia (PEI)",
  "Pasto, Colombia (PSO)",
  "Puerto Asis, Colombia (PUU)",
  "Isla Providencia , Colombia (PVA)",
  "Riohacha, Colombia (RCH)",
  "Punta Renes, Costa Rica (JAP)",
  "Puerto Limon, Costa Rica (LIO)",
  "Liberia, Costa Rica (LIR)",
  "Guanacaste, Costa Rica (GTE)",
  "Playa Tambor, Costa Rica (A18)",
  "Arenal, Costa Rica (A19)",
  "Quepos, Costa Rica (XQP)",
  "San Jose, Costa Rica (SJO)",
  "Tamarindo, Costa Rica (TNO)",
  "Tambor, Costa Rica (TMU)",
  "Tortuquero, Costa Rica (TTQ)",
  "Puerto Jiménez, Costa Rica (PJM)",
  "Pinar del Río, Cuba (C09)",
  "Playa Blanca, Cuba (C06)",
  "San Antonio de los Banos, Cuba (C01)",
  "Santiago de Cuba, Cuba (C07)",
  "Villa Clara, Cuba (C05)",
  "Península de Zapata, Cuba (C03)",
  "Playa Pesquero, Cuba (C04)",
  "Playa Santa Lucia, Cuba (C02)",
  "Cayo Ensenachos, Cuba (C08)",
  "Cayo Guillermo, Cuba (A08)",
  "Cayo Santa Maria, Cuba (A09)",
  "Cayo Las Brujas, Cuba (CU_001)",
  "Topes de Collantes, Cuba (CLS)",
  "Soroa, Cuba (SOR)",
  "Remedios, Cuba (REM)",
  "Baracoa, Cuba (BCA)",
  "Sancti Spiritus, Cuba (USS)",
  "Trinadad, Cuba (TND)",
  "Siguanea, Cuba (SZJ)",
  "Santa Clara, Cuba (SNU)",
  "Santiago, Cuba (SCU)",
  "Varadero, Cuba (VRA)",
  "Matanzas, Cuba (VRO)",
  "Palma Rubia-Cayo Levisa, Cuba (PRU)",
  "Cayo Saetia, Cuba (SAE)",
  "Santa Lucia, Cuba (LUC)",
  "Don Lino, Cuba (LIN)",
  "Cobarrubias, Cuba (COB)",
  "Brisas , Cuba (BSA)",
  "Esmeralda, Cuba (EMR)",
  "Pesquero , Cuba (PES)",
  "Guardalavaca, Cuba (GLV)",
  "Brisas Los Galeones, Cuba (BLG)",
  "Brisa Sierra Mar, Cuba (BSM)",
  "Costa Morena, Cuba (CMO)",
  "Bucanero, Cuba (BUC)",
  "Jibacoa, Cuba (JCO)",
  "Playa del Este, Cuba (PYE)",
  "Villa Panamericana, Cuba (VPN)",
  "Ensenachos, Cuba (ES1)",
  "Club Amigo Carisol los Corales, Cuba (CL2)",
  "Viñales, Cuba (VIÑ)",
  "Nueva Gerona, Cuba (GER)",
  "Holguin, Cuba (HOG)",
  "La Habana, Cuba (HAV)",
  "Cayo Largo Del Sur, Cuba (CYO)",
  "Camaguey, Cuba (CMW)",
  "Cienfuegos, Cuba (CFG)",
  "Cayo Coco, Cuba (CCC)",
  "Ciego De Avila, Cuba (AVI)",
  "Manzanillo, Cuba (MZO)",
  "Maio, Cabo Verde (MMO)",
  "Santo Antao, Cabo Verde (NTO)",
  "Praia, Cabo Verde (RAI)",
  "Boa Vista, Cabo Verde (BVC)",
  "Brava, Cabo Verde (BVR)",
  "Sao Vicente, Cabo Verde (VXE)",
  "Sao Filipe, Cabo Verde (SFL)",
  "Sao Nicolau, Cabo Verde (SNE)",
  "Ilha Do Sal, Cabo Verde (SID)",
  "Ercan, Chipre (ECN)",
  "Paphos, Chipre (PFO)",
  "Larnaca, Chipre (LCA)",
  "Marianske Lazne, Republica Checa (MKA)",
  "Karlovy Vary, Republica Checa (KLV)",
  "Pardubice, Republica Checa (PED)",
  "Praga, Republica Checa (PRG)",
  "Ostrava, Republica Checa (OSR)",
  "Brno, Republica Checa (BRQ)",
  "Braunschweig, Alemania (BWE)",
  "Bayreuth, Alemania (BYU)",
  "Bremerhaven, Alemania (BRV)",
  "Bremenhaven, Alemania (BRE)",
  "Bonn, Alemania (BNJ)",
  "Colonia/Bonn, Alemania (CGN)",
  "Barth, Alemania (BBH)",
  "Bitburg, Alemania (BBJ)",
  "Berlin, Alemania (BER)",
  "Bielefeld, Alemania (BFE)",
  "Wangerooge, Alemania (AGE)",
  "Aachen, Alemania (AAH)",
  "Altenburg, Alemania (AOC)",
  "Dusseldorf, Alemania (DUS)",
  "Dortmund, Alemania (DTM)",
  "Eisenach, Alemania (EIB)",
  "Friedrichshafen, Alemania (FDH)",
  "Flensburg, Alemania (FLF)",
  "Karlsruhe Baden Baden, Alemania (FKB)",
  "Essen, Alemania (ESS)",
  "Erfurt, Alemania (ERF)",
  "Dresde, Alemania (DRS)",
  "Heringsdorf, Alemania (HDF)",
  "Heide Buesum, Alemania (HEI)",
  "Heidelberg, Alemania (HDB)",
  "Helgoland, Alemania (HGL)",
  "Hamburgo, Alemania (HAM)",
  "Hanover, Alemania (HAJ)",
  "Westerland, Alemania (GWT)",
  "Gutersloh, Alemania (GUT)",
  "Hof De, Alemania (HOQ)",
  "Guettin, Alemania (GTI)",
  "Muenster, Alemania (FMO)",
  "Fritzlar, Alemania (FRZ)",
  "Frankfurt, Alemania (FRA)",
  "Nuremberg, Alemania (NUE)",
  "Munich, Alemania (MUC)",
  "Rothenburg, Alemania (QTK)",
  "Wurzburg, Alemania (QWU)",
  "Mainz, Alemania (QMZ)",
  "Freiburg, Alemania (QFB)",
  "Straubing, Alemania (RBM)",
  "Everglades, Alemania (PEF)",
  "Paderborn, Alemania (PAD)",
  "Kiel, Alemania (KEL)",
  "Kaiserslautern, Alemania (KLT)",
  "Kassel, Alemania (KSF)",
  "Mannheim Germany, Alemania (MHG)",
  "Luebeck, Alemania (LBC)",
  "Lahr, Alemania (LHA)",
  "Leipzig, Alemania (LEJ)",
  "Stuttgart, Alemania (STR)",
  "Siegen, Alemania (SGE)",
  "Saarbruecken, Alemania (SCN)",
  "Rostock Laage, Alemania (RLG)",
  "Ramstein, Alemania (RMS)",
  "Wiesbaden, Alemania (UWE)",
  "Wilhelmshaven, Alemania (WVN)",
  "Berchtesgaden, Alemania (ZCE)",
  "Weimar, Alemania (ZWM)",
  "Schwerin, Alemania (ZSR)",
  "Garmisch Prtnkrch, Alemania (ZEI)",
  "Baden Baden, Alemania (ZCC)",
  "Regensburg, Alemania (ZPM)",
  "Trier, Alemania (ZQF)",
  "Wolfsburg, Alemania (ZQU)",
  "Magdeburg, Alemania (ZMG)",
  "Gunzburg, Alemania (FMM)",
  "Yibuti, Djibouti (JIB)",
  "Karup, Dinamarca (KRP)",
  "Odense, Dinamarca (ODE)",
  "Copenhague, Dinamarca (CPH)",
  "Faeroe Islands, Dinamarca (FAE)",
  "Esbjerg, Dinamarca (EBJ)",
  "Aalborg, Dinamarca (AAL)",
  "Aarhus, Dinamarca (AAR)",
  "Billund, Dinamarca (BLL)",
  "Vejle, Dinamarca (VEJ)",
  "Thisted, Dinamarca (TED)",
  "Bornholm, Dinamarca (RNN)",
  "Roskilde, Dinamarca (RKE)",
  "Sonderborg, Dinamarca (SGD)",
  "Skrydstrup, Dinamarca (SKS)",
  "Santa Lucia, Dominica (SLU)",
  "Canovan Island, Dominica (CIW)",
  "Dominica, Dominica (DOM)",
  "Montserrat, Dominica (MNI)",
  "Puerto Plata, Republica Dominicana (POP)",
  "Punta Cana, Republica Dominicana (PUJ)",
  "La Romana, Republica Dominicana (LRM)",
  "Barahona, Republica Dominicana (BRX)",
  "Samana, Republica Dominicana (AZS)",
  "Santiago, Republica Dominicana (STI)",
  "Santo Domingo, Republica Dominicana (SDQ)",
  "Villa Trópico, Republica Dominicana (VTR)",
  "Villa Guajimico, Republica Dominicana (VGJ)",
  "Villa El Abra / Jibacoa, Republica Dominicana (JBC)",
  "Playa Esmeralda, Republica Dominicana (PE1)",
  "Pinares de Mayarí, Republica Dominicana (PM1)",
  "Cayo Santa Maria, Republica Dominicana (ST1)",
  "Campismo Arco Iris, Republica Dominicana (AC2)",
  "Caibarién, Republica Dominicana (CB2)",
  "LAS TERRENAS, Republica Dominicana (LT1)",
  "Cardenas, Republica Dominicana (CDN)",
  "Campismo Rio La Mula, Republica Dominicana (RLM)",
  "Campismo Caleton Blanco, Republica Dominicana (CCB)",
  "Ancon, Republica Dominicana (ACN)",
  "Aguas Claras, Republica Dominicana (AGC)",
  "Wajay, Republica Dominicana (WJY)",
  "Villa Maguana, Republica Dominicana (VMG)",
  "Rio San Juan, Republica Dominicana (RSJ)",
  "Uvero Alto , Republica Dominicana (UVA)",
  "Moron, Republica Dominicana (MRN)",
  "Matanzas, Republica Dominicana (MTZ)",
  "Maria La Gorda, Republica Dominicana (MGO)",
  "Marea del Portillo, Republica Dominicana (MPO)",
  "La Moka, Republica Dominicana (MOK)",
  "La Guabina, Republica Dominicana (GUN)",
  "Las Yagrumas, Republica Dominicana (LYG)",
  "Guamá, Republica Dominicana (GNM)",
  "Gran Piedra, Republica Dominicana (GPD)",
  "Elguea, Republica Dominicana (ELG)",
  "El Salton, Republica Dominicana (SLT)",
  "Sosúa, Republica Dominicana (D02)",
  "Playa Dorada, Republica Dominicana (D01)",
  "Cabarete, Republica Dominicana (D03)",
  "Playa Larga, Republica Dominicana (PLG)",
  "Playa Girón, Republica Dominicana (PGI)",
  "San José del Lagos, Republica Dominicana (SJL)",
  "Río Canimar, Republica Dominicana (RCA)",
  "Juan Dolio, Republica Dominicana (A12)",
  "Boca Chica, Republica Dominicana (AR6)",
  "Bayahibe, Republica Dominicana (BYE)",
  "Skikda, Algeria (SKI)",
  "Annaba, Algeria (AAE)",
  "Argel, Algeria (ALG)",
  "Constantine, Algeria (CZL)",
  "Ghardaia, Algeria (GHA)",
  "Oran, Algeria (ORN)",
  "Manta, Ecuador (MEC)",
  "Galapagos Is, Ecuador (GPS)",
  "Guayaquil, Ecuador (GYE)",
  "Cuenca, Ecuador (CUE)",
  "Esmeraldas, Ecuador (ESM)",
  "Shell Mera, Ecuador (PTZ)",
  "Alamor, Ecuador (AL1)",
  "Alangasi, Ecuador (AL2)",
  "Alausi, Ecuador (AL3)",
  "Alluriquin, Ecuador (QUI)",
  "Aloag, Ecuador (AL4)",
  "Amaguaña, Ecuador (AGM)",
  "Ambato, Ecuador (ATF)",
  "Ambuqui, Ecuador (AM1)",
  "Ancon, Ecuador (AN1)",
  "Andrade, Ecuador (AD1)",
  "Arajuno, Ecuador (AA1)",
  "Archidona, Ecuador (AA2)",
  "Arenillas, Ecuador (AA3)",
  "Atacames, Ecuador (AT1)",
  "Atahualpa, Ecuador (AT2)",
  "Atuntaqui, Ecuador (AT3)",
  "Azogues, Ecuador (ZOG)",
  "Baba, Ecuador (BA1)",
  "Babahoyo, Ecuador (BA2)",
  "Baeza, Ecuador (BA3)",
  "Bahia De Caraquez, Ecuador (BA4)",
  "Balao, Ecuador (BA5)",
  "Balsas, Ecuador (BA6)",
  "Balzar, Ecuador (BA7)",
  "Baños, Ecuador (BA8)",
  "Biblian, Ecuador (BI1)",
  "Bolívar, Ecuador (BO1)",
  "Borbón, Ecuador (BO2)",
  "Cajabamba, Ecuador (CA1)",
  "Calceta, Ecuador (CA2)",
  "Calderon, Ecuador (CA3)",
  "Caluma, Ecuador (CA4)",
  "Cañar, Ecuador (CA5)",
  "Cariamanga, Ecuador (CA6)",
  "Carlos Julio Arosemena Tola, Ecuador (CA7)",
  "Cascales, Ecuador (CA8)",
  "Catacocha, Ecuador (CA9)",
  "Catamayo, Ecuador (C10)",
  "Catarama, Ecuador (C11)",
  "Cayambe, Ecuador (C12)",
  "Celica, Ecuador (C13)",
  "Cevallos, Ecuador (C14)",
  "Chaguarpamba, Ecuador (C15)",
  "Chambo, Ecuador (C16)",
  "Chantillin, Ecuador (C17)",
  "Chilla, Ecuador (C18)",
  "Chillanes, Ecuador (C19)",
  "Chinchipe, Ecuador (C20)",
  "Chone, Ecuador (C21)",
  "Chunchi, Ecuador (C22)",
  "Colimes, Ecuador (C23)",
  "Colta, Ecuador (C24)",
  "Conocoto, Ecuador (C25)",
  "Cotacachi, Ecuador (C26)",
  "Cumandá, Ecuador (C27)",
  "Cumbaya, Ecuador (C28)",
  "Cuyabeno, Ecuador (C29)",
  "Daule, Ecuador (DA1)",
  "Duran, Ecuador (DU1)",
  "Echeandía, Ecuador (ECE)",
  "El Carmen, Ecuador (C30)",
  "El Chaco, Ecuador (C31)",
  "El Corazón, Ecuador (C32)",
  "El Empalme, Ecuador (EM2)",
  "El Guabo, Ecuador (GU1)",
  "El Quinche, Ecuador (GU2)",
  "El Triunfo, Ecuador (ET1)",
  "Eloy Alfaro, Ecuador (EA1)",
  "Espindola, Ecuador (EA2)",
  "Flavio Alfaro, Ecuador (FA1)",
  "Girón, Ecuador (GI1)",
  "Gonzalo Pizarro, Ecuador (GP1)",
  "Gonzanama, Ecuador (GO1)",
  "Guamote, Ecuador (GU3)",
  "Guano, Ecuador (GU4)",
  "Guaranda, Ecuador (GU5)",
  "Guayllabamba, Ecuador (GU6)",
  "Guaytacama, Ecuador (GU7)",
  "Huaca, Ecuador (HU1)",
  "Huaquillas, Ecuador (HU2)",
  "Huigra, Ecuador (HU3)",
  "Ibarra, Ecuador (IB1)",
  "Isabela, Ecuador (IS1)",
  "Izamba, Ecuador (IZ1)",
  "Jama, Ecuador (JA1)",
  "Jipijapa, Ecuador (JIP)",
  "Julio, Ecuador (JU1)",
  "Junin, Ecuador (JNI)",
  "La Asunción, Ecuador (LA1)",
  "La Concordia, Ecuador (LC1)",
  "La Independencia, Ecuador (LI1)",
  "La Joya De Los Sachas, Ecuador (LJ1)",
  "La Libertad, Ecuador (LJ2)",
  "La Magdalena, Ecuador (LM1)",
  "La Mana, Ecuador (LM2)",
  "La Merced, Ecuador (LM3)",
  "La Paz, Ecuador (LP1)",
  "La Troncal, Ecuador (LP2)",
  "La Unión, Ecuador (LU1)",
  "Las Naves, Ecuador (LN1)",
  "Lasso, Ecuador (LA2)",
  "Latacunga, Ecuador (LTX)",
  "Limon Indanza, Ecuador (LI2)",
  "Limones, Ecuador (LI3)",
  "Loja, Ecuador (LOH)",
  "Loreto, Ecuador (LO1)",
  "Luz De América, Ecuador (LU2)",
  "Macara, Ecuador (MRR)",
  "Macas, Ecuador (XMS)",
  "Machachi, Ecuador (MC1)",
  "Machala, Ecuador (MCH)",
  "Marcabeli, Ecuador (MA2)",
  "Mera, Ecuador (ME1)",
  "Milagro, Ecuador (MI1)",
  "Mindo, Ecuador (MI2)",
  "Mira, Ecuador (MI3)",
  "Mocha, Ecuador (MO2)",
  "Montalvo, Ecuador (MO3)",
  "Montecristi, Ecuador (MO4)",
  "Muisne, Ecuador (MU1)",
  "Mulalo, Ecuador (MU2)",
  "Nabon, Ecuador (NA1)",
  "Nangaritza, Ecuador (NA2)",
  "Naranjal, Ecuador (NA3)",
  "Naranjito, Ecuador (NA4)",
  "Nayon, Ecuador (NA5)",
  "Nueva Loja, Ecuador (NU1)",
  "Nuevo Rocafuerte, Ecuador (NU2)",
  "Otavalo, Ecuador (OT1)",
  "Pajan, Ecuador (PA2)",
  "Palestina, Ecuador (PA3)",
  "Pallatanga, Ecuador (PA4)",
  "Palora, Ecuador (PA5)",
  "Pasaje, Ecuador (PA6)",
  "Pastocalle, Ecuador (PA7)",
  "Patate, Ecuador (PA8)",
  "Paute, Ecuador (PA9)",
  "Pedernales, Ecuador (PDZ)",
  "Pedro Carbo, Ecuador (PE3)",
  "Penipe, Ecuador (PE4)",
  "Pichincha, Ecuador (PI1)",
  "Pifo, Ecuador (PI2)",
  "Pillaro, Ecuador (PI3)",
  "Pimampiro, Ecuador (PI4)",
  "Pindal, Ecuador (PI5)",
  "Pintag, Ecuador (PI6)",
  "Piñas, Ecuador (PI7)",
  "Playas, Ecuador (PL1)",
  "Poalo, Ecuador (PO2)",
  "Pomasqui, Ecuador (PO3)",
  "Portovelo, Ecuador (PO4)",
  "Portoviejo, Ecuador (PVO)",
  "Pucara, Ecuador (PU1)",
  "Puebloviejo, Ecuador (PU2)",
  "Puembo, Ecuador (PU3)",
  "Puerto Ayora, Ecuador (PU4)",
  "Puerto Baquerizo Moreno, Ecuador (PU5)",
  "Puerto Bolivar, Ecuador (PU6)",
  "Puerto Lopez, Ecuador (PU7)",
  "Puerto Quito, Ecuador (PU8)",
  "Pujili, Ecuador (PU9)",
  "Pusuqui, Ecuador (P10)",
  "Putumayo, Ecuador (PYO)",
  "Puyo, Ecuador (P11)",
  "Quero, Ecuador (QU1)",
  "Quevedo, Ecuador (QU2)",
  "Quilanga, Ecuador (QU3)",
  "Quininde, Ecuador (QU4)",
  "Quisapincha, Ecuador (QU5)",
  "Riobamba, Ecuador (RI1)",
  "Rioverde, Ecuador (RI2)",
  "Rocafuerte, Ecuador (RO1)",
  "Salcedo, Ecuador (SA3)",
  "Samborondon, Ecuador (SA4)",
  "Same Casablanca, Ecuador (SA5)",
  "San Andres, Ecuador (SA6)",
  "San Antonio De Ibarra, Ecuador (SA7)",
  "San Antonio De Pichincha, Ecuador (SA8)",
  "San Fernando, Ecuador (FDO)",
  "San Gabriel, Ecuador (SA9)",
  "San José De Chimbo, Ecuador (S10)",
  "San Juan, Ecuador (S11)",
  "San Lorenzo, Ecuador (S12)",
  "San Miguel, Ecuador (NMG)",
  "San Miguel De Urcuqui, Ecuador (S13)",
  "San Pablo, Ecuador (S14)",
  "San Rafael, Ecuador (S15)",
  "San Vicente, Ecuador (S16)",
  "Sangolquí, Ecuador (S17)",
  "Santa Ana, Ecuador (S18)",
  "Santa Clara, Ecuador (S19)",
  "Santa Cruz, Ecuador (S20)",
  "Santa Elena, Ecuador (S21)",
  "Santa Isabel, Ecuador (S22)",
  "Santa Lucia, Ecuador (S23)",
  "Santa Rosa, Ecuador (S24)",
  "Santo Domingo, Ecuador (S26)",
  "Santo Domingo de los Colorados, Ecuador (S27)",
  "Saquisili, Ecuador (S28)",
  "Saraguro, Ecuador (S29)",
  "Shell, Ecuador (S30)",
  "Shushufindi, Ecuador (S31)",
  "Sigchos, Ecuador (S32)",
  "Sigsig, Ecuador (S33)",
  "Sozoranga, Ecuador (S34)",
  "SuaTonsupa, Ecuador (S35)",
  "Sucua, Ecuador (S36)",
  "Sucumbios, Ecuador (S37)",
  "Tababela, Ecuador (TA1)",
  "Tabacundo, Ecuador (TA2)",
  "Tambillo, Ecuador (TA3)",
  "Tanicuchi, Ecuador (TA4)",
  "Taura, Ecuador (TA5)",
  "Tena, Ecuador (TE1)",
  "Tisaleo, Ecuador (TI1)",
  "Toacaso, Ecuador (TO1)",
  "Tonchigüé, Ecuador (TO2)",
  "Tosagua, Ecuador (TO3)",
  "Tulcan, Ecuador (TUA)",
  "Tumbabiro, Ecuador (TU1)",
  "Tumbaco, Ecuador (TU2)",
  "Urbina Jado, Ecuador (UR1)",
  "Valencia, Ecuador (VA1)",
  "Valle Hermoso, Ecuador (VA2)",
  "Veinticuatro De Mayo, Ecuador (VE1)",
  "Ventanas, Ecuador (VE2)",
  "Yacuambi, Ecuador (YA1)",
  "Yaguachi, Ecuador (YA2)",
  "Yantzaza, Ecuador (YA3)",
  "Yaruqui, Ecuador (YA4)",
  "Zamora, Ecuador (ZMM)",
  "Zapotillo, Ecuador (ZA1)",
  "Zaruma, Ecuador (ZA2)",
  "Pedro Vicente Maldonado, Ecuador (P18)",
  "Vinces, Ecuador (VI2)",
  "Montañita, Ecuador (AR5)",
  "Salinas, Ecuador (AR4)",
  "Punta Centinela, Ecuador (A03)",
  "Coca, Ecuador (OCC)",
  "Lago Agrio, Ecuador (LGQ)",
  "San Cristobal, Ecuador (SCY)",
  "Quito, Ecuador (UIO)",
  "Tartu, Estonia (TAY)",
  "Tallinn, Estonia (TLL)",
  "Taba, Egypt (TCP)",
  "Kharga, Egypt (UVL)",
  "Marsa Alam, Egypt (RMF)",
  "Sharm El Sheik, Egypt (SSH)",
  "Dakhla Oasis, Egypt (DAK)",
  "Borg El Arab, Egypt (HBE)",
  "Hurghada, Egypt (HRG)",
  "Alejandria, Egypt (ALY)",
  "Abu Simbel, Egypt (ABS)",
  "Aswan, Egypt (ASW)",
  "Cairo, Egypt (CAI)",
  "Luxor, Egypt (LXR)",
  "Asmara, Eritrea (ASM)",
  "Barcelona, España (BCN)",
  "Bilbao, España (BIO)",
  "Lanzarote, Islas Canarias, España (ACE)",
  "Albacete, España (ABC)",
  "Malaga, España (AGP)",
  "Alicante, España (ALC)",
  "Cádiz, España (CDZ)",
  "Badajoz, España (BJZ)",
  "Gerona, España (GRO)",
  "Granada, España (GRX)",
  "San Sebastian De La Gomera, España (GMZ)",
  "Fuerte Ventura, Islas Canarias, España (FUE)",
  "San Sebastion, España (EAS)",
  "Menorca, España (MAH)",
  "Madrid, España (MAD)",
  "Murcia, España (MJV)",
  "Gran Canaria, Islas Canarias, España (LPA)",
  "Leon, España (LEN)",
  "Almeira, España (LEI)",
  "La Coruña, España (LCG)",
  "Ibiza, España (IBZ)",
  "Oviedo, España (OVD)",
  "Cordoba, España (ODB)",
  "Melilla, España (MLN)",
  "Reus, España (REU)",
  "Marbella, España (QRL)",
  "Palma De Mallorca, España (PMI)",
  "Pamplona, España (PNA)",
  "Santa Cruz, España (SPC)",
  "Sevilla, España (SVQ)",
  "Logroño, España (RJL)",
  "Santiago De Compostera, España (SCQ)",
  "Santander, España (SDR)",
  "Torre Molinos, España (UTL)",
  "Valverde, España (VDE)",
  "Tenerife, Islas Canarias, España (TCI)",
  "Alicante Railway Station, España (YJE)",
  "Zaragoza, España (ZAZ)",
  "Vigo, España (VGO)",
  "Vitoria, España (VIT)",
  "Valencia, España (VLC)",
  "Valladolid, España (VLL)",
  "Jerez De La Frontera, España (XRY)",
  "Toledo, España (XTJ)",
  "San Antonio, España (SN1)",
  "Puerto de la Cruz, España (PCZ)",
  "Barajas, España (BJ1)",
  "Figueretas, España (FU1)",
  "Calella, España (CE5)",
  "Cala Mayor, España (CM5)",
  "Caceres, España (QUQ)",
  "Merida, España (QWX)",
  "Santillana del Mar, España (S38)",
  "Salamanca, España (SLM)",
  "Jimma, Etiopía (JIM)",
  "Dire Dawa, Etiopía (DIR)",
  "Addis Ababa, Etiopía (ADD)",
  "Helsinki, Finlandia (HEL)",
  "Joensuu, Finlandia (JOE)",
  "Ivalo, Finlandia (IVL)",
  "Kokkola, Finlandia (KOK)",
  "Kittila, Finlandia (KTT)",
  "Kuopio, Finlandia (KUO)",
  "Kemi, Finlandia (KEM)",
  "Kajaani, Finlandia (KAJ)",
  "Kuusamo, Finlandia (KAO)",
  "Jyvaskyla, Finlandia (JYV)",
  "Lappeenranta, Finlandia (LPP)",
  "Mikkeli, Finlandia (MIK)",
  "Mariehamn, Finlandia (MHQ)",
  "Pori, Finlandia (POR)",
  "Oulu, Finlandia (OUL)",
  "Laponia, Finlandia (RVI)",
  "Varkaus, Finlandia (VRK)",
  "Ylivieska, Finlandia (YLI)",
  "Tampere, Finlandia (TMP)",
  "Turku, Finlandia (TKU)",
  "Vaasa, Finlandia (VAA)",
  "Rovaniemi, Finlandia (RVN)",
  "Savonlinna, Finlandia (SVL)",
  "Seinajoki, Finlandia (SJY)",
  "Savusavu, Fiji Islands (SVU)",
  "Suva, Fiji Islands (SUV)",
  "Taveuni, Fiji Islands (TVU)",
  "Nadi, Fiji Islands (NAN)",
  "Labasa, Fiji Islands (LBS)",
  "Ba City, Fiji Islands (BFJ)",
  "Mount Pleasant, Islas Malvinas (MPN)",
  "Pohnpei, Micronesia (PNI)",
  "Truk, Micronesia (TKK)",
  "Toulon, Francia (TLN)",
  "Toulouse, Francia (TLS)",
  "Estrasburgo, Francia (SXB)",
  "Sophia Antipolis, Francia (SXD)",
  "Tours, Francia (TUF)",
  "Valence, Francia (VAF)",
  "Quimper, Francia (UIP)",
  "Rouen, Francia (URO)",
  "St Nazaire, Francia (SNR)",
  "Roanne, Francia (RNE)",
  "Rennes, Francia (RNS)",
  "St Brieuc, Francia (SBK)",
  "Cahors, Francia (ZAO)",
  "Arles, Francia (ZAF)",
  "Vannes, Francia (VNE)",
  "Vichy, Francia (VHY)",
  "St Malo, Francia (XSB)",
  "Dunkerque, Francia (XDK)",
  "Menton, Francia (XMT)",
  "Pontoise, Francia (POX)",
  "Paris, Francia (PAR)",
  "Perpignan, Francia (PGF)",
  "Perigueux, Francia (PGX)",
  "Poitiers, Francia (PIS)",
  "Arras, Francia (QRV)",
  "Reims, Francia (RHE)",
  "Rodez, Francia (RDZ)",
  "Rochefort, Francia (RCO)",
  "Amiens, Francia (QAM)",
  "Pau Fr, Francia (PUF)",
  "Propriano, Francia (PRP)",
  "Marsella, Francia (MRS)",
  "Montpellier, Francia (MPL)",
  "Metz, Francia (MZM)",
  "Annecy, Francia (NCY)",
  "Niza, Francia (NCE)",
  "Morlaix, Francia (MXN)",
  "Nantes, Francia (NTE)",
  "Lannion, Francia (LAI)",
  "La Baule, Francia (LBY)",
  "Albi, Francia (LBI)",
  "Lourdes, Francia (LDE)",
  "Le Havre, Francia (LEH)",
  "Limoges, Francia (LIG)",
  "Lille, Francia (LIL)",
  "Le Mans, Francia (LME)",
  "Le Puy, Francia (LPY)",
  "La Rochelle, Francia (LRH)",
  "Lorient, Francia (LRT)",
  "Les Sables, Francia (LSO)",
  "Le Touquet, Francia (LTQ)",
  "Mulhouse, Francia (MLH)",
  "Lyon, Francia (LYS)",
  "St Tropez, Francia (LTT)",
  "Montlucon, Francia (MCU)",
  "Brest, Francia (BES)",
  "Biarritz, Francia (BIQ)",
  "Bastia, Francia (BIA)",
  "Avignon, Francia (AVN)",
  "Aurillac, Francia (AUR)",
  "Agen, Francia (AGF)",
  "Ajaccio, Francia (AJA)",
  "Angouleme, Francia (ANG)",
  "Angers, Francia (ANE)",
  "Burdeos, Francia (BOD)",
  "Brive La Gaill, Francia (BVE)",
  "Beziers, Francia (BZR)",
  "Cholet, Francia (CET)",
  "Cannes, Francia (CEQ)",
  "Cherbourg, Francia (CER)",
  "Clermont Ferrand, Francia (CFE)",
  "Caen, Francia (CFR)",
  "Carcassonne, Francia (CCF)",
  "Chateauroux, Francia (CHR)",
  "Colmar, Francia (CMR)",
  "Calvi, Francia (CLY)",
  "Chambery, Francia (CMF)",
  "Cognac, Francia (CNG)",
  "Gap France, Francia (GAT)",
  "Frejus, Francia (FRJ)",
  "Figari, Francia (FSC)",
  "Nimes, Francia (FNI)",
  "Grenoble, Francia (GNB)",
  "Dijon, Francia (DIJ)",
  "Castres, Francia (DCM)",
  "Deauville, Francia (DOL)",
  "Dieppe, Francia (DPE)",
  "Dinard, Francia (DNR)",
  "Dole, Francia (DLE)",
  "Creil, Francia (CSF)",
  "Calais, Francia (CQF)",
  "Courchevel, Francia (CVF)",
  "Mulhouse Basel, Francia (EAP)",
  "St Etienne, Francia (EBU)",
  "La Roche, Francia (EDM)",
  "Bergerac, Francia (EGC)",
  "Nancy, Francia (ENC)",
  "Epinal, Francia (EPL)",
  "Evreux, Francia (EVX)",
  "Metz Nancy, Francia (ETZ)",
  "Albany, Gabon (ABY)",
  "Libreville, Gabon (LBV)",
  "Franceville Mvengue, Gabon (MVB)",
  "Port Gentil, Gabon (POG)",
  "Papa Westray, Inglaterra (PPW)",
  "Portsmouth, Inglaterra (PME)",
  "Plymouth, Inglaterra (PLH)",
  "Perth, Inglaterra (PSL)",
  "Penzance, Inglaterra (PZE)",
  "Leicester, Inglaterra (QEW)",
  "Bath, Inglaterra (QQX)",
  "York, Inglaterra (QQY)",
  "Newcastle, Inglaterra (NCL)",
  "Sanday, Inglaterra (NDY)",
  "Teesside, Inglaterra (MME)",
  "Manston, Inglaterra (MSE)",
  "Oban, Inglaterra (OBN)",
  "Norwich, Inglaterra (NWI)",
  "North Ronaldsay, Inglaterra (NRL)",
  "Nottingham UK, Inglaterra (NQT)",
  "Newquay, Inglaterra (NQY)",
  "Oxford, Inglaterra (OXF)",
  "Northampton, Inglaterra (ORM)",
  "Leeds, Inglaterra (LBA)",
  "Londres, Inglaterra (LON)",
  "Londonderry, Inglaterra (LDY)",
  "Lands End, Inglaterra (LEQ)",
  "Luton, Inglaterra (LTN)",
  "Lerwick, Inglaterra (LSI)",
  "Liverpool, Inglaterra (LPL)",
  "Manchester, Inglaterra (MAN)",
  "Lydd, Inglaterra (LYX)",
  "Mildenhall, Inglaterra (MHZ)",
  "Kings Lynn, Inglaterra (KNF)",
  "Milton Keynes, Inglaterra (KYN)",
  "Kirkwall, Inglaterra (KOI)",
  "Isles Of Scilly, Inglaterra (ISC)",
  "Ipswich, Inglaterra (IPW)",
  "Jersey, Inglaterra (JER)",
  "Humberside, Inglaterra (HUY)",
  "Islay, Inglaterra (ILY)",
  "Inverness, Inglaterra (INV)",
  "Isle Of Man, Inglaterra (IOM)",
  "Aberdeen, Inglaterra (ABZ)",
  "Alderney, Inglaterra (ACI)",
  "St. Andrews, Inglaterra (ADX)",
  "Birmingham, Inglaterra (BHX)",
  "Belfast, Inglaterra (BFS)",
  "Bury St Edmunds, Inglaterra (BEQ)",
  "Benbecula, Inglaterra (BEB)",
  "Puerto Caldera, Inglaterra (CAL)",
  "Carlisle, Inglaterra (CAX)",
  "Cambridge, Inglaterra (CBG)",
  "Chester, Inglaterra (CEG)",
  "Barrow In Furness, Inglaterra (BWF)",
  "Barra, Inglaterra (BRR)",
  "Bristol, Inglaterra (BRS)",
  "Brighton, Inglaterra (BSH)",
  "Bradford, Inglaterra (BRF)",
  "Bournemouth, Inglaterra (BOH)",
  "Blackpool, Inglaterra (BLK)",
  "Exeter, Inglaterra (EXT)",
  "Fair Isle, Inglaterra (FIE)",
  "Eday, Inglaterra (EOI)",
  "Edimburgo, Inglaterra (EDI)",
  "Coventry, Inglaterra (CVT)",
  "Cardiff, Inglaterra (CWL)",
  "Dornoch, Inglaterra (DOC)",
  "Dundee, Inglaterra (DND)",
  "Doncaster, Inglaterra (DCS)",
  "Gloucester, Inglaterra (GLO)",
  "Glasgow, Inglaterra (GLA)",
  "Fort William, Inglaterra (FWM)",
  "Guernsey, Inglaterra (GCI)",
  "Grimsby, Inglaterra (GSY)",
  "Harrogate, Inglaterra (HRT)",
  "Hatfield, Inglaterra (HTF)",
  "Holyhead, Inglaterra (HLY)",
  "Coll Island, Inglaterra (COL)",
  "Rugby, Inglaterra (XRU)",
  "Berwick Upon Tweed, Inglaterra (XQG)",
  "Preston, Inglaterra (XPT)",
  "Nottingham, Inglaterra (XNM)",
  "Salisbury, Inglaterra (XSR)",
  "Wolverhampton, Inglaterra (XVW)",
  "Stockport, Inglaterra (XVA)",
  "Stevenage, Inglaterra (XVJ)",
  "Wakefield Westgate, Inglaterra (XWD)",
  "Stoke On Trent, Inglaterra (XWH)",
  "Braintree, Inglaterra (WXF)",
  "Wick, Inglaterra (WIC)",
  "Westray, Inglaterra (WRY)",
  "Chesterfield, Inglaterra (ZFI)",
  "Southend, Inglaterra (SEN)",
  "Shetland Islands Area, Inglaterra (SDZ)",
  "Isle Of Skye Hebrides Islands, Inglaterra (SKL)",
  "Southampton, Inglaterra (SOU)",
  "Stronsay, Inglaterra (SOY)",
  "Unst, Inglaterra (UNT)",
  "Tiree, Inglaterra (TRE)",
  "Swindon, Inglaterra (SWI)",
  "Stornoway, Inglaterra (SYY)",
  "Swansea, Inglaterra (SWS)",
  "Sheffield, Inglaterra (SZD)",
  "Granada, Grenada (GND)",
  "Batumi, Georgia (BUS)",
  "Tbilisi, Georgia (TBS)",
  "Cayenne, French Guiana (CAY)",
  "Accra, Ghana (ACC)",
  "Gibraltar, Gibraltar (GIB)",
  "Nuuk, Groenlandia (GOH)",
  "Sisimiut, Groenlandia (JHS)",
  "Aasiaat, Groenlandia (JEG)",
  "Groennedal, Groenlandia (JGR)",
  "Narsaq, Groenlandia (JNS)",
  "Qaqortoq, Groenlandia (JJU)",
  "Ilulissat, Groenlandia (JAV)",
  "Maniitsoq, Groenlandia (JSU)",
  "Alluitsup Paa, Groenlandia (LLU)",
  "Narsarsuaq, Groenlandia (UAK)",
  "Kangerlussuaq, Groenlandia (SFJ)",
  "Banjul, Gambia (BJL)",
  "Conakry, Guinea (CKY)",
  "Saint Martin, Guadeloupe (CCE)",
  "Basse Terre, Guadeloupe (BBR)",
  "La Desirade, Guadeloupe (DSD)",
  "Pointe A Prite, Guadeloupe (PTP)",
  "St Barthelemy, Guadeloupe (SBH)",
  "Malabo, Guinea Ecuatorial (SSG)",
  "Thessaloniki, Grecia (SKG)",
  "Samos, Grecia (SMI)",
  "Rhodes, Grecia (RHO)",
  "Zakynthos, Grecia (ZTH)",
  "Volos, Grecia (VOL)",
  "Santorini, Grecia (JTR)",
  "Preveza, Grecia (PVK)",
  "Paros, Grecia (PAS)",
  "Leros, Grecia (LRS)",
  "Mytilene, Grecia (MJT)",
  "Limnos, Grecia (LXS)",
  "Syros Island, Grecia (JSY)",
  "Thira Island, Grecia (JTI)",
  "Naxos, Grecia (JNX)",
  "Skiathos, Grecia (JSI)",
  "Kos, Grecia (KGS)",
  "Kalamata, Grecia (KLX)",
  "Kastoria, Grecia (KSO)",
  "Kavalla, Grecia (KVA)",
  "Chios, Grecia (JKH)",
  "Mykonos, Grecia (JMK)",
  "Ikaria Island, Grecia (JIK)",
  "Ioannina, Grecia (IOA)",
  "Kefalonia, Grecia (EFL)",
  "Patras, Grecia (GPA)",
  "Heraklion, Grecia (HER)",
  "Alexandroupolis, Grecia (AXD)",
  "Atenas, Grecia (ATH)",
  "Karpathos, Grecia (AOK)",
  "Kerkyra, Grecia (CFU)",
  "Chania, Grecia (CHQ)",
  "Antigua Guatemala, Guatemala (ATG)",
  "Atitlan, Guatemala (ATT)",
  "Guatemala, Guatemala (GUA)",
  "Flores, Guatemala (FRS)",
  "Rio Dulce, Guatemala (LCF)",
  "Puerto Barrios, Guatemala (PBR)",
  "Playa Grande, Guatemala (PKJ)",
  "Retalhuleu, Guatemala (RER)",
  "Tikal, Guatemala (TKM)",
  "Guam, Guam (GUM)",
  "Bissau, Guinea Bissau (OXB)",
  "Georgetown, Guyana (GEO)",
  "Hong Kong, Hong Kong (HKG)",
  "Cauquira, Honduras (CDD)",
  "La Ceiba, Honduras (LCE)",
  "Tegucigalpa, Honduras (TGU)",
  "Tela, Honduras (TEA)",
  "San Pedro Sula, Honduras (SAP)",
  "Roatan, Honduras (RTB)",
  "Comayagua, Honduras (XPL)",
  "Choluteca, Honduras (CH0)",
  "El Progreso, Honduras (A20)",
  "Danli, Honduras (D4N)",
  "Guanaja, Honduras (GJA)",
  "Gracias, Honduras (GAC)",
  "Puerto Lempira, Honduras (PEU)",
  "Puerto Cortés, Honduras (PC3)",
  "Santa Rosa de Copan, Honduras (SDH)",
  "Utila, Honduras (UII)",
  "Tocoa, Honduras (TCF)",
  "Slunj, Croacia (HR3)",
  "Zagreb, Croacia (ZAG)",
  "Zadar, Croacia (ZAD)",
  "Rijeka, Croacia (RJK)",
  "Split, Croacia (SPU)",
  "Pula, Croacia (PUY)",
  "Dubrobvnik, Croacia (DBV)",
  "Cap Haitien, Haiti (CAP)",
  "Port Au Prince, Haiti (PAP)",
  "Budapest, Hungría (BUD)",
  "Saarmelleek, Hungría (SOB)",
  "Solo, Indonesia (SOC)",
  "Sorong, Indonesia (SOQ)",
  "Semarang, Indonesia (SRG)",
  "Surabaya, Indonesia (SUB)",
  "Timika, Indonesia (TIM)",
  "Tanjung Pandan, Indonesia (TJQ)",
  "Bandar Lampung, Indonesia (TKG)",
  "Ujung Pandang, Indonesia (UPG)",
  "Ubud, Indonesia (UBU)",
  "Seminyak, Indonesia (SMN)",
  "Batam, Indonesia (BTH)",
  "Banda Aceh, Indonesia (BTJ)",
  "Biak, Indonesia (BIK)",
  "Balikpapan, Indonesia (BPN)",
  "Cirebon, Indonesia (CBN)",
  "Bali, Indonesia (BAJ)",
  "Bandung, Indonesia (BDO)",
  "Mataram, Indonesia (AMI)",
  "Amahai, Indonesia (AHI)",
  "Jambi, Indonesia (DJB)",
  "Denpasar, Indonesia (DPS)",
  "Cilacap, Indonesia (CXP)",
  "Gunungsitoli, Indonesia (GNS)",
  "Padang, Indonesia (PDG)",
  "Pekanbaru, Indonesia (PKU)",
  "Palembang, Indonesia (PLM)",
  "Menado, Indonesia (MDC)",
  "Medan, Indonesia (MES)",
  "Jakarta, Indonesia (JKT)",
  "Yogjakarta, Indonesia (JOG)",
  "Kerry County, Irlanda (KIR)",
  "Limerick, Irlanda (LMK)",
  "Cork, Irlanda (ORK)",
  "Spiddal, Irlanda (NNR)",
  "Knock, Irlanda (NOC)",
  "Galway, Irlanda (GWY)",
  "Enniskillen, Irlanda (ENK)",
  "Dublin, Irlanda (DUB)",
  "Donegal, Irlanda (CFN)",
  "Sligo, Irlanda (SXL)",
  "Shannon, Irlanda (SNN)",
  "Waterford, Irlanda (WAT)",
  "Wexford, Irlanda (WEX)",
  "Yotvata, Israel (YOT)",
  "Rosh Pina, Israel (RPN)",
  "Tel Aviv, Israel (TLV)",
  "Ovda, Israel (VDA)",
  "Elat, Israel (ETH)",
  "Haifa, Israel (HFA)",
  "Jerusalem, Israel (JRS)",
  "Kiryat Shmona, Israel (KSW)",
  "Kulu, India (KUU)",
  "Jamnagar, India (JGA)",
  "Jodhpur, India (JDH)",
  "Jaipur, India (JAI)",
  "Bagdogra, India (IXB)",
  "Mangalore, India (IXE)",
  "Jammu, India (IXJ)",
  "Madurai, India (IXM)",
  "Aurangabad, India (IXU)",
  "Port Blair, India (IXZ)",
  "Hyderabad, India (HYD)",
  "Lucknow, India (LKO)",
  "Madras, India (MAA)",
  "Nagpur, India (NAG)",
  "Mysore, India (MYQ)",
  "Pune, India (PNQ)",
  "Porbandar, India (PBD)",
  "Patna, India (PAT)",
  "Khajuraho, India (HJR)",
  "Goa, India (GOI)",
  "Diu In, India (DIU)",
  "Delhi, India (DEL)",
  "Kozhikode, India (CCJ)",
  "Calcuta, India (CCU)",
  "Coimbatore, India (CJB)",
  "Kochi, India (COK)",
  "Bombay, India (BOM)",
  "Bangalore, India (BLR)",
  "Agra, India (AGR)",
  "Ahmedabad, India (AMD)",
  "Vadodara, India (BDQ)",
  "Bhuj, India (BHJ)",
  "Bhopal, India (BHO)",
  "Bhubaneswar, India (BBI)",
  "Udaipur, India (UDR)",
  "Thiruvananthapuram, India (TRV)",
  "Tirupati, India (TIR)",
  "Srinagar, India (SXR)",
  "Simla, India (SLV)",
  "Vishakhapatanam, India (VTZ)",
  "Varanasi, India (VNS)",
  "Baghdad, Irak (BGW)",
  "Basra, Irak (BSR)",
  "Yazd, Iran (AZD)",
  "Shahre Kord, Iran (CQD)",
  "Mashad, Iran (MHD)",
  "Isfahan, Iran (IFN)",
  "Kermanshah, Iran (KSH)",
  "Zanjan, Iran (JWN)",
  "Khorramabad, Iran (KHD)",
  "Kerman, Iran (KER)",
  "Shiraz, Iran (SYZ)",
  "Teheran, Iran (THR)",
  "Isafjordur, Islandia (IFJ)",
  "Reykjavyk, Islandia (REK)",
  "Kopasker, Islandia (OPA)",
  "Egilsstadir, Islandia (EGS)",
  "Akureyri, Islandia (AEY)",
  "Alghero, Italia (AHO)",
  "Ancona, Italia (AOI)",
  "Albenga, Italia (ALL)",
  "Bergamo, Italia (BGY)",
  "Brindisi, Italia (BDS)",
  "Cagliari, Italia (CAG)",
  "Bolzano, Italia (BZO)",
  "Bolonia, Italia (BLQ)",
  "Bari, Italia (BRI)",
  "Elba Island, Italia (EBA)",
  "Crotone, Italia (CRV)",
  "Catania, Italia (CTA)",
  "Cuneo, Italia (CUF)",
  "Genoa, Italia (GOA)",
  "Grosseto, Italia (GRS)",
  "San Giovanni Rotondo, Italia (GBN)",
  "Forli, Italia (FRL)",
  "Foggia, Italia (FOG)",
  "Florencia, Italia (FLR)",
  "Olbia, Italia (OLB)",
  "Napoles, Italia (NAP)",
  "Reggio Calabria, Italia (REG)",
  "Padova, Italia (QPA)",
  "Salerno, Italia (QSR)",
  "Varese, Italia (QVA)",
  "Ravenna, Italia (RAN)",
  "Brescia, Italia (QBS)",
  "Pescara, Italia (PSR)",
  "Pisa, Italia (PSA)",
  "Capri, Italia (PRJ)",
  "Perugia, Italia (PEG)",
  "Peschiei, Italia (PEJ)",
  "Palermo, Italia (PMO)",
  "Parma, Italia (PMF)",
  "Ischia, Italia (ISH)",
  "Milan, Italia (MIL)",
  "Lucca, Italia (LCV)",
  "Lecce, Italia (LCC)",
  "Taormina, Italia (TFC)",
  "Taranto, Italia (TAR)",
  "Trieste, Italia (TRS)",
  "Trapani, Italia (TPS)",
  "San Domino Island, Italia (TQR)",
  "Treviso, Italia (TSF)",
  "Tortoli, Italia (TTB)",
  "Udine, Italia (UDN)",
  "Torino, Italia (TRN)",
  "Venecia, Italia (VCE)",
  "Lamezia Terme, Italia (SUF)",
  "Sorrento, Italia (RRO)",
  "Rimini, Italia (RMI)",
  "Roma, Italia (ROM)",
  "Siena, Italia (SAY)",
  "Verona, Italia (VRN)",
  "Vieste, Italia (VIF)",
  "Vicenza, Italia (VIC)",
  "Trento, Italia (ZIA)",
  "La Spezia, Italia (LZ1)",
  "Portofino, Italia (PTF)",
  "Amalfi, Italia (LFI)",
  "Alberobello Bari, Italia (IT3)",
  "Tropea Calabria, Italia (IT2)",
  "Vietri Sul Mare, Italia (SUL)",
  "Positano, Italia (OSI)",
  "Leonardo da Vinci, Italia (FCO)",
  "Praiano, Italia (IAN)",
  "PRATO, Italia (QPR)",
  "Ravello, Italia (ELL)",
  "Runaway Bay, Jamaica (A05)",
  "Port Antonio, Jamaica (PAN)",
  "Tryall, Jamaica (TRY)",
  "Starfish, Jamaica (STF)",
  "Rose Hall, Jamaica (RHL)",
  "Freeport, Jamaica (FRE)",
  "South Coast / Treasure Beach, Jamaica (SCT)",
  "Montego Bay, Jamaica (MBJ)",
  "Kingston, Jamaica (KIN)",
  "Negril, Jamaica (NEG)",
  "Ocho Rios, Jamaica (OCJ)",
  "Maan, Jordan (MPQ)",
  "Petra, Jordan (PE2)",
  "Amman, Jordan (AMM)",
  "Aqaba, Jordan (AQJ)",
  "Aomori, Japón (AOJ)",
  "Asahikawa, Japón (AKJ)",
  "Akita, Japón (AXT)",
  "Amami O Shima, Japón (ASJ)",
  "Fukue, Japón (FUJ)",
  "Fukuoka, Japón (FUK)",
  "Yamagata, Japón (GAJ)",
  "Hiroshima, Japón (HIJ)",
  "Hakodate, Japón (HKD)",
  "Morioka, Japón (HNA)",
  "Saga, Japón (HSG)",
  "Hachijo Jima, Japón (HAC)",
  "Fukushima, Japón (FKS)",
  "Misawa, Japón (MSJ)",
  "Miyako Jima, Japón (MMY)",
  "Matsumoto, Japón (MMJ)",
  "Memambetsu, Japón (MMB)",
  "Matsuyama, Japón (MYJ)",
  "Obihiro, Japón (OBO)",
  "Narita, Japón (NRT)",
  "Nagoya, Japón (NGO)",
  "Nagasaki, Japón (NGS)",
  "Okino Erabu, Japón (OKE)",
  "Okayama, Japón (OKJ)",
  "Oshima, Japón (OIM)",
  "Oita, Japón (OIT)",
  "Okinawa, Japón (OKA)",
  "Odate Noshiro, Japón (ONJ)",
  "Osaka, Japón (OSA)",
  "Niigata, Japón (KIJ)",
  "Kochi, Japón (KCZ)",
  "Miyazaki, Japón (KMI)",
  "Kumamoto, Japón (KMJ)",
  "Komatsu, Japón (KMQ)",
  "Kita Kyushu, Japón (KKJ)",
  "Kagoshima, Japón (KOJ)",
  "Kushiro, Japón (KUH)",
  "Izumo, Japón (IZO)",
  "Ishigaki, Japón (ISG)",
  "Iwami, Japón (IWJ)",
  "Yokohama, Japón (YOK)",
  "Wakkanai, Japón (WKJ)",
  "Yonago, Japón (YGJ)",
  "Sendai, Japón (SDJ)",
  "Nakashibetsu, Japón (SHB)",
  "Sapporo, Japón (SPK)",
  "Kume Jima, Japón (UEO)",
  "Kyoto, Japón (UKY)",
  "Tokio, Japón (TYO)",
  "Ube Jp, Japón (UBJ)",
  "Tsushima, Japón (TSJ)",
  "Tottori, Japón (TTJ)",
  "Takamatsu, Japón (TAK)",
  "Shonai, Japón (SYO)",
  "Tokunoshima, Japón (TKN)",
  "Tokushima, Japón (TKS)",
  "Tanega Shima, Japón (TNE)",
  "Toyama, Japón (TOY)",
  "Samburu, Kenya (UAS)",
  "Kisumu, Kenya (KIS)",
  "Mombasa, Kenya (MBA)",
  "Lokichoggio, Kenya (LKG)",
  "Nyeri, Kenya (NYE)",
  "Nanyuki, Kenya (NYK)",
  "Nairobi, Kenya (NBO)",
  "Malindi, Kenya (MYD)",
  "Mara Lodges, Kenya (MRE)",
  "Eldoret, Kenya (EDL)",
  "Bishkek, Kyrgyzstan (FRU)",
  "Phnom Penh, Cambodia (PNH)",
  "Siem Reap, Cambodia (REP)",
  "Maiana, Kiribati (MNK)",
  "Tarawa, Kiribati (TRW)",
  "Moroni, Comoros (YVA)",
  "St Kitts, St. Kitts - Nevis (SKB)",
  "Nevis, St. Kitts - Nevis (NEV)",
  "Busan, Corea del Sur (PUS)",
  "Kunsan, Corea del Sur (KUV)",
  "Kwangju, Corea del Sur (KWJ)",
  "Pohang, Corea del Sur (KPO)",
  "Chinju, Corea del Sur (HIN)",
  "Jeju City, Corea del Sur (CJU)",
  "Cheongju, Corea del Sur (CJJ)",
  "Sokcho, Corea del Sur (SHO)",
  "Seul, Corea del Sur (SEL)",
  "Yeosu, Corea del Sur (RSU)",
  "Ulsan, Corea del Sur (USN)",
  "Daegu, Corea del Sur (TAE)",
  "Daejeon, Corea del Sur (QTW)",
  "Kuwait, Kuwait (KWI)",
  "Little Cayman, Islas Cayman (LYB)",
  "Grand Cayman Island, Islas Cayman (GCM)",
  "Cayman Brac, Islas Cayman (CYB)",
  "Shimkent, Kazakstan (CIT)",
  "Almaty, Kazakstan (ALA)",
  "Ust Kamenogorsk, Kazakstan (UKK)",
  "Astana, Kazakstan (TSE)",
  "Vientiane, Rep. de Lao (VTE)",
  "Beirut, Líbano (BEY)",
  "Santa Lucia, Saint Lucia (UVF)",
  "Sigiriya, Sri Lanka (GIU)",
  "Colombo, Sri Lanka (CMB)",
  "Monrovia, Liberia (MLW)",
  "Sinoe, Liberia (SNI)",
  "Maseru, Lesotho (MSU)",
  "Lesobeng, Lesotho (LES)",
  "Kaunas, Lithuania (KUN)",
  "Klaipeda, Lithuania (KLJ)",
  "Palanga, Lithuania (PLQ)",
  "Vilnius, Lithuania (VNO)",
  "Luxemburgo, Luxemburgo (LUX)",
  "Liepaja, Latvia (LPX)",
  "Daugavpils, Latvia (DGP)",
  "Riga, Latvia (RIX)",
  "Tobruk, Libia (TOB)",
  "Tripoli, Libia (TIP)",
  "Benghazi, Libia (BEN)",
  "Al Hoceima, Marruecos (AHU)",
  "Agadir, Marruecos (AGA)",
  "Casablanca, Marruecos (CAS)",
  "Fez Ma, Marruecos (FEZ)",
  "El Aaiun, Marruecos (EUN)",
  "Essaouira, Marruecos (ESU)",
  "Ourzazate, Marruecos (OZZ)",
  "Marrakech, Marruecos (RAK)",
  "Rabat, Marruecos (RBA)",
  "Nador, Marruecos (NDR)",
  "Oujda, Marruecos (OUD)",
  "Tanger, Marruecos (TNG)",
  "Dakhla, Marruecos (VIL)",
  "Monte Carlo, Monaco (MCM)",
  "Chisinau, Moldova (KIV)",
  "Moldovia, Moldova (MV8)",
  "Tamatave, Madagascar (TMM)",
  "Antananarivo, Madagascar (TNR)",
  "Tulear, Madagascar (TLE)",
  "Saint Marie, Madagascar (SMS)",
  "Majunga, Madagascar (MJN)",
  "Nossi Be, Madagascar (NOS)",
  "Morondava, Madagascar (MOQ)",
  "Majuro, Marshall Islands (MAJ)",
  "Kwajalein, Marshall Islands (KWA)",
  "Bikini Atoll, Marshall Islands (BII)",
  "Ohrid, Macedonia (OHD)",
  "Skopje, Macedonia (SKP)",
  "Mopti, Mali (MZI)",
  "Bamako, Mali (BKO)",
  "Heho, Myanmar (HEH)",
  "Nyaung, Myanmar (NYU)",
  "Yangon, Myanmar (RGN)",
  "Mandalay, Myanmar (MDL)",
  "Ulan Bator, Mongolia (ULN)",
  "Macau, Macau (MFM)",
  "Tinian, Marianna Islands (TIQ)",
  "Saipan, Marianna Islands (SPN)",
  "Rota, Marianna Islands (ROP)",
  "Fort De France, Martinique (FDF)",
  "Nouakchott, Mauritania (NKC)",
  "Nouadhibou, Mauritania (NDB)",
  "Malta, Malta (MLA)",
  "Gozo, Malta (GZM)",
  "Mauricio, Mauritius (MRU)",
  "Rodrigues Island, Mauritius (RRG)",
  "Male, Maldives (MLE)",
  "Lilongwe, Malawi (LLW)",
  "Blantyre, Malawi (BLZ)",
  "Chelinda, Malawi (CEH)",
  "Ciudad Obregón, México (CEN)",
  "Ciudad Del Carmen, México (CME)",
  "Ciudad Juárez, México (CJS)",
  "Cordoba, México (CO1)",
  "Chignahuapan, México (CP1)",
  "Campeche, México (CPE)",
  "Colima, México (CLQ)",
  "León, México (BJX)",
  "Bahia De Los Angeles, México (BHL)",
  "Barrancas del Cobre, México (BC1)",
  "Apatzingan, México (AZG)",
  "Aguascalientes, México (AGU)",
  "Acapulco, México (ACA)",
  "Guaymas, México (GYM)",
  "Hermosillo, México (HMO)",
  "Huejotzingo, México (HP2)",
  "Huamantla, México (HT2)",
  "Guadalajara, México (GDL)",
  "Grutas de Cacahuamilpa, México (GG2)",
  "Guanajuato, México (GMO)",
  "Ensenada, México (ESE)",
  "El Oro, México (EM1)",
  "Durango, México (DGO)",
  "Celestin, México (CY1)",
  "Coatepec, México (CV2)",
  "Cozumel, México (CZM)",
  "Chichen Itza, México (CZA)",
  "Chihuahua, México (CUU)",
  "Cuernavaca, México (CVJ)",
  "Ciudad Victoria, México (CVM)",
  "Ciudad Constitucion, México (CUA)",
  "Culiacán, México (CUL)",
  "Cancún, México (CUN)",
  "Chetumal, México (CTM)",
  "Lagos De Moreno, México (LOM)",
  "Monclova, México (LOV)",
  "Los Mochis, México (LMM)",
  "Loreto, México (LTO)",
  "Merida, México (MID)",
  "Ciudad de México, México (MEX)",
  "Matamoros, México (MAM)",
  "Lázaro Cárdenas, México (LZC)",
  "La Paz, México (LAP)",
  "Jalcomulco, México (JV3)",
  "Ixtepec, México (IZT)",
  "Xalapa, México (JAL)",
  "Isla Mujeres, México (ISJ)",
  "Holbox, México (IH1)",
  "Huatulco, México (HUX)",
  "Morelia, México (MLM)",
  "Ciudad Mante, México (MMC)",
  "Mazatlán, México (MZT)",
  "Mexicali, México (MXL)",
  "Minatitlan, México (MTT)",
  "Monterrey, México (MTY)",
  "Nogales, México (NOG)",
  "Oaxaca, México (OAX)",
  "Nuevo Laredo, México (NLD)",
  "Otongo, México (OT2)",
  "Real del Monte, México (RH1)",
  "Reynosa, México (REX)",
  "Coatzacoalcos, México (QTZ)",
  "Queretaro, México (QRO)",
  "Puerto Vallarta, México (PVR)",
  "Papantla, México (PV4)",
  "Puerto Escondido, México (PXM)",
  "Palenque, México (PQM)",
  "Pachuca, México (PC1)",
  "Poza Rica, México (PAZ)",
  "Puebla, México (PBC)",
  "Piedras Negras, México (PDS)",
  "Playa del Carmen, México (PCM)",
  "Puerto Penasco, México (PPE)",
  "Pinotepa Nacional, México (PNO)",
  "Riviera Nayarit, México (RNA)",
  "Riviera Maya  Tulum, México (RM4)",
  "San Felipe, México (SFH)",
  "San miguel de Allende, México (SG2)",
  "San Jose Iturbide, México (SG3)",
  "Salina Cruz, México (SCX)",
  "Santa Rosalia, México (SRL)",
  "San Juan del Rio, México (SQ2)",
  "San Luis Potosí, México (SLP)",
  "Saltillo, México (SLW)",
  "San Quintin, México (SNQ)",
  "San José del Cabo, México (SJD)",
  "Tijuana, México (TIJ)",
  "Tuxtla Gutiérrez, México (TGZ)",
  "Toluca, México (TLC)",
  "Tlalpujahua, México (TM1)",
  "Tapachula, México (TAP)",
  "San Cristobal De Las Casas, México (SZT)",
  "Tehuacan, México (TCN)",
  "Taxco, México (TG1)",
  "Tierra Blanca, México (TG4)",
  "Tampico, México (TAM)",
  "Uruapan, México (UPN)",
  "Torreón, México (TRC)",
  "Tequisquiapan, México (TQ1)",
  "Tepic, México (TPQ)",
  "Tlaxcala, México (TT1)",
  "San Luis Rio Colorado, México (UAC)",
  "Tepotzotlan, México (TZ9)",
  "Corredor Turistico, México (CTR)",
  "Puerto Vallarta Zona 4, México (VA4)",
  "Ixtapa, México (ZIH)",
  "Zacatecas, México (ZCL)",
  "Manzanillo, México (ZLO)",
  "Zacatlán, México (ZP3)",
  "Silao, México (SL1)",
  "Celaya, México (CL1)",
  "Irapuato, México (IP1)",
  "Puerto Morelos, México (PT2)",
  "Xpu Ha, México (XH1)",
  "Puerto Aventuras, México (PT3)",
  "Ciudad Valles, México (CV1)",
  "Valladolid, México (VL1)",
  "Bacalar, México (BC2)",
  "Creel, México (CR1)",
  "El Fuerte, México (FR1)",
  "Posadas Barrancas, México (PB1)",
  "Uayamon, México (UA1)",
  "Cholula, México (CH1)",
  "Ciudad Madero, México (CM1)",
  "Copper Canyon, México (CC1)",
  "El Tajin, México (TJ1)",
  "Salamanca, México (SL2)",
  "Patzcuaro, México (PT4)",
  "Uxmal, México (UX1)",
  "Villa Constitucion, México (VIB)",
  "Veracruz, México (VER)",
  "Valle de Bravo, México (VM2)",
  "Villahermosa, México (VSA)",
  "Alamos, México (XAL)",
  "Xico, México (XV1)",
  "Sonora, México (M17)",
  "Tangolunda, México (M15)",
  "Tula de Allende, México (M01)",
  "Tixkokob, México (M20)",
  "Tlaquepaque, México (M02)",
  "Temozón, México (M13)",
  "Teotihuacán, México (TE2)",
  "Tepatitlán de Morelos, México (M21)",
  "Túxpam de Rodríguez Cano, México (M22)",
  "Zapopan, México (M06)",
  "Zihuatanejo, México (M07)",
  "Tecate, México (TCT)",
  "Punta Mita, México (M04)",
  "Sayulita, México (M18)",
  "San Pedro Garza García, México (M10)",
  "San José del Cabo, México (M08)",
  "Gomez Palacio, México (M14)",
  "Mahahual, México (M09)",
  "Los Cabos, México (M05)",
  "Kohunlich, México (M03)",
  "Paraíso, México (M11)",
  "Naucalpan, México (M19)",
  "Chiapas, México (CI1)",
  "Akumal, México (AK5)",
  "Nuevo Vallarta, México (NVR)",
  "Puerto Vallarta Zona 3, México (PV3)",
  "Cozumel Zona 3, México (CZ3)",
  "Cozumel Zona 2, México (CZ2)",
  "Cozumel Zona 1, México (CZ1)",
  "Cabo San Lucas, México (A06)",
  "Costa Mujeres, México (CMJ)",
  "Apodaca, México (M12)",
  "Bucerías, México (M16)",
  "Tawau, Malasia (TWU)",
  "Kuala Terengganu, Malasia (TGG)",
  "Tioman, Malasia (TOD)",
  "Sandakan, Malasia (SDK)",
  "Sibu, Malasia (SBW)",
  "Pangkor, Malasia (PKG)",
  "Penang, Malasia (PEN)",
  "Marudi, Malasia (MUR)",
  "Miri, Malasia (MYY)",
  "Ipoh, Malasia (IPH)",
  "Johor Bahru, Malasia (JHB)",
  "Kuching, Malasia (KCH)",
  "Kota Bharu, Malasia (KBR)",
  "Kuala Lumpur, Malasia (KUL)",
  "Kuantan, Malasia (KUA)",
  "Kerteh, Malasia (KTE)",
  "Lawas, Malasia (LWY)",
  "Malacca, Malasia (MKZ)",
  "Mukah, Malasia (MKM)",
  "Limbang, Malasia (LMN)",
  "Long Akah, Malasia (LKH)",
  "Langkawi, Malasia (LGK)",
  "Labuan, Malasia (LBU)",
  "Lahad Datu, Malasia (LDU)",
  "Alor Setar, Malasia (AOR)",
  "Kota Kinabalu, Malasia (BKI)",
  "Nampula, Mozambique (APL)",
  "Beira, Mozambique (BEW)",
  "Maputo, Mozambique (MPM)",
  "Tete, Mozambique (TET)",
  "Vilanculos, Mozambique (VNX)",
  "Windhoek, Namibia (WDH)",
  "Walvis Bay, Namibia (WVB)",
  "Rosh Pina, Namibia (RHN)",
  "Noumea, New Caledonia (NOU)",
  "Lifou, New Caledonia (LIF)",
  "Koumac, New Caledonia (KOC)",
  "Ile Des Pins, New Caledonia (ILP)",
  "Niamey, Niger (NIM)",
  "Port Harcourt, Nigeria (PHC)",
  "Kano, Nigeria (KAN)",
  "Lagos, Nigeria (LOS)",
  "Abuja, Nigeria (ABV)",
  "Managua, Nicaragua (MGA)",
  "Bluefields Región Autónoma Atlántico Sur, Nicaragua (BEF)",
  "Bocao, Nicaragua (OA9)",
  "Masaya, Nicaragua (MY9)",
  "Matagalpa, Nicaragua (MT9)",
  "Ocotal, Nicaragua (OCT)",
  "Leon, Nicaragua (LN9)",
  "Juigalpa, Nicaragua (JGP)",
  "Jinotega, Nicaragua (JN9)",
  "Jinotepe, Nicaragua (JI9)",
  "Granada, Nicaragua (GN9)",
  "EstelÍ, Nicaragua (ET9)",
  "Chinandega, Nicaragua (CH9)",
  "San Juan del Sur Rivas, Nicaragua (SJN)",
  "San Carlos, Nicaragua (NCR)",
  "Rivas, Nicaragua (ECI)",
  "Puerto Cabezas Región Autónoma Atlántico Norte, Nicaragua (PUZ)",
  "Somoto, Nicaragua (OM9)",
  "Uden, Holanda (UDE)",
  "Utrecht, Holanda (UTC)",
  "Rotterdam, Holanda (RTM)",
  "Leiden, Holanda (LID)",
  "Lelystad, Holanda (LEY)",
  "Maastricht, Holanda (MST)",
  "Amsterdam, Holanda (AMS)",
  "Eindhoven, Holanda (EIN)",
  "Enschede, Holanda (ENS)",
  "Groningen, Holanda (GRQ)",
  "La Haya, Holanda (HAG)",
  "Hammerfest, Noruega (HFT)",
  "Haugesund, Noruega (HAU)",
  "Orsta Volda, Noruega (HOV)",
  "Hamar, Noruega (HMR)",
  "Gol City, Noruega (GLL)",
  "Floro, Noruega (FRO)",
  "Harstad Narvik, Noruega (EVE)",
  "Forde, Noruega (FDE)",
  "Geilo, Noruega (DLD)",
  "Alta, Noruega (ALF)",
  "Andenes, Noruega (ANX)",
  "Aalesund, Noruega (AES)",
  "Bardufoss, Noruega (BDU)",
  "Bergen, Noruega (BGO)",
  "Bronnoysund, Noruega (BNN)",
  "Bodo, Noruega (BOO)",
  "Mo I Rana, Noruega (MQN)",
  "Molde, Noruega (MOL)",
  "Notodden, Noruega (NTB)",
  "Narvik, Noruega (NVK)",
  "Oslo, Noruega (OSL)",
  "Namsos, Noruega (OSY)",
  "Maloy, Noruega (QFQ)",
  "Lakselv, Noruega (LKL)",
  "Leknes, Noruega (LKN)",
  "Mehamn, Noruega (MEH)",
  "Mosjoen, Noruega (MJF)",
  "Longyearbyen, Noruega (LYR)",
  "Kirkenes, Noruega (KKN)",
  "Kristiansund, Noruega (KSU)",
  "Kristiansand, Noruega (KRS)",
  "Honningsvag, Noruega (HVG)",
  "Roros, Noruega (RRS)",
  "Roervik, Noruega (RVK)",
  "Sandane, Noruega (SDN)",
  "Skien, Noruega (SKE)",
  "Stokmarknes, Noruega (SKN)",
  "Sogndal, Noruega (SOG)",
  "Stord, Noruega (SRP)",
  "Sandnessjoen, Noruega (SSJ)",
  "Svolvaer, Noruega (SVJ)",
  "Stavanger, Noruega (SVG)",
  "Fagernes, Noruega (VDB)",
  "Vardoe, Noruega (VAW)",
  "Trondheim, Noruega (TRD)",
  "Tromso, Noruega (TOS)",
  "Vadso, Noruega (VDS)",
  "Lille Hammer, Noruega (XXL)",
  "Steinkjer, Noruega (XKJ)",
  "Fauske, Noruega (ZXO)",
  "Katmandu, Nepal (KTM)",
  "Pokhara, Nepal (PKR)",
  "Phaplu, Nepal (PPL)",
  "Nauru Island, Nauru (INU)",
  "Niue Island, Niue (IUE)",
  "Invercargill, Nueva Zelanda (IVC)",
  "Kerikeri, Nueva Zelanda (KKE)",
  "Kaitaia, Nueva Zelanda (KAT)",
  "Milford Sound, Nueva Zelanda (MFN)",
  "Paraparaumu, Nueva Zelanda (PPQ)",
  "Palmerston, Nueva Zelanda (PMR)",
  "Picton, Nueva Zelanda (PCN)",
  "Nelson, Nueva Zelanda (NSN)",
  "Oamaru, Nueva Zelanda (OAM)",
  "Napier Hastings, Nueva Zelanda (NPE)",
  "New Plymouth, Nueva Zelanda (NPL)",
  "Mount Cook, Nueva Zelanda (MON)",
  "Masterton, Nueva Zelanda (MRO)",
  "Christchurch, Nueva Zelanda (CHC)",
  "Coromandel, Nueva Zelanda (CMV)",
  "Blenheim, Nueva Zelanda (BHE)",
  "Auckland, Nueva Zelanda (AKL)",
  "Dunedin, Nueva Zelanda (DUD)",
  "Great Barrier Island, Nueva Zelanda (GBZ)",
  "Gisborne, Nueva Zelanda (GIS)",
  "Hamilton, Nueva Zelanda (HLZ)",
  "Hokitika, Nueva Zelanda (HKK)",
  "Queenstown, Nueva Zelanda (ZQN)",
  "Wanganui, Nueva Zelanda (WAG)",
  "Whangarei, Nueva Zelanda (WRE)",
  "Wellington, Nueva Zelanda (WLG)",
  "Wanaka, Nueva Zelanda (WKA)",
  "Whakatane, Nueva Zelanda (WHK)",
  "Westport, Nueva Zelanda (WSZ)",
  "Thames, Nueva Zelanda (TMZ)",
  "Timaru, Nueva Zelanda (TIU)",
  "Te Anau, Nueva Zelanda (TEU)",
  "Tauranga, Nueva Zelanda (TRG)",
  "Taupo, Nueva Zelanda (TUO)",
  "Rotorua, Nueva Zelanda (ROT)",
  "Sur Om, Omán (SUH)",
  "Salalah, Omán (SLL)",
  "Muscat, Omán (MCT)",
  "Panamá, Panamá (PTY)",
  "David, Panamá (DAV)",
  "Changuinola, Panamá (CHX)",
  "Bocas Del Toro, Panamá (BOC)",
  "Colon, Panamá (ONX)",
  "Panamá Playa, Panamá (A07)",
  "Playa Blanca, Panamá (AML)",
  "Playa Bonita, Panamá (A02)",
  "Mancora-Talara, Peru (A13)",
  "Mancora-Piura, Peru (MCA)",
  "Aguas Calientes, Peru (AG1)",
  "Jaen, Peru (JAE)",
  "Alerta, Peru (ALD)",
  "Bellavista, Peru (BLP)",
  "Chimbote, Peru (CHM)",
  "Iberia, Peru (IBP)",
  "Quince Mil, Peru (UMI)",
  "Rioja, Peru (RIJ)",
  "Rodriguez de Mendoza  , Peru (RIM)",
  "Santa Maria, Peru (SMG)",
  "Shiringayoc, Peru (SYC)",
  "Tingo Maria, Peru (TGI)",
  "San Juan, Peru (SJA)",
  "Juanjui, Peru (JJI)",
  "Yurimaguas, Peru (YMS)",
  "Valle Sagrado, Peru (P3N)",
  "Atalaya, Peru (AYX)",
  "Nazca, Peru (NZC)",
  "Saposoa, Peru (SQU)",
  "Vichayito-Piura, Peru (VCH)",
  "Vichayito-Talara , Peru (VC2)",
  "Puno, Peru (P1N)",
  "Paracas, Peru (PR9)",
  "Nazca, Peru (P2N)",
  "Andahuaylas, Peru (ANS)",
  "Huaraz, Peru (ATA)",
  "Cajamarca, Peru (CJA)",
  "Chachapoyas, Peru (CHH)",
  "Pisco, Peru (PIO)",
  "Ayacucho, Peru (AYP)",
  "Jauja, Peru (JAU)",
  "Ilo, Peru (ILQ)",
  "Moyobamba, Peru (MBP)",
  "Tacna, Peru (TCQ)",
  "Talara, Peru (TYL)",
  "Pacasmayo, Peru (PA1)",
  "San Roman, Peru (SA2)",
  "Ica, Peru (ICA)",
  "Trujillo, Peru (TRU)",
  "Tarapoto, Peru (TPP)",
  "Tumbes, Peru (TBP)",
  "Chiclayo, Peru (CIX)",
  "Arequipa, Peru (AQP)",
  "Cusco, Peru (CUZ)",
  "Huanuco, Peru (HUU)",
  "Pucalpa, Peru (PCL)",
  "Puerto Maldonado, Peru (PEM)",
  "Piura, Peru (PIU)",
  "Lima, Peru (LIM)",
  "Juliaca, Peru (JUL)",
  "Iquitos, Peru (IQT)",
  "Papeete, French Polynesia (PPT)",
  "Raiatea, French Polynesia (RFP)",
  "Rangiroa Island, French Polynesia (RGI)",
  "Moorea, French Polynesia (MOZ)",
  "Huahine, French Polynesia (HUH)",
  "Atuona, French Polynesia (AUQ)",
  "Bora Bora, French Polynesia (BOB)",
  "Tikehau, French Polynesia (TIH)",
  "Tari, Papua Nueva Guinea (TIZ)",
  "Tububil, Papua Nueva Guinea (TBG)",
  "Vanimo, Papua Nueva Guinea (VAI)",
  "Wewak, Papua Nueva Guinea (WWK)",
  "Aragip, Papua Nueva Guinea (ARP)",
  "Hoskins, Papua Nueva Guinea (HKN)",
  "Mt Hagen, Papua Nueva Guinea (HGU)",
  "Alotau, Papua Nueva Guinea (GUR)",
  "Goroka, Papua Nueva Guinea (GKA)",
  "Rabaul, Papua Nueva Guinea (RAB)",
  "Port Moresby, Papua Nueva Guinea (POM)",
  "Kokoro, Papua Nueva Guinea (KOR)",
  "Kavieng, Papua Nueva Guinea (KVG)",
  "Lae Pg, Papua Nueva Guinea (LAE)",
  "Lihir Island, Papua Nueva Guinea (LNV)",
  "Manus Island, Papua Nueva Guinea (MAS)",
  "Mendi, Papua Nueva Guinea (MDU)",
  "Madang, Papua Nueva Guinea (MAG)",
  "Kalibo, Filipinas (KLO)",
  "Ilo, Filipinas (ILO)",
  "Puerto Princesa, Filipinas (PPS)",
  "Manila, Filipinas (MNL)",
  "Davao, Filipinas (DVO)",
  "Cebu, Filipinas (CEB)",
  "Cagayan, Filipinas (CGY)",
  "Baguio, Filipinas (BAG)",
  "Angeles Mabalacat, Filipinas (CRK)",
  "Tacloban, Filipinas (TAC)",
  "San Fernando, Filipinas (SFE)",
  "Subic Bay, Filipinas (SFS)",
  "Sialkot, Pakistan (SKT)",
  "Turbat, Pakistan (TUK)",
  "Nawabshah, Pakistan (WNS)",
  "Gilgit, Pakistan (GIL)",
  "Hyderabad, Pakistan (HDD)",
  "Peshawar, Pakistan (PEW)",
  "Islamabad, Pakistan (ISB)",
  "Karachi, Pakistan (KHI)",
  "Mohenjodaro, Pakistan (MJD)",
  "Lahore, Pakistan (LHE)",
  "Lodz, Polonia (LCJ)",
  "Lublinek, Polonia (LLK)",
  "Katowice, Polonia (KTW)",
  "Krakow, Polonia (KRK)",
  "Zielona, Polonia (IEG)",
  "Poznan, Polonia (POZ)",
  "Olsztyn, Polonia (QYO)",
  "Gdansk, Polonia (GDN)",
  "Bydgoszcz, Polonia (BZG)",
  "Wroclaw, Polonia (WRO)",
  "Varsovia, Polonia (WAW)",
  "Szczecin, Polonia (SZZ)",
  "Rzeszow, Polonia (RZE)",
  "Gaza, Palestina (GZA)",
  "Horta, Islas Azores, Portugal (HOR)",
  "Santa Cruz Flores, Portugal (FLW)",
  "Funchal Isla Madeira, Portugal (FNC)",
  "Graciosa Island, Portugal (GRW)",
  "Faro, Portugal (FAO)",
  "Corvo Island, Portugal (CVU)",
  "Coimbra, Portugal (CBP)",
  "Porto Santo, Isla Madera, Portugal (PXO)",
  "Portimao, Portugal (PRM)",
  "Pico Island, Portugal (PIX)",
  "Pointe Delgado, Azores, Portugal (PDL)",
  "Oporto, Portugal (OPO)",
  "Lisboa, Portugal (LIS)",
  "Sao Jorge Island, Portugal (SJZ)",
  "Santa Maria, Portugal (SMA)",
  "Terceira, Islas Azores, Portugal (TER)",
  "Vila Real, Portugal (VRL)",
  "Evora, Portugal (EVO)",
  "Albufeira, Portugal (AFE)",
  "Cascais, Portugal (CSC)",
  "Carvoeiro, Portugal (CVR)",
  "Óbidos, Portugal (OB5)",
  "Obidos, Portugal (OB1)",
  "Lamego, Portugal (NEJ)",
  "Viseu, Portugal (VSE)",
  "Sintra, Portugal (SI1)",
  "Koror, Palau (ROR)",
  "Vallemi, Paraguay (VMI)",
  "Fuerte Olimpo, Paraguay (OLK)",
  "Puerto La Victoria, Paraguay (PCJ)",
  "Corinto, Paraguay (CIO)",
  "Asunción, Paraguay (ASU)",
  "Ciudad Del Este, Paraguay (AGT)",
  "Doha, Qatar (DOH)",
  "St Pierre Dela Reunion, Reunion (ZSE)",
  "St. Denis, Isla Reunion, Reunion (RUN)",
  "Sibiu, Rumania (SBZ)",
  "Suceava, Rumania (SCV)",
  "Tirgu Mures, Rumania (TGM)",
  "Tulcea, Rumania (TCE)",
  "Timisoara, Rumania (TSR)",
  "Brasov, Rumania (XHV)",
  "Arad, Rumania (ARW)",
  "Baia Mare, Rumania (BAY)",
  "Constanta, Rumania (CND)",
  "Bucarest, Rumania (BUH)",
  "Oradea, Rumania (OMR)",
  "Iasi, Rumania (IAS)",
  "Yaroslavl, Rusia (IAR)",
  "Irkutsk, Rusia (IKT)",
  "Ivanovo, Rusia (IWA)",
  "Krasnodar, Rusia (KRR)",
  "Samara, Rusia (KUF)",
  "Kazan, Rusia (KZN)",
  "Khabarovsk, Rusia (KHV)",
  "Krasnoyarsk, Rusia (KJA)",
  "Kostroma, Rusia (KMW)",
  "Kaliningrad, Rusia (KGD)",
  "St Petersburg, Rusia (LED)",
  "Omsk, Rusia (OMS)",
  "Novosibirsk, Rusia (OVB)",
  "Nizhnevartovsk, Rusia (NJC)",
  "Naberevnye Chelny, Rusia (NBC)",
  "Moscu, Rusia (MOW)",
  "Murmansk, Rusia (MMK)",
  "Mineralnye Vody, Rusia (MRV)",
  "Perm, Rusia (PEE)",
  "Port Elizabeth, Rusia (PEZ)",
  "Pskov, Rusia (PKV)",
  "Blagoveshchensk, Rusia (BQS)",
  "Chelyabinsk, Rusia (CEK)",
  "Astrakhan, Rusia (ASF)",
  "Arkhangelsk, Rusia (ARH)",
  "Adler Sochi, Rusia (AER)",
  "Anapa, Rusia (AAQ)",
  "Elista, Rusia (ESL)",
  "Belgorod, Rusia (EGO)",
  "Nizhniy Novgorod, Rusia (GOJ)",
  "Magadan, Rusia (GDX)",
  "Chita, Rusia (HTA)",
  "Volgograd, Rusia (VOG)",
  "Vladivostok, Rusia (VVO)",
  "Vologda, Rusia (VGD)",
  "Ulan Ude, Rusia (UUD)",
  "Yuzhno Sakhalinsk, Rusia (UUS)",
  "Kursk, Rusia (URS)",
  "Tyumen, Rusia (TJM)",
  "Tobolsk, Rusia (TOX)",
  "Tomsk, Rusia (TOF)",
  "Syktyvkar, Rusia (SCW)",
  "Saratov, Rusia (RTW)",
  "Rostov, Rusia (ROV)",
  "Ekaterinburg, Rusia (SVX)",
  "Stavropol, Rusia (STW)",
  "Saransk, Rusia (SKX)",
  "Kigali, Rwanda (KGL)",
  "Khamis Mushait, Saudi Arabia (KMX)",
  "King Khalid Military City, Saudi Arabia (KMC)",
  "Jeddah, Saudi Arabia (JED)",
  "Madinah, Saudi Arabia (MED)",
  "Hafr Albatin, Saudi Arabia (HBT)",
  "Hail, Saudi Arabia (HAS)",
  "Gizan, Saudi Arabia (GIZ)",
  "Gassim, Saudi Arabia (ELQ)",
  "Nejran, Saudi Arabia (EAM)",
  "Dammam, Saudi Arabia (DMM)",
  "Dhahran, Saudi Arabia (DHA)",
  "Al Baha, Saudi Arabia (ABT)",
  "Abha, Saudi Arabia (AHB)",
  "Qaisumah, Saudi Arabia (AQI)",
  "Sharurah, Saudi Arabia (SHW)",
  "Riyadh, Saudi Arabia (RUH)",
  "Taif, Saudi Arabia (TIF)",
  "Turaif, Saudi Arabia (TUI)",
  "Tabuk, Saudi Arabia (TUU)",
  "Yanbo, Saudi Arabia (YNB)",
  "Honiara, Solomon Islands (HIR)",
  "Praslin Island, Seychelles Islands (PRI)",
  "Mahe Island, Seychelles Islands (SEZ)",
  "Khartoum, Sudan (KRT)",
  "Karlstad, Suecia (KSD)",
  "Kiruna, Suecia (KRN)",
  "Kramfors, Suecia (KRF)",
  "Skovde, Suecia (KVB)",
  "Kalmar, Suecia (KLR)",
  "Kristianstad, Suecia (KID)",
  "Sodertalje, Suecia (JSO)",
  "Helsingborg, Suecia (JHE)",
  "Jonkoping, Suecia (JKG)",
  "Landskrona, Suecia (JLD)",
  "Lycksele, Suecia (LYC)",
  "Lidkoping, Suecia (LDK)",
  "Lulea, Suecia (LLA)",
  "Linkoping, Suecia (LPI)",
  "Malmo, Suecia (MMA)",
  "Mora, Suecia (MXX)",
  "Norrkoping, Suecia (NRK)",
  "Oskarshamn, Suecia (OSK)",
  "Ostersund, Suecia (OSD)",
  "Orebro Bofors, Suecia (ORB)",
  "Ornskoldsvik, Suecia (OER)",
  "Hultsfred, Suecia (HLF)",
  "Hudiksvall, Suecia (HUV)",
  "Halmstad, Suecia (HAD)",
  "Gavle, Suecia (GVX)",
  "Gotemburgo, Suecia (GOT)",
  "Gallivare, Suecia (GEV)",
  "Eskilstuna, Suecia (EKT)",
  "Sveg, Suecia (EVG)",
  "Arvidsjaur, Suecia (AJR)",
  "Angelholm, Suecia (AGH)",
  "Borlange, Suecia (BLE)",
  "Skelleftea, Suecia (SFT)",
  "Sundsvall, Suecia (SDL)",
  "Ronneby, Suecia (RNB)",
  "Estocolmo, Suecia (STO)",
  "Storuman, Suecia (SQO)",
  "Soderhamn, Suecia (SOO)",
  "Uppsala, Suecia (UPS)",
  "Umea, Suecia (UME)",
  "Visby, Suecia (VBY)",
  "Trollhattan, Suecia (THN)",
  "Vilhelmina, Suecia (VHM)",
  "Vaxjo, Suecia (VXO)",
  "Vasteras, Suecia (VST)",
  "Lund C, Suecia (XGC)",
  "Singapur, Singapur (SIN)",
  "Portoroz, Slovenia (POW)",
  "Ljubljana, Slovenia (LJU)",
  "Maribor, Slovenia (MBX)",
  "Kosice, Slovakia (KSC)",
  "Piestany, Slovakia (PZY)",
  "Bratislava, Slovakia (BTS)",
  "Tatry Poprad, Slovakia (TAT)",
  "Gbangbatok, Sierra Leone (GBK)",
  "Freetown, Sierra Leone (FNA)",
  "Dakar, Senegal (DKR)",
  "Paramaribo, Suriname (PBM)",
  "San Salvador, El Salvador (SAL)",
  "Playas de Oriente, El Salvador (EV_001)",
  "Playas de La Libertad, El Salvador (EV_002)",
  "Ruta de Las Flores, El Salvador (EV_003)",
  "Suchitoto, El Salvador (EV_004)",
  "Golfo de Fonseca La Union, El Salvador (S39)",
  "Latakia, Siria (LTK)",
  "Damasco, Siria (DAM)",
  "Aleppo, Siria (ALP)",
  "Manzini, Swazilandia (MTS)",
  "North Caicos, Turks y Caicos (NCA)",
  "Providenciales, Turks y Caicos (PLS)",
  "Grand Turk, Turks y Caicos (GDT)",
  "Parrot Cay, Turks y Caicos (PIC)",
  "South Caicos, Turks y Caicos (XSC)",
  "N´Djamena, Chad (NDJ)",
  "Lome, Togo (LFW)",
  "Lampang, Tailandia (LPT)",
  "Mae Sot, Tailandia (MAQ)",
  "Nakhon Phanom, Tailandia (KOP)",
  "Krabi, Tailandia (KBV)",
  "Khon Kaen, Tailandia (KKC)",
  "Narathiwat, Tailandia (NAW)",
  "Nakhon Ratchasima, Tailandia (NAK)",
  "Nan Th, Tailandia (NNT)",
  "Nakhon Si Tham, Tailandia (NST)",
  "Phitsanulok, Tailandia (PHS)",
  "Phi Phi, Tailandia (PHZ)",
  "Pattaya, Tailandia (PYX)",
  "Phrae, Tailandia (PRH)",
  "Hat Yai, Tailandia (HDY)",
  "Hua Hin, Tailandia (HHQ)",
  "Mae Hongson, Tailandia (HGN)",
  "Phuket, Tailandia (HKT)",
  "Buri Ram, Tailandia (BFV)",
  "Bangkok, Tailandia (BKK)",
  "Chiang Rai, Tailandia (CEI)",
  "Chiang Mai, Tailandia (CNX)",
  "Chumphon, Tailandia (CJM)",
  "Sakon Nakhon, Tailandia (SNO)",
  "Trat, Tailandia (TDX)",
  "Sukhothai, Tailandia (THS)",
  "U Tapao, Tailandia (UTP)",
  "Udon Thani, Tailandia (UTH)",
  "Koh Samui, Tailandia (USM)",
  "Ranong, Tailandia (UNN)",
  "Surat Thani, Tailandia (URT)",
  "Ubon Ratchath, Tailandia (UBP)",
  "Trang, Tailandia (TST)",
  "Dushanbe, Tajikistan (DYU)",
  "Turkmenabad, Turkmenistan (CRZ)",
  "Ashgabat, Turkmenistan (ASB)",
  "Mary, Turkmenistan (MYP)",
  "Turkmanbashi, Turkmenistan (KRW)",
  "Dashoguz, Turkmenistan (TAZ)",
  "Tabarka, Tunisia (TBJ)",
  "Tozeur, Tunisia (TOE)",
  "Tunez, Tunisia (TUN)",
  "Sfax, Tunisia (SFA)",
  "Monastir, Tunisia (MIR)",
  "Djerba, Tunisia (DJE)",
  "Ha Apai, Tonga (HPA)",
  "Vava U, Tonga (VAV)",
  "Tongatapu, Tonga (TBU)",
  "Dili, East Timor (DIL)",
  "Baucau, East Timor (BCH)",
  "Antalya, Turquía (AYT)",
  "Kayseri, Turquía (ASR)",
  "Ankara, Turquía (ANK)",
  "Adana, Turquía (ADA)",
  "Antioquía, Turquía (4AN )",
  "Capadocia, Turquía (4CD)",
  "Kusadasi, Turquía (4KS)",
  "Kahta, Turquía (4KT)",
  "Mardin, Turquía (4MN)",
  "Pamukkale, Turquía (4PK)",
  "Canakkale, Turquía (CKZ)",
  "Bursa, Turquía (BTZ)",
  "Bodrum, Turquía (BXN)",
  "Balikesir, Turquía (BZI)",
  "Dalaman, Turquía (DLM)",
  "Denizli, Turquía (DNZ)",
  "Diyarbai, Turquía (DIY)",
  "Erzurum, Turquía (ERZ)",
  "Elazig, Turquía (EZS)",
  "Gaziantep, Turquía (GZT)",
  "Sanliurfa Guney, Turquía (GNY)",
  "Konya, Turquía (KYA)",
  "Esmirna, Turquía (IZM)",
  "Estambul, Turquía (IST)",
  "Nevsehir, Turquía (NAV)",
  "Mus Turkey, Turquía (MSR)",
  "Trabzon, Turquía (TZX)",
  "Sabiha Gokcen, Turquía (SAW)",
  "Samsun, Turquía (SSX)",
  "Fethiye-Oludeniz, Turquía (FE1)",
  "Cunupia, Trinidad & Tobago (TB1)",
  "San Fernando, Trinidad & Tobago (TB2)",
  "Tobago, Trinidad & Tobago (TAB)",
  "Puerto España, Isla Madeira, Trinidad & Tobago (POS)",
  "Funafuti, Tuvalu (FUN)",
  "Hengchun, Taiwan (HCN)",
  "Hualien, Taiwan (HUN)",
  "Hsinchun, Taiwan (HSZ)",
  "Makung, Taiwan (MZG)",
  "Kaohsiung, Taiwan (KHH)",
  "Kinmen, Taiwan (KNH)",
  "Matsu, Taiwan (MFK)",
  "Tainan, Taiwan (TNN)",
  "Taichung, Taiwan (TXG)",
  "Taitung, Taiwan (TTT)",
  "Taipei, Taiwan (TPE)",
  "Tanga, Tanzania (TGT)",
  "Zanzibar, Tanzania (ZNZ)",
  "Kilimanjaro, Tanzania (JRO)",
  "Mtwara, Tanzania (MYW)",
  "Mwanza, Tanzania (MWZ)",
  "Dar Es Salaam, Tanzania (DAR)",
  "Arusha, Tanzania (ARK)",
  "Dnepropetrovsk, Ucrania (DNK)",
  "Donetsk, Ucrania (DOK)",
  "Kharkov, Ucrania (HRK)",
  "Odesa, Ucrania (ODS)",
  "Zaporozhe, Ucrania (OZH)",
  "Kiev, Ucrania (IEV)",
  "Ivano Frankovsk, Ucrania (IFO)",
  "Lvov, Ucrania (LWO)",
  "Lugansk, Ucrania (VSG)",
  "Vinnitsa, Ucrania (VIN)",
  "Lutsk, Ucrania (UCK)",
  "Sumy, Ucrania (UMY)",
  "Simferopol, Ucrania (SIP)",
  "Entebbe Kampala, Uganda (EBB)",
  "Midway Island, Islas de EEUU (MDY)",
  "Chicago Midway Apt, Estados Unidos (MDW)",
  "Mason City, Estados Unidos (MCW)",
  "Carbondale, Estados Unidos (MDH)",
  "Merced, Estados Unidos (MCE)",
  "McCook, Estados Unidos (MCK)",
  "Macon, Estados Unidos (MCN)",
  "Orlando, Estados Unidos (ORL)",
  "Mayaguez, Estados Unidos (MAZ)",
  "Manistee, Estados Unidos (MBL)",
  "Saginaw, Estados Unidos (MBS)",
  "Lewiston, Estados Unidos (LWS)",
  "Lewistown, Estados Unidos (LWT)",
  "Lexington, Estados Unidos (LXN)",
  "Greenbrier, Estados Unidos (LWB)",
  "Lawrence, Estados Unidos (LWC)",
  "Lawrence, Estados Unidos (LWM)",
  "Lynchburg, Estados Unidos (LYH)",
  "Ely Mn, Estados Unidos (LYU)",
  "Madera, Estados Unidos (MAE)",
  "Midland, Estados Unidos (MAF)",
  "Minden, Estados Unidos (MEV)",
  "Medford, Estados Unidos (MFR)",
  "Meridian, Estados Unidos (MEI)",
  "Memphis, Estados Unidos (MEM)",
  "Mansfield, Estados Unidos (MFD)",
  "McAllen, Estados Unidos (MFE)",
  "Mesquite, Estados Unidos (MFH)",
  "Marshfield, Estados Unidos (MFI)",
  "Mitchell, Estados Unidos (MHE)",
  "Manhattan, Estados Unidos (MHK)",
  "Manchester, Estados Unidos (MHT)",
  "Mojave, Estados Unidos (MHV)",
  "Michigan City, Estados Unidos (MGC)",
  "Marietta, Estados Unidos (MGE)",
  "Morgantown, Estados Unidos (MGW)",
  "Montgomery, Estados Unidos (MGM)",
  "Moultrie, Estados Unidos (MGR)",
  "Millville, Estados Unidos (MIV)",
  "Marshalltown, Estados Unidos (MIW)",
  "Muncie, Estados Unidos (MIE)",
  "Miami, Estados Unidos (MIA)",
  "Orlando, Estados Unidos (MCO)",
  "Muskogee, Estados Unidos (MKO)",
  "Kansas, Estados Unidos (MKC)",
  "Milwaukee, Estados Unidos (MKE)",
  "Muskegon, Estados Unidos (MKG)",
  "Hoolehua, Estados Unidos (MKK)",
  "Jackson, Estados Unidos (MKL)",
  "Mankato, Estados Unidos (MKT)",
  "Melbourne, Estados Unidos (MLB)",
  "McAlester, Estados Unidos (MLC)",
  "Moline, Estados Unidos (MLI)",
  "Laredo, Estados Unidos (LRD)",
  "Las Cruces, Estados Unidos (LRU)",
  "La Crosse, Estados Unidos (LSE)",
  "Altus, Estados Unidos (LTS)",
  "Livermore, Estados Unidos (LVK)",
  "Livingston, Estados Unidos (LVM)",
  "Laurel, Estados Unidos (LUL)",
  "Kalaupapa, Estados Unidos (LUP)",
  "Lake Jackson, Estados Unidos (LJN)",
  "Klamath Falls, Estados Unidos (LMT)",
  "Lincoln, Estados Unidos (LNK)",
  "London, Estados Unidos (LOZ)",
  "La Porte, Estados Unidos (LPO)",
  "Lopez Island, Estados Unidos (LPS)",
  "Lanai, Estados Unidos (LNY)",
  "Mount Holly, Estados Unidos (LLY)",
  "Lancaster, Estados Unidos (LNS)",
  "Long Beach, Estados Unidos (LGB)",
  "Lufkin, Estados Unidos (LFK)",
  "Lafayette, Estados Unidos (LFT)",
  "Lewiston, Estados Unidos (LEW)",
  "Lexington, Estados Unidos (LEX)",
  "Little Rock, Estados Unidos (LIT)",
  "Lihue, Estados Unidos (LIH)",
  "Logan, Estados Unidos (LGU)",
  "Linden, Estados Unidos (LDJ)",
  "Leesburg, Estados Unidos (LEE)",
  "Lebanon, Estados Unidos (LEB)",
  "Lake Charles, Estados Unidos (LCH)",
  "Laconia, Estados Unidos (LCI)",
  "Lafayette, Estados Unidos (LAF)",
  "Lubbock, Estados Unidos (LBB)",
  "Liberal, Estados Unidos (LBL)",
  "Latrobe, Estados Unidos (LBE)",
  "North Platte, Estados Unidos (LBF)",
  "Lumberton, Estados Unidos (LBT)",
  "Bullhead City, Estados Unidos (IFP)",
  "Kingman, Estados Unidos (IGM)",
  "Killeen, Estados Unidos (ILE)",
  "Wilmington, Estados Unidos (ILG)",
  "Wilmington, Estados Unidos (ILM)",
  "Jacksonville, Estados Unidos (IJX)",
  "Kankakee, Estados Unidos (IKK)",
  "New Haven, Estados Unidos (HVN)",
  "Havre, Estados Unidos (HVR)",
  "Hayward, Estados Unidos (HWD)",
  "Hyannis, Estados Unidos (HYA)",
  "Wichita, Estados Unidos (ICT)",
  "Idaho Falls, Estados Unidos (IDA)",
  "Indiana, Estados Unidos (IDI)",
  "Hayward, Estados Unidos (HYR)",
  "Hays, Estados Unidos (HYS)",
  "Niagara Falls, Estados Unidos (IAG)",
  "Houston, Estados Unidos (HOU)",
  "Iron Mountain, Estados Unidos (IMT)",
  "Indianappolis, Estados Unidos (IND)",
  "International Falls, Estados Unidos (INL)",
  "Winston-Salem, Estados Unidos (INT)",
  "Winslow, Estados Unidos (INW)",
  "Williamsport, Estados Unidos (IPT)",
  "El Centro, Estados Unidos (IPL)",
  "Kissimmee, Estados Unidos (ISM)",
  "Williston, Estados Unidos (ISN)",
  "Kinston, Estados Unidos (ISO)",
  "Islip, Estados Unidos (ISP)",
  "Manistique, Estados Unidos (ISQ)",
  "Wiscasset, Estados Unidos (ISS)",
  "Pasadena, Estados Unidos (JPD)",
  "Juneau, Estados Unidos (JNU)",
  "Joplin, Estados Unidos (JLN)",
  "Sausalito, Estados Unidos (JMC)",
  "Jamestown, Estados Unidos (JMS)",
  "Jacksonville, Estados Unidos (JKV)",
  "Jefferson City, Estados Unidos (JEF)",
  "Jamestown, Estados Unidos (JHW)",
  "Kapalua, Estados Unidos (JHM)",
  "Kirksville, Estados Unidos (IRK)",
  "Sturgis, Estados Unidos (IRS)",
  "Ironwood, Estados Unidos (IWD)",
  "Ithaca, Estados Unidos (ITH)",
  "Hilo, Estados Unidos (ITO)",
  "Jackson, Estados Unidos (JAN)",
  "Jacksonville, Estados Unidos (JAX)",
  "Jonesboro, Estados Unidos (JBR)",
  "Pleasanton, Estados Unidos (JBS)",
  "Jackson, Estados Unidos (JAC)",
  "Inyokern, Estados Unidos (IYK)",
  "Klawock, Estados Unidos (KLW)",
  "Kentland, Estados Unidos (KKT)",
  "Kalskag, Estados Unidos (KLG)",
  "Kansas City, Estados Unidos (KCK)",
  "Johnstown, Estados Unidos (JST)",
  "Kake, Estados Unidos (KAE)",
  "Beloit, Estados Unidos (JVL)",
  "Jackson, Estados Unidos (JXN)",
  "Key Largo, Estados Unidos (KYL)",
  "Lamar, Estados Unidos (LAA)",
  "Laramie, Estados Unidos (LAR)",
  "Las Vegas, Estados Unidos (LAS)",
  "Lawton, Estados Unidos (LAW)",
  "Los Angeles, Estados Unidos (LAX)",
  "Lakeland, Estados Unidos (LAL)",
  "Los Alamos, Estados Unidos (LAM)",
  "Lansing, Estados Unidos (LAN)",
  "Brevig Mission, Estados Unidos (KTS)",
  "Ketchikan, Estados Unidos (KTN)",
  "King Of Prussia, Estados Unidos (KPD)",
  "Hawaiian Big Island, Estados Unidos (KOA)",
  "Kennett, Estados Unidos (KNT)",
  "Oxnard, Estados Unidos (OXR)",
  "Owatonna, Estados Unidos (OWA)",
  "Owensboro, Estados Unidos (OWB)",
  "Norwood, Estados Unidos (OWD)",
  "Worthington, Estados Unidos (OTG)",
  "North Bend, Estados Unidos (OTH)",
  "Ottumwa, Estados Unidos (OTM)",
  "Ancortes, Estados Unidos (OTS)",
  "Kotzebue, Estados Unidos (OTZ)",
  "Oshkosh, Estados Unidos (OSH)",
  "Newport, Estados Unidos (ONP)",
  "Ontario, Estados Unidos (ONT)",
  "Norwalk, Estados Unidos (ORQ)",
  "Oak Harbor, Estados Unidos (ODW)",
  "Vincennes, Estados Unidos (OEA)",
  "Norfolk Nebraska, Estados Unidos (OFK)",
  "Ogallala, Estados Unidos (OGA)",
  "Ogden, Estados Unidos (OGD)",
  "Maui, Estados Unidos (OGG)",
  "Ogdensburg, Estados Unidos (OGS)",
  "Olympia, Estados Unidos (OLM)",
  "Kokomo, Estados Unidos (OKK)",
  "Oklahoma City, Estados Unidos (OKC)",
  "Chicago, Estados Unidos (ORD)",
  "Norfolk Virginia Newport News, Estados Unidos (ORF)",
  "Worcester, Estados Unidos (ORH)",
  "Oneonta, Estados Unidos (ONH)",
  "Nogales, Estados Unidos (OLS)",
  "Columbus, Estados Unidos (OLU)",
  "Omaha, Estados Unidos (OMA)",
  "Nome, Estados Unidos (OME)",
  "Nulato, Estados Unidos (NUL)",
  "Mountain View, Estados Unidos (NUQ)",
  "Nueva York, Estados Unidos (NYC)",
  "Okeechobee, Estados Unidos (OBE)",
  "Jacksonville, Estados Unidos (OAJ)",
  "Oakland, Estados Unidos (OAK)",
  "Ocean Reef, Estados Unidos (OCA)",
  "Ocean City, Estados Unidos (OCE)",
  "Ocala, Estados Unidos (OCF)",
  "Oceanside, Estados Unidos (OCN)",
  "Newport, Estados Unidos (NPT)",
  "Kingsville, Estados Unidos (NQI)",
  "Milton, Estados Unidos (NSE)",
  "Brunswick, Estados Unidos (NHZ)",
  "Marion, Estados Unidos (MWA)",
  "Moses Lake, Estados Unidos (MWH)",
  "Middletown, Estados Unidos (MWO)",
  "Martha S Vineyard, Estados Unidos (MVY)",
  "Mccall, Estados Unidos (MYL)",
  "Mattoon, Estados Unidos (MTO)",
  "Montauk, Estados Unidos (MTP)",
  "Kamuela, Estados Unidos (MUE)",
  "Manitowoc, Estados Unidos (MTW)",
  "Monroeville, Estados Unidos (MVC)",
  "Mt Vernon, Estados Unidos (MVN)",
  "Myrtle Beach, Estados Unidos (MYR)",
  "Marysville, Estados Unidos (MYV)",
  "Fallon, Estados Unidos (NFL)",
  "Massena, Estados Unidos (MSS)",
  "Monticello, Estados Unidos (MSV)",
  "New Orleans, Estados Unidos (MSY)",
  "Marathon, Estados Unidos (MTH)",
  "Montrose, Estados Unidos (MTJ)",
  "Mesa, Estados Unidos (MSC)",
  "Muscle Shoals, Estados Unidos (MSL)",
  "Madison, Estados Unidos (MSN)",
  "Missoula, Estados Unidos (MSO)",
  "Minneapolis, Estados Unidos (MSP)",
  "Monterey, Estados Unidos (MRY)",
  "Martinsburgh, Estados Unidos (MRB)",
  "Columbia, Estados Unidos (MRC)",
  "Marquette, Estados Unidos (MQT)",
  "Smyrna, Estados Unidos (MQY)",
  "McPherson, Estados Unidos (MPR)",
  "Montpelier, Estados Unidos (MPV)",
  "Miles City, Estados Unidos (MLS)",
  "Monroe, Estados Unidos (MLU)",
  "Marshall, Estados Unidos (MML)",
  "Mammoth Lakes, Estados Unidos (MMH)",
  "Morristown, Estados Unidos (MMU)",
  "Mount Pleasant, Estados Unidos (MOP)",
  "Minot, Estados Unidos (MOT)",
  "Mountain Village, Estados Unidos (MOU)",
  "Menominee, Estados Unidos (MNM)",
  "Modesto, Estados Unidos (MOD)",
  "Mobile, Estados Unidos (MOB)",
  "Poughkeepsie, Estados Unidos (POU)",
  "Sherman, Estados Unidos (PNX)",
  "Pensacola, Estados Unidos (PNS)",
  "La Verne, Estados Unidos (POC)",
  "Fort Polk, Estados Unidos (POE)",
  "Poplar Bluff, Estados Unidos (POF)",
  "Pompano Beach, Estados Unidos (PPM)",
  "Presque Isle, Estados Unidos (PQI)",
  "Plymouth, Estados Unidos (PLY)",
  "Branson Point Lookout, Estados Unidos (PLK)",
  "Plattsburgh, Estados Unidos (PLB)",
  "Pellston, Estados Unidos (PLN)",
  "Palmdale, Estados Unidos (PMD)",
  "Ponca City, Estados Unidos (PNC)",
  "Peoria, Estados Unidos (PIA)",
  "St. Petersburgo, Estados Unidos (PIE)",
  "Pocatello, Estados Unidos (PIH)",
  "Pierre, Estados Unidos (PIR)",
  "Paris, Estados Unidos (PHT)",
  "Filadelfia, Estados Unidos (PHL)",
  "Port Huron, Estados Unidos (PHN)",
  "Payson, Estados Unidos (PJB)",
  "Parkersburg, Estados Unidos (PKB)",
  "Pittsburgo, Estados Unidos (PIT)",
  "Phoenix, Estados Unidos (PHX)",
  "Page, Estados Unidos (PGA)",
  "Punta Gorda, Estados Unidos (PGD)",
  "Panamá City, Estados Unidos (PFN)",
  "Newport News, Estados Unidos (PHF)",
  "Pascagoula, Estados Unidos (PGL)",
  "Puerto Progreso, Estados Unidos (PGO)",
  "Greenville, Estados Unidos (PGV)",
  "Pendleton, Estados Unidos (PDT)",
  "Portland, Estados Unidos (PDX)",
  "Pine Bluff, Estados Unidos (PBF)",
  "West Palm Beach, Estados Unidos (PBI)",
  "Everett, Estados Unidos (PAE)",
  "Paducah, Estados Unidos (PAH)",
  "Palo Alto, Estados Unidos (PAO)",
  "Paso Robles, Estados Unidos (PRB)",
  "Prescott, Estados Unidos (PRC)",
  "Philipsburg, Estados Unidos (PSB)",
  "Pasco, Estados Unidos (PSC)",
  "Paris, Estados Unidos (PRX)",
  "Pittsfield, Estados Unidos (PSF)",
  "Petersburg, Estados Unidos (PSG)",
  "Dublin, Estados Unidos (PSK)",
  "Pontiac, Estados Unidos (PTK)",
  "Pittsburg, Estados Unidos (PTS)",
  "Pottstown, Estados Unidos (PTW)",
  "Portsmouth, Estados Unidos (PSM)",
  "Palm Springs, Estados Unidos (PSP)",
  "Petersburg, Estados Unidos (PTB)",
  "Provincetown, Estados Unidos (PVC)",
  "Providence, Estados Unidos (PVD)",
  "Copper Mountain, Estados Unidos (QCE)",
  "Pueblo, Estados Unidos (PUB)",
  "Price, Estados Unidos (PUC)",
  "Pullman, Estados Unidos (PUW)",
  "Provo, Estados Unidos (PVU)",
  "Plainview, Estados Unidos (PVW)",
  "Painesville, Estados Unidos (PVZ)",
  "Portland, Estados Unidos (PWM)",
  "Bremerton, Estados Unidos (PWT)",
  "Racine, Estados Unidos (RAC)",
  "Big Bear City, Estados Unidos (RBF)",
  "Roseburg, Estados Unidos (RBG)",
  "Riverside, Estados Unidos (RAL)",
  "Breckenridge, Estados Unidos (QKB)",
  "Keystone, Estados Unidos (QKS)",
  "Rockford, Estados Unidos (RFD)",
  "Richmond, Estados Unidos (RIC)",
  "Richfield, Estados Unidos (RIF)",
  "Ranger, Estados Unidos (RGR)",
  "Rhinelander, Estados Unidos (RHI)",
  "Roche Harbor, Estados Unidos (RCE)",
  "Redding, Estados Unidos (RDD)",
  "Reading, Estados Unidos (RDG)",
  "Redmond Bend, Estados Unidos (RDM)",
  "Raleigh, Estados Unidos (RDU)",
  "Walterboro, Estados Unidos (RBW)",
  "Rapid City, Estados Unidos (RAP)",
  "Elizabeth City, Estados Unidos (ECG)",
  "Eagle, Estados Unidos (EAA)",
  "Kearney, Estados Unidos (EAR)",
  "Wenatchee, Estados Unidos (EAT)",
  "Eau Claire, Estados Unidos (EAU)",
  "Douglas, Estados Unidos (DUG)",
  "Dubois, Estados Unidos (DUJ)",
  "Detroit, Estados Unidos (DTW)",
  "Dutch Harbor, Estados Unidos (DUT)",
  "Devils Lake, Estados Unidos (DVL)",
  "Davenport, Estados Unidos (DVN)",
  "Doylestown, Estados Unidos (DYL)",
  "Danbury, Estados Unidos (DXR)",
  "Elizabethtown, Estados Unidos (EKX)",
  "El Dorado, Estados Unidos (ELD)",
  "Elkhart, Estados Unidos (EKI)",
  "Elkins, Estados Unidos (EKN)",
  "Elko, Estados Unidos (EKO)",
  "Needles, Estados Unidos (EED)",
  "Keene, Estados Unidos (EEN)",
  "Eagle River, Estados Unidos (EGV)",
  "East Hartford, Estados Unidos (EHT)",
  "Eagle, Estados Unidos (EGE)",
  "Ely Nv, Estados Unidos (ELY)",
  "Elk City, Estados Unidos (ELK)",
  "Elmira, Estados Unidos (ELM)",
  "El Paso, Estados Unidos (ELP)",
  "Kenosha, Estados Unidos (ENW)",
  "Keokuk, Estados Unidos (EOK)",
  "Centralia, Estados Unidos (ENL)",
  "El Monte, Estados Unidos (EMT)",
  "Kenai, Estados Unidos (ENA)",
  "Key West, Estados Unidos (EYW)",
  "Fargo, Estados Unidos (FAR)",
  "Fresno, Estados Unidos (FAT)",
  "Fayetteville, Estados Unidos (FAY)",
  "Forrest City, Estados Unidos (FCY)",
  "Frederick, Estados Unidos (FDK)",
  "Fairbanks, Estados Unidos (FAI)",
  "Fajardo, Estados Unidos (FAJ)",
  "Kalispell, Estados Unidos (FCA)",
  "Franklin, Estados Unidos (FKL)",
  "Fergus Falls, Estados Unidos (FFM)",
  "Ft Huachuca, Estados Unidos (FHU)",
  "Florence, Estados Unidos (FLO)",
  "Flagstaff, Estados Unidos (FLG)",
  "Fort Lauderdale Florida, Estados Unidos (FLL)",
  "Escanaba, Estados Unidos (ESC)",
  "East Sound, Estados Unidos (ESD)",
  "Erie, Estados Unidos (ERI)",
  "Easton, Estados Unidos (ESN)",
  "East Stroudsburg, Estados Unidos (ESP)",
  "West Bend, Estados Unidos (ETB)",
  "Eveleth, Estados Unidos (EVM)",
  "Enterprise, Estados Unidos (ETS)",
  "Eufaula, Estados Unidos (EUF)",
  "Eugene, Estados Unidos (EUG)",
  "Evansville, Estados Unidos (EVV)",
  "New Bedford, Estados Unidos (EWB)",
  "Newton, Estados Unidos (EWK)",
  "New Bern, Estados Unidos (EWN)",
  "Excursion Inlet, Estados Unidos (EXI)",
  "Danville, Estados Unidos (DNV)",
  "Sedalia, Estados Unidos (DMO)",
  "The Dalles, Estados Unidos (DLS)",
  "Dillon, Estados Unidos (DLL)",
  "Dillingham, Estados Unidos (DLG)",
  "Duluth, Estados Unidos (DLH)",
  "Dover, Estados Unidos (DOV)",
  "Destin, Estados Unidos (DSI)",
  "Des Moines, Estados Unidos (DSM)",
  "Del Rio, Estados Unidos (DRT)",
  "Durango, Estados Unidos (DRO)",
  "Dubuque, Estados Unidos (DBQ)",
  "Danville, Estados Unidos (DAN)",
  "Dayton, Estados Unidos (DAY)",
  "Dublin, Estados Unidos (DBN)",
  "Denver, Estados Unidos (DEN)",
  "Defiance, Estados Unidos (DFI)",
  "Dallas, Estados Unidos (DFW)",
  "Decatur, Estados Unidos (DCU)",
  "Dodge City, Estados Unidos (DDC)",
  "Dothan, Estados Unidos (DHN)",
  "Dickinson, Estados Unidos (DIK)",
  "Decatur, Estados Unidos (DEC)",
  "Decorah, Estados Unidos (DEH)",
  "Corpus Christi, Estados Unidos (CRP)",
  "Charleston, Estados Unidos (CRW)",
  "Corinth, Estados Unidos (CRX)",
  "San Luis Obispo, Estados Unidos (CSL)",
  "Clinton, Estados Unidos (CSM)",
  "Carson City, Estados Unidos (CSN)",
  "Casper, Estados Unidos (CPR)",
  "Cape Town, Estados Unidos (CTW)",
  "Columbus, Estados Unidos (CSG)",
  "Columbus, Estados Unidos (CUS)",
  "Clinton, Estados Unidos (CWI)",
  "Calexico, Estados Unidos (CXL)",
  "Conroe, Estados Unidos (CXO)",
  "Cincinati, Estados Unidos (CVG)",
  "Clovis, Estados Unidos (CVN)",
  "Corvallis, Estados Unidos (CVO)",
  "Daytona Beach, Estados Unidos (DAB)",
  "Cheyenne, Estados Unidos (CYS)",
  "Harlingen, Estados Unidos (HRL)",
  "Harrison, Estados Unidos (HRO)",
  "Hastings, Estados Unidos (HSI)",
  "Hot Springs, Estados Unidos (HSP)",
  "Homestead, Estados Unidos (HST)",
  "Huntsville, Estados Unidos (HSV)",
  "Batesville, Estados Unidos (HLB)",
  "White Plains, Estados Unidos (HPN)",
  "Princeville, Estados Unidos (HPV)",
  "East Hampton, Estados Unidos (HTO)",
  "Huntington, Estados Unidos (HTS)",
  "Huntsville, Estados Unidos (HTV)",
  "Humacao, Estados Unidos (HUC)",
  "Terre Haute, Estados Unidos (HUF)",
  "Hutchinson, Estados Unidos (HUT)",
  "Houma, Estados Unidos (HUM)",
  "Hickory, Estados Unidos (HKY)",
  "Holland, Estados Unidos (HLM)",
  "Helena, Estados Unidos (HLN)",
  "Hillsboro, Estados Unidos (HIO)",
  "Blytheville, Estados Unidos (HKA)",
  "Healy Lake, Estados Unidos (HKB)",
  "Hot Springs, Estados Unidos (HOT)",
  "Hobbs, Estados Unidos (HOB)",
  "Homer, Estados Unidos (HOM)",
  "Huron, Estados Unidos (HON)",
  "Hopkinsville, Estados Unidos (HOP)",
  "Huntingburg, Estados Unidos (HNB)",
  "Hoonah, Estados Unidos (HNH)",
  "Honolulu, Estados Unidos (HNL)",
  "Hana, Estados Unidos (HNM)",
  "Haines, Estados Unidos (HNS)",
  "Hattiesburg, Estados Unidos (HBG)",
  "Hayden, Estados Unidos (HDN)",
  "Natchez, Estados Unidos (HEZ)",
  "Hagerstown, Estados Unidos (HGR)",
  "Hartford, Estados Unidos (HFD)",
  "Hawthorne, Estados Unidos (HHR)",
  "Hibbing, Estados Unidos (HIB)",
  "Lake Havasu Cty, Estados Unidos (HII)",
  "Hilton Head, Estados Unidos (HHH)",
  "Gary, Estados Unidos (GYY)",
  "Goodyear, Estados Unidos (GYR)",
  "Harrisburg, Estados Unidos (HAR)",
  "Greenwood, Estados Unidos (GWO)",
  "Glenwood Springs, Estados Unidos (GWS)",
  "Gallup, Estados Unidos (GUP)",
  "Gunnison, Estados Unidos (GUC)",
  "Gulf Shores, Estados Unidos (GUF)",
  "Ft Wayne, Estados Unidos (FWA)",
  "Galena, Estados Unidos (GAL)",
  "Great Bend, Estados Unidos (GBD)",
  "Galesburg, Estados Unidos (GBG)",
  "Fullerton, Estados Unidos (FUL)",
  "Fayetteville, Estados Unidos (FYV)",
  "Gadsden, Estados Unidos (GAD)",
  "Gaithersburg, Estados Unidos (GAI)",
  "Georgetown, Estados Unidos (GED)",
  "Spokane, Estados Unidos (GEG)",
  "Gillette, Estados Unidos (GCC)",
  "Garden City, Estados Unidos (GCK)",
  "Grand Canyon, Estados Unidos (GCN)",
  "Greenville, Estados Unidos (GCY)",
  "Fort Madison, Estados Unidos (FMS)",
  "Fort Myers, Estados Unidos (FMY)",
  "Falmouth, Estados Unidos (FMH)",
  "Farmington, Estados Unidos (FMN)",
  "Fort Pierce, Estados Unidos (FPR)",
  "Ft Collins, Estados Unidos (FNL)",
  "Flint, Estados Unidos (FNT)",
  "Fort Dodge, Estados Unidos (FOD)",
  "Front Royal, Estados Unidos (FRR)",
  "Fairmont, Estados Unidos (FRM)",
  "Friday Harbor, Estados Unidos (FRD)",
  "Farmingdale, Estados Unidos (FRG)",
  "Sioux Falls, Estados Unidos (FSD)",
  "Ft Smith, Estados Unidos (FSM)",
  "Fort Stockton, Estados Unidos (FST)",
  "Ft Worth, Estados Unidos (FTW)",
  "Gulfport, Estados Unidos (GPT)",
  "Grand Rapids, Estados Unidos (GPZ)",
  "Galion, Estados Unidos (GQQ)",
  "Green Bay, Estados Unidos (GRB)",
  "Grand Island, Estados Unidos (GRI)",
  "New London, Estados Unidos (GON)",
  "Gainesville, Estados Unidos (GNV)",
  "Killen, Texas, Estados Unidos (GRK)",
  "Grand Rapids, Estados Unidos (GRR)",
  "Columbus, Estados Unidos (GTR)",
  "Gettysburg, Estados Unidos (GTY)",
  "Great Falls, Estados Unidos (GTF)",
  "Goldsboro, Estados Unidos (GSB)",
  "Greensboro, Estados Unidos (GSO)",
  "Greenville, Estados Unidos (GSP)",
  "Glacier Bay, Estados Unidos (GST)",
  "Grand Junction, Estados Unidos (GJT)",
  "Winter Haven, Estados Unidos (GIF)",
  "Longview, Estados Unidos (GGG)",
  "Glasgow, Estados Unidos (GGW)",
  "Grand Forks, Estados Unidos (GFK)",
  "Glens Falls, Estados Unidos (GFL)",
  "Greenfield, Estados Unidos (GFD)",
  "Gaylord, Estados Unidos (GLR)",
  "Galveston, Estados Unidos (GLS)",
  "Monument Valley, Estados Unidos (GMV)",
  "Gatlinburg, Estados Unidos (GKT)",
  "Goodland, Estados Unidos (GLD)",
  "Gainesville, Estados Unidos (GLE)",
  "Greenville, Estados Unidos (GLH)",
  "Ann Arbor, Estados Unidos (ARB)",
  "Alpena, Estados Unidos (APN)",
  "Napa, Estados Unidos (APC)",
  "Naples, Estados Unidos (APF)",
  "Annapolis, Estados Unidos (ANP)",
  "Aniak, Estados Unidos (ANI)",
  "Altoona, Estados Unidos (AOO)",
  "Lima, Estados Unidos (AOH)",
  "Ainsworth, Estados Unidos (ANW)",
  "Alamosa, Estados Unidos (ALS)",
  "Alamogordo, Estados Unidos (ALM)",
  "Waterloo, Estados Unidos (ALO)",
  "Amarillo, Estados Unidos (AMA)",
  "Walla Walla, Estados Unidos (ALW)",
  "Alexander City, Estados Unidos (ALX)",
  "Ames, Estados Unidos (AMW)",
  "Anaheim , Estados Unidos (ANA)",
  "Anniston, Estados Unidos (ANB)",
  "Anchorage, Estados Unidos (ANC)",
  "Anderson, Estados Unidos (AND)",
  "Atlantic City, Estados Unidos (AIY)",
  "Lake Of The Ozarks, Estados Unidos (AIZ)",
  "King Salmon, Estados Unidos (AKN)",
  "Albany, Estados Unidos (ALB)",
  "Alpine, Estados Unidos (ALE)",
  "Allentown, Estados Unidos (ABE)",
  "Abilene, Estados Unidos (ABI)",
  "Albuquerque, Estados Unidos (ABQ)",
  "Aberdeen, Estados Unidos (ABR)",
  "Nantucket, Estados Unidos (ACK)",
  "Waco, Estados Unidos (ACT)",
  "Eureka, Estados Unidos (ACV)",
  "Magnolia, Estados Unidos (AGO)",
  "Augusta, Estados Unidos (AGS)",
  "Athens, Estados Unidos (AHN)",
  "Alliance, Estados Unidos (AIA)",
  "Anderson, Estados Unidos (AID)",
  "Aiken, Estados Unidos (AIK)",
  "Alexandria, Estados Unidos (AEX)",
  "Albert Lea, Estados Unidos (AEL)",
  "Adrian, Estados Unidos (ADG)",
  "Adak Island, Estados Unidos (ADK)",
  "Ardmore, Estados Unidos (ADM)",
  "Kodiak, Estados Unidos (ADQ)",
  "Ada OK, Estados Unidos (ADT)",
  "Camp Springs, Estados Unidos (ADW)",
  "Nashua, Estados Unidos (ASH)",
  "Marhsall, Estados Unidos (ASL)",
  "Aspen, Estados Unidos (ASE)",
  "Minocqua, Estados Unidos (ARV)",
  "Watertown, Estados Unidos (ART)",
  "Atlanta, Estados Unidos (ATL)",
  "Athens, Estados Unidos (ATO)",
  "Augusta, Estados Unidos (AUG)",
  "Auburn, Estados Unidos (AUO)",
  "Appleton, Estados Unidos (ATW)",
  "Watertown, Estados Unidos (ATY)",
  "Beaver Creek , Estados Unidos (BBC)",
  "Kalamazoo, Estados Unidos (AZO)",
  "Waycross, Estados Unidos (AYS)",
  "Wapakoneta, Estados Unidos (AXV)",
  "Alexandria, Estados Unidos (AXN)",
  "Catalina Island, Estados Unidos (AVX)",
  "Austin, Estados Unidos (AUS)",
  "Wausau, Estados Unidos (AUW)",
  "Aurora, Estados Unidos (AUZ)",
  "Scranton, Estados Unidos (AVP)",
  "Asheville, Estados Unidos (AVL)",
  "Broken Bow, Estados Unidos (BBW)",
  "Blacksburg, Estados Unidos (BCB)",
  "Bryce, Estados Unidos (BCE)",
  "Bedford, Estados Unidos (BED)",
  "Bridgeport, Estados Unidos (BDR)",
  "Bethel, Estados Unidos (BET)",
  "Benton Harbor, Estados Unidos (BEH)",
  "Bradford, Estados Unidos (BFD)",
  "Scottsbluff, Estados Unidos (BFF)",
  "Bullfrog Basin, Estados Unidos (BFG)",
  "Bakersfield, Estados Unidos (BFL)",
  "Beaver Falls, Estados Unidos (BFP)",
  "Bedford, Estados Unidos (BFR)",
  "Beaufort, Estados Unidos (BFT)",
  "Bangor, Estados Unidos (BGR)",
  "Binghamton, Estados Unidos (BGM)",
  "Bar Harbor, Estados Unidos (BHB)",
  "Birmingham, Estados Unidos (BHM)",
  "Block Island, Estados Unidos (BID)",
  "Bishop, Estados Unidos (BIH)",
  "Bismarck, Estados Unidos (BIS)",
  "Bozeman, Estados Unidos (BZN)",
  "Blakely Island, Estados Unidos (BYW)",
  "Brazoria, Estados Unidos (BZT)",
  "Cadillac, Estados Unidos (CAD)",
  "Columbia, Estados Unidos (CAE)",
  "Borrego Springs, Estados Unidos (BXS)",
  "Burley, Estados Unidos (BYI)",
  "Bowling Green, Estados Unidos (BWG)",
  "Baltimore, Estados Unidos (BWI)",
  "Batesville, Estados Unidos (BVX)",
  "Brawley, Estados Unidos (BWC)",
  "Brownwood, Estados Unidos (BWD)",
  "Buffalo, Estados Unidos (BUF)",
  "Burbank, Estados Unidos (BUR)",
  "Bartlesville, Estados Unidos (BVO)",
  "Burlington, Estados Unidos (BTV)",
  "Battle Creek, Estados Unidos (BTL)",
  "Butte, Estados Unidos (BTM)",
  "Baton Rouge, Estados Unidos (BTR)",
  "Blairsville, Estados Unidos (BSI)",
  "Bisbee, Estados Unidos (BSQ)",
  "Billings, Estados Unidos (BIL)",
  "Broomfield, Estados Unidos (BJC)",
  "Bemidji, Estados Unidos (BJI)",
  "Bluefield, Estados Unidos (BLF)",
  "Blythe, Estados Unidos (BLH)",
  "Bellingham, Estados Unidos (BLI)",
  "Beckley, Estados Unidos (BKW)",
  "Brookings, Estados Unidos (BKX)",
  "Bloomington, Estados Unidos (BMG)",
  "Bloomington, Estados Unidos (BMI)",
  "Nashville, Estados Unidos (BNA)",
  "Belleville, Estados Unidos (BLV)",
  "Brainerd, Estados Unidos (BRD)",
  "Barrow, Estados Unidos (BRW)",
  "Brownsville, Estados Unidos (BRO)",
  "Burlington, Estados Unidos (BRL)",
  "Boise, Estados Unidos (BOI)",
  "Boston, Estados Unidos (BOS)",
  "Beaumont, Estados Unidos (BPT)",
  "Brunswick, Estados Unidos (BQK)",
  "Aguadilla, Estados Unidos (BQN)",
  "Clear Lake City, Estados Unidos (CLC)",
  "Carlsbad, Estados Unidos (CLD)",
  "Cleveland, Estados Unidos (CLE)",
  "Callao, Estados Unidos (CLL)",
  "Port Angeles, Estados Unidos (CLM)",
  "Charlotte, Estados Unidos (CLT)",
  "Columbus, Estados Unidos (CLU)",
  "Clarksburg, Estados Unidos (CKB)",
  "Clarksdale, Estados Unidos (CKM)",
  "Clarksville, Estados Unidos (CKV)",
  "El Cajon, Estados Unidos (CJN)",
  "Chico, Estados Unidos (CIC)",
  "Cedar Rapids, Estados Unidos (CID)",
  "Craig, Estados Unidos (CIG)",
  "Chandler, Estados Unidos (CHD)",
  "Charlottesville, Estados Unidos (CHO)",
  "Charleston, Estados Unidos (CHS)",
  "Moab, Estados Unidos (CNY)",
  "Carlsbad, Estados Unidos (CNM)",
  "Houghton, Estados Unidos (CMX)",
  "Sparta, Estados Unidos (CMY)",
  "Columbus, Estados Unidos (CMH)",
  "Champaign, Estados Unidos (CMI)",
  "Colorado Springs, Estados Unidos (COS)",
  "Columbia, Estados Unidos (COU)",
  "Cody, Estados Unidos (COD)",
  "Coeur D Alene, Estados Unidos (COE)",
  "Cocoa Metro Area, Estados Unidos (COI)",
  "Crescent City, Estados Unidos (CEC)",
  "Camden, Estados Unidos (CDH)",
  "Clemson, Estados Unidos (CEU)",
  "Murray, Estados Unidos (CEY)",
  "Cortez, Estados Unidos (CEZ)",
  "Chattanooga, Estados Unidos (CHA)",
  "Cape Girardeau, Estados Unidos (CGI)",
  "Craig, Estados Unidos (CGA)",
  "Colby, Estados Unidos (CBK)",
  "Cumberland, Estados Unidos (CBE)",
  "Council Bluffs, Estados Unidos (CBF)",
  "Akron, Estados Unidos (CAK)",
  "Cedar City, Estados Unidos (CDC)",
  "Chadron, Estados Unidos (CDR)",
  "Cordova, Estados Unidos (CDV)",
  "Caldwell, Estados Unidos (CDW)",
  "Concord, Estados Unidos (CCR)",
  "Sheridan, Estados Unidos (SHR)",
  "San Jose, Estados Unidos (SJC)",
  "Sitka, Estados Unidos (SIT)",
  "Shreveport, Estados Unidos (SHV)",
  "San Angelo, Estados Unidos (SJT)",
  "Sandusky, Estados Unidos (SKY)",
  "Shawnee, Estados Unidos (SNL)",
  "Salinas, Estados Unidos (SNS)",
  "Sidney, Estados Unidos (SNY)",
  "Somerset, Estados Unidos (SME)",
  "Santa Maria, Estados Unidos (SMX)",
  "Santa Ana, Estados Unidos (SNA)",
  "Salina, Estados Unidos (SLN)",
  "Salt Lake City, Estados Unidos (SLC)",
  "Salem, Estados Unidos (SLE)",
  "Saranac Lake, Estados Unidos (SLK)",
  "Saint Cloud, Estados Unidos (STC)",
  "St Paul, Estados Unidos (STP)",
  "St. Louis, Estados Unidos (STL)",
  "St. Croix, Islas Virgenes, Estados Unidos (STX)",
  "Santa Rosa, Estados Unidos (STS)",
  "St. Thomas, Islas Virgenes, Estados Unidos (STT)",
  "Sturgeon Bay, Estados Unidos (SUE)",
  "Stevens Point, Estados Unidos (STE)",
  "Stuart, Estados Unidos (SUA)",
  "Statesville, Estados Unidos (SVH)",
  "Sumter, Estados Unidos (SUM)",
  "Sun Valley, Estados Unidos (SUN)",
  "Fairfield, Estados Unidos (SUU)",
  "Superior, Estados Unidos (SUW)",
  "Sioux City, Estados Unidos (SUX)",
  "Silver City, Estados Unidos (SVC)",
  "Pinehurst, Estados Unidos (SOP)",
  "Spearfish, Estados Unidos (SPF)",
  "Springfield, Estados Unidos (SPI)",
  "Seldovia, Estados Unidos (SOV)",
  "Show Low, Estados Unidos (SOW)",
  "Spencer, Estados Unidos (SPW)",
  "Springdale, Estados Unidos (SPZ)",
  "Wichita Falls, Estados Unidos (SPS)",
  "Santa Ynez, Estados Unidos (SQA)",
  "Sterling, Estados Unidos (SQI)",
  "Sarasota, Estados Unidos (SRQ)",
  "Santa Cruz, Estados Unidos (SRU)",
  "Sault Ste Marie, Estados Unidos (SSM)",
  "St Simons Is, Estados Unidos (SSI)",
  "San Diego, Estados Unidos (SAN)",
  "Sheboygan, Estados Unidos (SBM)",
  "South Bend, Estados Unidos (SBN)",
  "Steamboat Springs, Estados Unidos (SBS)",
  "Prudhoe Bay Deadhorse, Estados Unidos (SCC)",
  "State College, Estados Unidos (SCE)",
  "Scottsdale, Estados Unidos (SCF)",
  "Schenectady, Estados Unidos (SCH)",
  "Salisbury Ocean City, Estados Unidos (SBY)",
  "Santa Barbara, Estados Unidos (SBA)",
  "Louisville, Estados Unidos (SDF)",
  "Sedona, Estados Unidos (SDX)",
  "Sidney, Estados Unidos (SDY)",
  "Stockton, Estados Unidos (SCK)",
  "Sanford, Estados Unidos (SFB)",
  "Seattle, Estados Unidos (SEA)",
  "Sebring, Estados Unidos (SEF)",
  "Stephenville, Estados Unidos (SEP)",
  "San Francisco, Estados Unidos (SFO)",
  "Springfield, Estados Unidos (SFY)",
  "Smithfield, Estados Unidos (SFZ)",
  "Springfield, Estados Unidos (SGF)",
  "Staunton, Estados Unidos (SHD)",
  "Sugar Land, Estados Unidos (SGR)",
  "Stuttgart, Estados Unidos (SGT)",
  "St George, Estados Unidos (SGU)",
  "Skagway, Estados Unidos (SGY)",
  "New Richmond, Estados Unidos (RNH)",
  "Reno, Estados Unidos (RNO)",
  "Roanoke, Estados Unidos (ROA)",
  "Rochester, Estados Unidos (ROC)",
  "Rockport, Estados Unidos (RKP)",
  "Rock Springs, Estados Unidos (RKS)",
  "Rome, Estados Unidos (RMG)",
  "Rockland, Estados Unidos (RKD)",
  "Riverton, Estados Unidos (RIW)",
  "Rifle, Estados Unidos (RIL)",
  "Ruidoso, Estados Unidos (RUI)",
  "Rutland, Estados Unidos (RUT)",
  "Raton, Estados Unidos (RTN)",
  "Roswell, Estados Unidos (ROW)",
  "Ruston, Estados Unidos (RSN)",
  "Rochester, Estados Unidos (RST)",
  "Roanoke Rapids, Estados Unidos (RZZ)",
  "Green River, Estados Unidos (RVR)",
  "Rocky Mount, Estados Unidos (RWI)",
  "Rawlins, Estados Unidos (RWL)",
  "Sparta, Estados Unidos (SAR)",
  "San Antonio, Estados Unidos (SAT)",
  "Savannah, Estados Unidos (SAV)",
  "Sacramento, Estados Unidos (SMF)",
  "Santa Fe, Estados Unidos (SAF)",
  "Unalakleet, Estados Unidos (UNK)",
  "University Oxford, Estados Unidos (UOX)",
  "Quincy, Estados Unidos (UIN)",
  "Waukegan, Estados Unidos (UGN)",
  "New Ulm, Estados Unidos (ULM)",
  "Quakertown, Estados Unidos (UKT)",
  "Ukiah, Estados Unidos (UKI)",
  "Victoria, Estados Unidos (VCT)",
  "Victorville, Estados Unidos (VCV)",
  "Vidalia, Estados Unidos (VDI)",
  "St Augustine, Estados Unidos (UST)",
  "Palm Desert, Estados Unidos (UDD)",
  "Utica, Estados Unidos (UCA)",
  "Texarkana, Estados Unidos (TXK)",
  "Tyler, Estados Unidos (TYR)",
  "Knoxville, Estados Unidos (TYS)",
  "Tucson, Estados Unidos (TUS)",
  "Twin Falls, Estados Unidos (TWF)",
  "Tupelo, Estados Unidos (TUP)",
  "Traverse City, Estados Unidos (TVC)",
  "Thief River Falls, Estados Unidos (TVF)",
  "Lake Tahoe, Estados Unidos (TVL)",
  "Temple, Estados Unidos (TPL)",
  "Bristol, Estados Unidos (TRI)",
  "Terrell, Estados Unidos (TRL)",
  "Trenton, Estados Unidos (TTN)",
  "Tulsa, Estados Unidos (TUL)",
  "Taos, Estados Unidos (TSM)",
  "Troutdale, Estados Unidos (TTD)",
  "Telluride, Estados Unidos (TEX)",
  "Tuscaloosa, Estados Unidos (TCL)",
  "Ft Leonard Wood, Estados Unidos (TBN)",
  "Tanana, Estados Unidos (TAL)",
  "Syracuse, Estados Unidos (SYR)",
  "Stillwater, Estados Unidos (SWO)",
  "Seward, Estados Unidos (SWD)",
  "Newburgh, Estados Unidos (SWF)",
  "Toledo, Estados Unidos (TOL)",
  "Topeka, Estados Unidos (TOP)",
  "Torrington, Estados Unidos (TOR)",
  "Tampa, Estados Unidos (TPA)",
  "Tifton, Estados Unidos (TMA)",
  "Tulare, Estados Unidos (TLR)",
  "York, Estados Unidos (THV)",
  "Thermopolis, Estados Unidos (THP)",
  "Tok Ak, Estados Unidos (TKJ)",
  "Tacoma, Estados Unidos (TIW)",
  "Titusville, Estados Unidos (TIX)",
  "Tallahassee, Estados Unidos (TLH)",
  "Visalia, Estados Unidos (VIS)",
  "Abingdon, Estados Unidos (VJI)",
  "Vicksburg, Estados Unidos (VKS)",
  "Valdosta, Estados Unidos (VLD)",
  "Vallejo, Estados Unidos (VLO)",
  "Van Horn, Estados Unidos (VHN)",
  "Valdez, Estados Unidos (VDZ)",
  "Vernal, Estados Unidos (VEL)",
  "Vero Beach, Estados Unidos (VRB)",
  "Valparaiso / Ft Walton Beach, Estados Unidos (VPS)",
  "Peru, Estados Unidos (VYS)",
  "Chincoteague, Estados Unidos (WAL)",
  "Washington D. C., Estados Unidos (WAS)",
  "Weatherford, Estados Unidos (WEA)",
  "Boulder, Estados Unidos (WBU)",
  "Enid, Estados Unidos (WDG)",
  "West Yellowstone, Estados Unidos (WYS)",
  "Cape May, Estados Unidos (WWD)",
  "Westerly, Estados Unidos (WST)",
  "Watsonville, Estados Unidos (WVI)",
  "Waterville, Estados Unidos (WVL)",
  "Winnemucca, Estados Unidos (WMC)",
  "Mountain Home, Estados Unidos (WMH)",
  "Wrangell, Estados Unidos (WRG)",
  "Worland, Estados Unidos (WRL)",
  "Winchester, Estados Unidos (WGO)",
  "Lancaster, Estados Unidos (WJF)",
  "Selawik, Estados Unidos (WLK)",
  "Winfield, Estados Unidos (WLD)",
  "Cocoa Beach, Estados Unidos (XMR)",
  "Yakutat, Estados Unidos (YAK)",
  "Yakima, Estados Unidos (YKM)",
  "Yankton, Estados Unidos (YKN)",
  "Yuma, Estados Unidos (YUM)",
  "Zanesville, Estados Unidos (ZZV)",
  "Youngstown, Estados Unidos (YNG)",
  "Cambridge, Estados Unidos (JHY)",
  "San Marcos, Estados Unidos (SMT)",
  "Schaumburg, Estados Unidos (JMH)",
  "Ciudad de Panamá, Estados Unidos (ECP)",
  "Covington Louisiana, Estados Unidos (C33)",
  "Cross City, Estados Unidos (CTY)",
  "Estherville, Estados Unidos (EST)",
  "Hoover, Estados Unidos (BIR)",
  "Lewisville, Estados Unidos (LE1)",
  "Bay Lake, Estados Unidos (BA9)",
  "Cape Canaveral, Estados Unidos (CC2)",
  "Santa Clara, Estados Unidos (ZSM)",
  "Boca Raton Airport, Estados Unidos (BCT)",
  "Salto, Uruguay (STY)",
  "Colonia del Sacramento, Uruguay (CYR)",
  "Punta Del Este, Uruguay (PDP)",
  "Montevideo, Uruguay (MVD)",
  "Bukhara, Uzbekistan Sum (BHK)",
  "Samarkand, Uzbekistan Sum (SKD)",
  "Tashkent, Uzbekistan Sum (TAS)",
  "Urgench, Uzbekistan Sum (UGC)",
  "Union Island, San Vicente (UNI)",
  "St Vincent, San Vicente (SVD)",
  "San Antonio, Venezuela (SVZ)",
  "Santo Domingo, Venezuela (STD)",
  "Santa Barbara, Venezuela (STB)",
  "San Felipe, Venezuela (SNF)",
  "San Tome, Venezuela (SOM)",
  "San Felix, Venezuela (SFX)",
  "San Fernando, Venezuela (SFD)",
  "San Crystobal, Venezuela (SCI)",
  "El Vigia, Venezuela (VIG)",
  "Valera, Venezuela (VLV)",
  "Valencia, Venezuela (VLN)",
  "Isla Margarita, Venezuela (AR3)",
  "Caracas, Venezuela (CCS)",
  "Ciudad Bolivar, Venezuela (CBL)",
  "Cabimas, Venezuela (CBS)",
  "Barquisimeto, Venezuela (BRM)",
  "Barinas, Venezuela (BNS)",
  "Barcelona, Venezuela (BLA)",
  "Coro, Venezuela (CZE)",
  "Maturin, Venezuela (MUN)",
  "Maracay, Venezuela (MYC)",
  "Merida, Venezuela (MRD)",
  "Porlamar, Venezuela (PMV)",
  "Puerto Ordaz, Venezuela (PZO)",
  "Puerto Ayacucho, Venezuela (PYH)",
  "La Fria, Venezuela (LFR)",
  "Las Piedras, Venezuela (LSP)",
  "Maracaibo, Venezuela (MAR)",
  "Beef Island, Islas Vírgenes (EIS)",
  "Virgin Gorda, Islas Vírgenes (VIJ)",
  "Tortola Westend, Islas Vírgenes (TOV)",
  "Ho Chi Minh, Vietnam (SGN)",
  "Da Nang, Vietnam (DAD)",
  "Dalat, Vietnam (DLI)",
  "Handi, Vietnam (HAN)",
  "Hu PG, Vietnam (HUI)",
  "Haiphong, Vietnam (HPH)",
  "Phan Thiet, Vietnam (PHH)",
  "Nha Trang, Vietnam (NHA)",
  "Espiritu Santo, Vanuatu (SON)",
  "Port Vila, Vanuatu (VLI)",
  "Maota, Samoa del oeste (MXS)",
  "Apia, Samoa del oeste (APW)",
  "Aden, Yemen (ADE)",
  "Sana, Yemen (SAH)",
  "Dzaoudzi, Mayotte (DZA)",
  "Belgrado, Serbia (BEG)",
  "Pristina, Serbia (PRN)",
  "Nis Yu, Serbia (INI)",
  "Tivat, Serbia (TIV)",
  "Podgorica, Serbia (TGD)",
  "Thaba Nchu, South Africa (TCU)",
  "Skukuza, South Africa (SZK)",
  "Umtata, South Africa (UTT)",
  "Queenstown, South Africa (UTW)",
  "Upington, South Africa (UTN)",
  "Springbok, South Africa (SBU)",
  "Saldanha Bay, South Africa (SDB)",
  "Vryheid, South Africa (VYD)",
  "Welkom, South Africa (WEL)",
  "Secunda, South Africa (ZEC)",
  "Johannesburgo, South Africa (JNB)",
  "Ladysmith, South Africa (LAY)",
  "Kimberley, South Africa (KIM)",
  "Mmabatho, South Africa (MBD)",
  "Mannheim, South Africa (MGH)",
  "Tzaneen, South Africa (LTA)",
  "Malelane, South Africa (LLE)",
  "Pretoria, South Africa (PRY)",
  "Pietersburg, South Africa (PTG)",
  "Pietermaritzburg, South Africa (PZB)",
  "Richards Bay, South Africa (RCB)",
  "Phalaborwa, South Africa (PHW)",
  "Plettenberg Bay, South Africa (PBZ)",
  "Port Elizabeth, South Africa (PLZ)",
  "Newcastle, South Africa (NCS)",
  "Nelspruit, South Africa (NLP)",
  "Sun City, South Africa (NTY)",
  "Oudtshoorn, South Africa (OUH)",
  "Bloemfontein, South Africa (BFN)",
  "Bisho, South Africa (BIY)",
  "Alexander Bay, South Africa (ALJ)",
  "Durban, South Africa (DUR)",
  "East London, South Africa (ELS)",
  "Ficksburg, South Africa (FCB)",
  "Ciudad Del Cabo, South Africa (CPT)",
  "Harrismith, South Africa (HRS)",
  "Hluhluwe, South Africa (HLW)",
  "Lanseria, South Africa (HLA)",
  "Hoedspruit, South Africa (HDS)",
  "George, South Africa (GRJ)",
  "N Dola, Zambia (NLA)",
  "Lusaka, Zambia (LUN)",
  "Livingstone, Zambia (LVI)",
  "Mahenye, Zimbabwe (MJW)",
  "Kariba Dam, Zimbabwe (KAB)",
  "Hwange, Zimbabwe (HWN)",
  "Masvingo, Zimbabwe (MVZ)",
  "Gweru, Zimbabwe (GWE)",
  "Harare, Zimbabwe (HRE)",
  "Bulawayo, Zimbabwe (BUQ)",
  "Bumi Hills, Zimbabwe (BZH)",
  "Cataratas Victoria, Zimbabwe (VFA)",
  "Mutare, Zimbabwe (UTA)",
  "San Juan, Puerto Rico (SJU)",
  "Ponce, Puerto Rico (PSE)",
  "Posadas, Argentina (PSS)",
  "Trelew, Argentina (REL)",
  "Resistencia, Argentina (RES)",
  "Rio Gallegos, Argentina (RGL)",
  "Rio Grande, Argentina (RGA)",
  "Puerto Madryn, Argentina (PMY)",
  "Neuquen, Argentina (NQN)",
  "Iguazu, Argentina (IGR)",
  "La Rioja, Argentina (IRJ)",
  "Jujuy, Argentina (JUJ)",
  "Mar del Plata, Argentina (MDQ)",
  "Mendoza, Argentina (MDZ)",
  "San Luis, Argentina (LUQ)",
  "Malargue, Argentina (LGS)",
  "Buenos Aires, Argentina (BUE)",
  "Bariloche, Argentina (BRC)",
  "Córdoba, Argentina (COR)",
  "San Martin Andes, Argentina (CPC)",
  "Corrientes, Argentina (CNQ)",
  "San Rafael, Argentina (AFA)",
  "Bahia Blanca, Argentina (BHI)",
  "Calafate, Argentina (FTE)",
  "Formosa, Argentina (FMA)",
  "Comodoro Rivadavia, Argentina (CRD)",
  "Catamarca, Argentina (CTC)",
  "Esquel, Argentina (EQS)",
  "Salta, Argentina (SLA)",
  "Santiago del Estero, Argentina (SDE)",
  "Santa Fe, Argentina (SFN)",
  "Santa Rosa, Argentina (RSA)",
  "Rosario, Argentina (ROS)",
  "Viedma, Argentina (VDM)",
  "Ushuaia, Argentina (USH)",
  "Tucuman, Argentina (TUC)",
  "San Juan, Argentina (UAQ)",
  "Villa la Angostura, Argentina (VLA)",
  "Termas de Rio Hondo, Argentina (RHD)",
  "Rio Cuarto, Argentina (RCU)",
  "Villa Mercedes, Argentina (VME)",
  "Villa Gesell, Argentina (VGL)",
  "Paraná, Argentina (PRA)",
  "Alta Gracia, Argentina (AR_001)",
  "Arroyito, Argentina (AR_002)",
  "Capilla del Monte, Argentina (AR_003)",
  "Colonia Caroya, Argentina (AR_004)",
  "Cosquin, Argentina (AR_005)",
  "Cruz del Eje, Argentina (AR_006)",
  "Dean Funes, Argentina (AR_007)",
  "Devoto, Argentina (AR_008)",
  "General Cabrera, Argentina (AR_009)",
  "Hernando, Argentina (AR_010)",
  "Inriville, Argentina (AR_011)",
  "Isla Verde, Argentina (AR_012)",
  "Jesus María, Argentina (AR_013)",
  "La Carlota, Argentina (AR_014)",
  "La Falda, Argentina (AR_015)",
  "Las Perdices, Argentina (AR_016)",
  "Las Varillas, Argentina (AR_017)",
  "Luque, Argentina (AR_018)",
  "Marcos Juarez, Argentina (AR_019)",
  "Mina Clavero, Argentina (AR_020)",
  "Monte Maíz, Argentina (AR_021)",
  "Morteros, Argentina (AR_022)",
  "Oliva, Argentina (AR_023)",
  "Oncativo, Argentina (AR_024)",
  "Pilar, Argentina (AR_025)",
  "Río Ceballos, Argentina (AR_026)",
  "Río Segundo, Argentina (AR_027)",
  "Río Tercero, Argentina (AR_028)",
  "Sampacho, Argentina (AR_029)",
  "San Francisco , Argentina (AR_030)",
  "Santa Rosa de Calamuchita, Argentina (AR_031)",
  "Unquillo, Argentina (AR_032)",
  "Valle Hermoso, Argentina (AR_033)",
  "Villa Allende, Argentina (AR_034)",
  "Villa Ascasubi, Argentina (AR_035)",
  "Villa Carlos Paz, Argentina (AR_036)",
  "Villa Dolores, Argentina (VDR)",
  "Villa General Belgrano, Argentina (AR_037)",
  "Villa Giardino, Argentina (AR_038)",
  "Villa María, Argentina (AR_039)",
  "Rafaela, Argentina (RAF)",
  "San Jorge, Argentina (AR_040)",
  "Sunchales, Argentina (NCJ)",
  "Chilecito, Argentina (AR_041)",
  "Bell Ville, Argentina (11A)",
  "Bolivar, Argentina (12A)",
  "Balnearia, Argentina (10A)",
  "Arguello, Argentina (07A)",
  "Arroyito, Argentina (08A)",
  "Avellaneda, Argentina (09A)",
  "Cafayate, Argentina (9A4)",
  "Canada De Gomez, Argentina (15A)",
  "Caleta Olivia, Argentina (14A)",
  "Chaco, Argentina (19A)",
  "Chacras De Coria, Argentina (20A)",
  "Chilecito, Argentina (02A)",
  "Castelar, Argentina (18A)",
  "Adrogue, Argentina (03A)",
  "Allen, Argentina (04A)",
  "Almafuerte, Argentina (05A)",
  "Alta Gracia, Argentina (06A)",
  "Las Heras, Argentina (46A)",
  "Las Leñas, Argentina (LL9)",
  "Lanus Oeste, Argentina (45A)",
  "Laboulaye, Argentina (44A)",
  "Lomas De Zamora, Argentina (47A)",
  "Lujan, Argentina (48A)",
  "Lujan De Cuyo, Argentina (49A)",
  "Mar De Ajo, Argentina (50A)",
  "Juan Jose Castelli, Argentina (39A)",
  "Junin De Los Andes, Argentina (40A)",
  "La Cumbre, Argentina (41A)",
  "La Plata, Argentina (LPG)",
  "La Tablada, Argentina (43A)",
  "Paso De Los Libres, Argentina (59A)",
  "Olavarria, Argentina (57A)",
  "Olivos, Argentina (58A)",
  "Pergamino, Argentina (60A)",
  "Perico, Argentina (61A)",
  "Plaza Grand Bourg-Palermo, Argentina (CAB)",
  "Plottier, Argentina (62A)",
  "Necochea, Argentina (55A)",
  "Neuquén, Argentina (56A)",
  "Mendiolaza, Argentina (52A)",
  "Merlo, Argentina (RLO)",
  "Monteros, Argentina (AR_40)",
  "Moron, Argentina (53A)",
  "Morteros, Argentina (54A)",
  "Huinca Renanco, Argentina (38A)",
  "Haedo, Argentina (37A)",
  "Gualeguaychu, Argentina (GHU)",
  "Guaymallen, Argentina (36A)",
  "Florida, Argentina (30A)",
  "Funes, Argentina (31A)",
  "General Roca, Argentina (32A)",
  "Gral Rodriguez, Argentina (35A)",
  "Gobernador Crespo, Argentina (33A)",
  "Godoy Cruz, Argentina (34A)",
  "Coronel Pringles, Argentina (25A)",
  "Concordia, Argentina (24A)",
  "ChosMalal, Argentina (21A)",
  "Cinco Saltos, Argentina (22A)",
  "Cipolletti, Argentina (23A)",
  "CutralCo, Argentina (26A)",
  "El Chaltén, Argentina (99A)",
  "Esperanza, Argentina (29A)",
  "ElBolson, Argentina (27A)",
  "Eldorado, Argentina (28A)",
  "SantiagoTemple, Argentina (81A)",
  "SanGuillermo, Argentina (72A)",
  "San Salvador, Argentina (78A)",
  "San Vicente, Argentina (80A)",
  "San Fernando Del Valle, Argentina (71A)",
  "San Jeronimo Norte, Argentina (73A)",
  "San Jorge, Argentina (01A)",
  "San Jose De Metan, Argentina (74A)",
  "San Martin, Argentina (SM1)",
  "San Miguel de Tucumán, Argentina (97A)",
  "San Nicolas, Argentina (77A)",
  "Puerto San Julian, Argentina (63A)",
  "Roque Saenz Pena, Argentina (70A)",
  "Rivadavia, Argentina (69A)",
  "Purmamarca, Argentina (95A)",
  "Quilmes, Argentina (64A)",
  "Ramos Mejia, Argentina (65A)",
  "Reconquista, Argentina (66A)",
  "Rio Primero, Argentina (68A)",
  "Tafi del Valle, Argentina (98A)",
  "Tandil, Argentina (83A)",
  "Tartagal, Argentina (AR_39)",
  "Tunuyan, Argentina (86A)",
  "Tres Arroyos, Argentina (85A)",
  "Tilcara, Argentina (96A)",
  "Yerba Buena, Argentina (92A)",
  "Villa Constitucion, Argentina (89A)",
  "Villa Cura Brochero, Argentina (90A)",
  "Villa Maria, Argentina (91A)",
  "Venado Tuerto, Argentina (87A)",
  "Villa Adelina, Argentina (88A)",
  "Zarate, Argentina (93A)",
  "Aruba, Aruba (AUA)"
];